export default [
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {
    "icm": [
      [
        [
          0.5019999742507935,
          0.4860000014305115
        ],
        [
          0.4620000123977661,
          0.5040000081062317
        ],
        [
          0.40400001406669617,
          0.5040000081062317
        ],
        [
          0.4000000059604645,
          0.5080000162124634
        ],
        [
          0.38199999928474426,
          0.5099999904632568
        ],
        [
          0.36800000071525574,
          0.5239999890327454
        ],
        [
          0.3440000116825104,
          0.5759999752044678
        ],
        [
          0.34200000762939453,
          0.5899999737739563
        ],
        [
          0.3440000116825104,
          0.6679999828338623
        ],
        [
          0.3659999966621399,
          0.7020000219345093
        ],
        [
          0.38600000739097595,
          0.7139999866485596
        ],
        [
          0.3880000114440918,
          0.7179999947547913
        ],
        [
          0.40799999237060547,
          0.7239999771118164
        ],
        [
          0.4099999964237213,
          0.7279999852180481
        ],
        [
          0.41999998688697815,
          0.7319999933242798
        ],
        [
          0.44999998807907104,
          0.7379999756813049
        ],
        [
          0.4860000014305115,
          0.7379999756813049
        ],
        [
          0.5180000066757202,
          0.7300000190734863
        ],
        [
          0.5239999890327454,
          0.7239999771118164
        ],
        [
          0.550000011920929,
          0.7120000123977661
        ],
        [
          0.5659999847412109,
          0.6959999799728394
        ],
        [
          0.5740000009536743,
          0.6919999718666077
        ],
        [
          0.5820000171661377,
          0.6819999814033508
        ],
        [
          0.5920000076293945,
          0.6600000262260437
        ],
        [
          0.5920000076293945,
          0.6340000033378601
        ],
        [
          0.5879999995231628,
          0.6200000047683716
        ],
        [
          0.5839999914169312,
          0.5640000104904175
        ],
        [
          0.5740000009536743,
          0.550000011920929
        ],
        [
          0.5699999928474426,
          0.5239999890327454
        ],
        [
          0.5600000023841858,
          0.5040000081062317
        ],
        [
          0.5460000038146973,
          0.492000013589859
        ],
        [
          0.5299999713897705,
          0.4860000014305115
        ],
        [
          0.5019999742507935,
          0.4860000014305115
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5040000081062317,
          0.49000000953674316
        ],
        [
          0.49399998784065247,
          0.492000013589859
        ],
        [
          0.49000000953674316,
          0.49799999594688416
        ],
        [
          0.45399999618530273,
          0.5120000243186951
        ],
        [
          0.4359999895095825,
          0.5120000243186951
        ],
        [
          0.42399999499320984,
          0.5080000162124634
        ],
        [
          0.3880000114440918,
          0.5080000162124634
        ],
        [
          0.3720000088214874,
          0.5199999809265137
        ],
        [
          0.36399999260902405,
          0.5339999794960022
        ],
        [
          0.3440000116825104,
          0.5820000171661377
        ],
        [
          0.34200000762939453,
          0.6100000143051147
        ],
        [
          0.3440000116825104,
          0.6660000085830688
        ],
        [
          0.3619999885559082,
          0.6959999799728394
        ],
        [
          0.3840000033378601,
          0.7139999866485596
        ],
        [
          0.4339999854564667,
          0.7300000190734863
        ],
        [
          0.4740000069141388,
          0.7319999933242798
        ],
        [
          0.5260000228881836,
          0.7239999771118164
        ],
        [
          0.5419999957084656,
          0.7160000205039978
        ],
        [
          0.5479999780654907,
          0.7059999704360962
        ],
        [
          0.5619999766349792,
          0.671999990940094
        ],
        [
          0.5759999752044678,
          0.6499999761581421
        ],
        [
          0.5720000267028809,
          0.6100000143051147
        ],
        [
          0.5799999833106995,
          0.5799999833106995
        ],
        [
          0.578000009059906,
          0.5600000023841858
        ],
        [
          0.5740000009536743,
          0.5540000200271606
        ],
        [
          0.5659999847412109,
          0.5139999985694885
        ],
        [
          0.5600000023841858,
          0.5059999823570251
        ],
        [
          0.5460000038146973,
          0.49399998784065247
        ],
        [
          0.5360000133514404,
          0.49000000953674316
        ],
        [
          0.5040000081062317,
          0.49000000953674316
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5,
          0.492000013589859
        ],
        [
          0.47999998927116394,
          0.5
        ],
        [
          0.46799999475479126,
          0.5120000243186951
        ],
        [
          0.4580000042915344,
          0.5139999985694885
        ],
        [
          0.4560000002384186,
          0.5180000066757202
        ],
        [
          0.4440000057220459,
          0.5220000147819519
        ],
        [
          0.42399999499320984,
          0.5180000066757202
        ],
        [
          0.421999990940094,
          0.5139999985694885
        ],
        [
          0.4020000100135803,
          0.5139999985694885
        ],
        [
          0.39800000190734863,
          0.5180000066757202
        ],
        [
          0.38600000739097595,
          0.5180000066757202
        ],
        [
          0.3720000088214874,
          0.5260000228881836
        ],
        [
          0.36000001430511475,
          0.5419999957084656
        ],
        [
          0.34200000762939453,
          0.5820000171661377
        ],
        [
          0.34200000762939453,
          0.6660000085830688
        ],
        [
          0.34599998593330383,
          0.6800000071525574
        ],
        [
          0.3580000102519989,
          0.6980000138282776
        ],
        [
          0.37400001287460327,
          0.7120000123977661
        ],
        [
          0.4020000100135803,
          0.722000002861023
        ],
        [
          0.40400001406669617,
          0.7260000109672546
        ],
        [
          0.4399999976158142,
          0.734000027179718
        ],
        [
          0.4699999988079071,
          0.734000027179718
        ],
        [
          0.5120000243186951,
          0.7260000109672546
        ],
        [
          0.5139999985694885,
          0.722000002861023
        ],
        [
          0.5339999794960022,
          0.7160000205039978
        ],
        [
          0.5460000038146973,
          0.7059999704360962
        ],
        [
          0.5519999861717224,
          0.6959999799728394
        ],
        [
          0.5559999942779541,
          0.6800000071525574
        ],
        [
          0.5860000252723694,
          0.6480000019073486
        ],
        [
          0.5899999737739563,
          0.6380000114440918
        ],
        [
          0.5899999737739563,
          0.6159999966621399
        ],
        [
          0.6060000061988831,
          0.5839999914169312
        ],
        [
          0.6060000061988831,
          0.5519999861717224
        ],
        [
          0.6000000238418579,
          0.5360000133514404
        ],
        [
          0.593999981880188,
          0.5260000228881836
        ],
        [
          0.5699999928474426,
          0.5080000162124634
        ],
        [
          0.5440000295639038,
          0.4959999918937683
        ],
        [
          0.5320000052452087,
          0.492000013589859
        ],
        [
          0.5,
          0.492000013589859
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5180000066757202,
          0.49399998784065247
        ],
        [
          0.5120000243186951,
          0.5
        ],
        [
          0.5,
          0.5019999742507935
        ],
        [
          0.49399998784065247,
          0.5080000162124634
        ],
        [
          0.4659999907016754,
          0.5139999985694885
        ],
        [
          0.42399999499320984,
          0.5080000162124634
        ],
        [
          0.3880000114440918,
          0.5099999904632568
        ],
        [
          0.37599998712539673,
          0.515999972820282
        ],
        [
          0.36399999260902405,
          0.5299999713897705
        ],
        [
          0.35600000619888306,
          0.5479999780654907
        ],
        [
          0.35199999809265137,
          0.550000011920929
        ],
        [
          0.3440000116825104,
          0.5740000009536743
        ],
        [
          0.3440000116825104,
          0.6639999747276306
        ],
        [
          0.3479999899864197,
          0.6759999990463257
        ],
        [
          0.35600000619888306,
          0.6819999814033508
        ],
        [
          0.3619999885559082,
          0.6940000057220459
        ],
        [
          0.3880000114440918,
          0.7160000205039978
        ],
        [
          0.4180000126361847,
          0.7260000109672546
        ],
        [
          0.4620000123977661,
          0.7260000109672546
        ],
        [
          0.5099999904632568,
          0.7160000205039978
        ],
        [
          0.5220000147819519,
          0.7059999704360962
        ],
        [
          0.5299999713897705,
          0.7039999961853027
        ],
        [
          0.5519999861717224,
          0.6779999732971191
        ],
        [
          0.5699999928474426,
          0.6639999747276306
        ],
        [
          0.5879999995231628,
          0.6439999938011169
        ],
        [
          0.6019999980926514,
          0.5879999995231628
        ],
        [
          0.6039999723434448,
          0.5720000267028809
        ],
        [
          0.6000000238418579,
          0.550000011920929
        ],
        [
          0.5860000252723694,
          0.5239999890327454
        ],
        [
          0.5699999928474426,
          0.5099999904632568
        ],
        [
          0.5559999942779541,
          0.5040000081062317
        ],
        [
          0.5479999780654907,
          0.4959999918937683
        ],
        [
          0.5180000066757202,
          0.49399998784065247
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5139999985694885,
          0.49399998784065247
        ],
        [
          0.49399998784065247,
          0.5
        ],
        [
          0.48399999737739563,
          0.5080000162124634
        ],
        [
          0.47200000286102295,
          0.5099999904632568
        ],
        [
          0.44999998807907104,
          0.5059999823570251
        ],
        [
          0.4000000059604645,
          0.5059999823570251
        ],
        [
          0.38199999928474426,
          0.5099999904632568
        ],
        [
          0.3720000088214874,
          0.5139999985694885
        ],
        [
          0.36800000071525574,
          0.5239999890327454
        ],
        [
          0.3619999885559082,
          0.527999997138977
        ],
        [
          0.3499999940395355,
          0.5580000281333923
        ],
        [
          0.33799999952316284,
          0.6060000061988831
        ],
        [
          0.33799999952316284,
          0.6499999761581421
        ],
        [
          0.3499999940395355,
          0.6800000071525574
        ],
        [
          0.3720000088214874,
          0.7059999704360962
        ],
        [
          0.3880000114440918,
          0.7179999947547913
        ],
        [
          0.4000000059604645,
          0.7200000286102295
        ],
        [
          0.4000000059604645,
          0.7239999771118164
        ],
        [
          0.4399999976158142,
          0.7239999771118164
        ],
        [
          0.44200000166893005,
          0.7200000286102295
        ],
        [
          0.5,
          0.7139999866485596
        ],
        [
          0.527999997138977,
          0.7020000219345093
        ],
        [
          0.5419999957084656,
          0.6859999895095825
        ],
        [
          0.5479999780654907,
          0.6679999828338623
        ],
        [
          0.5600000023841858,
          0.6499999761581421
        ],
        [
          0.5619999766349792,
          0.6359999775886536
        ],
        [
          0.5580000281333923,
          0.6240000128746033
        ],
        [
          0.5540000200271606,
          0.5759999752044678
        ],
        [
          0.5600000023841858,
          0.5640000104904175
        ],
        [
          0.5720000267028809,
          0.5659999847412109
        ],
        [
          0.578000009059906,
          0.5600000023841858
        ],
        [
          0.578000009059906,
          0.5260000228881836
        ],
        [
          0.5680000185966492,
          0.5139999985694885
        ],
        [
          0.5440000295639038,
          0.49799999594688416
        ],
        [
          0.5139999985694885,
          0.49399998784065247
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4959999918937683,
          0.49399998784065247
        ],
        [
          0.49399998784065247,
          0.49799999594688416
        ],
        [
          0.47999998927116394,
          0.49799999594688416
        ],
        [
          0.4699999988079071,
          0.5040000081062317
        ],
        [
          0.3880000114440918,
          0.5139999985694885
        ],
        [
          0.3659999966621399,
          0.5400000214576721
        ],
        [
          0.35199999809265137,
          0.5960000157356262
        ],
        [
          0.3580000102519989,
          0.6460000276565552
        ],
        [
          0.3619999885559082,
          0.6620000004768372
        ],
        [
          0.3779999911785126,
          0.6819999814033508
        ],
        [
          0.3880000114440918,
          0.7080000042915344
        ],
        [
          0.3959999978542328,
          0.7179999947547913
        ],
        [
          0.41200000047683716,
          0.7260000109672546
        ],
        [
          0.4320000112056732,
          0.7300000190734863
        ],
        [
          0.515999972820282,
          0.7279999852180481
        ],
        [
          0.5360000133514404,
          0.7179999947547913
        ],
        [
          0.5460000038146973,
          0.6959999799728394
        ],
        [
          0.550000011920929,
          0.6940000057220459
        ],
        [
          0.5519999861717224,
          0.6620000004768372
        ],
        [
          0.550000011920929,
          0.6480000019073486
        ],
        [
          0.5460000038146973,
          0.6460000276565552
        ],
        [
          0.5460000038146973,
          0.6159999966621399
        ],
        [
          0.550000011920929,
          0.6140000224113464
        ],
        [
          0.5540000200271606,
          0.5680000185966492
        ],
        [
          0.550000011920929,
          0.5580000281333923
        ],
        [
          0.550000011920929,
          0.5320000052452087
        ],
        [
          0.5559999942779541,
          0.5260000228881836
        ],
        [
          0.5619999766349792,
          0.5260000228881836
        ],
        [
          0.5640000104904175,
          0.5180000066757202
        ],
        [
          0.5540000200271606,
          0.5040000081062317
        ],
        [
          0.5400000214576721,
          0.49799999594688416
        ],
        [
          0.5239999890327454,
          0.49799999594688416
        ],
        [
          0.5220000147819519,
          0.49399998784065247
        ],
        [
          0.4959999918937683,
          0.49399998784065247
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4959999918937683,
          0.4860000014305115
        ],
        [
          0.4860000014305115,
          0.4880000054836273
        ],
        [
          0.4740000069141388,
          0.49399998784065247
        ],
        [
          0.47200000286102295,
          0.49799999594688416
        ],
        [
          0.4480000138282776,
          0.5080000162124634
        ],
        [
          0.3880000114440918,
          0.5099999904632568
        ],
        [
          0.37400001287460327,
          0.5180000066757202
        ],
        [
          0.3580000102519989,
          0.5519999861717224
        ],
        [
          0.3580000102519989,
          0.6019999980926514
        ],
        [
          0.36800000071525574,
          0.6200000047683716
        ],
        [
          0.3779999911785126,
          0.628000020980835
        ],
        [
          0.3779999911785126,
          0.6340000033378601
        ],
        [
          0.38600000739097595,
          0.6499999761581421
        ],
        [
          0.38999998569488525,
          0.7139999866485596
        ],
        [
          0.40799999237060547,
          0.7279999852180481
        ],
        [
          0.4180000126361847,
          0.7319999933242798
        ],
        [
          0.515999972820282,
          0.7260000109672546
        ],
        [
          0.5419999957084656,
          0.7160000205039978
        ],
        [
          0.5979999899864197,
          0.6499999761581421
        ],
        [
          0.6000000238418579,
          0.628000020980835
        ],
        [
          0.5899999737739563,
          0.6079999804496765
        ],
        [
          0.5860000252723694,
          0.5899999737739563
        ],
        [
          0.5820000171661377,
          0.5879999995231628
        ],
        [
          0.5860000252723694,
          0.5839999914169312
        ],
        [
          0.5860000252723694,
          0.5699999928474426
        ],
        [
          0.5920000076293945,
          0.5479999780654907
        ],
        [
          0.5860000252723694,
          0.5220000147819519
        ],
        [
          0.5400000214576721,
          0.4880000054836273
        ],
        [
          0.4959999918937683,
          0.4860000014305115
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4740000069141388,
          0.48399999737739563
        ],
        [
          0.44999998807907104,
          0.49399998784065247
        ],
        [
          0.4440000057220459,
          0.5019999742507935
        ],
        [
          0.4259999990463257,
          0.5120000243186951
        ],
        [
          0.37599998712539673,
          0.515999972820282
        ],
        [
          0.35600000619888306,
          0.5379999876022339
        ],
        [
          0.3580000102519989,
          0.6140000224113464
        ],
        [
          0.3720000088214874,
          0.628000020980835
        ],
        [
          0.38199999928474426,
          0.656000018119812
        ],
        [
          0.38600000739097595,
          0.6779999732971191
        ],
        [
          0.3840000033378601,
          0.7039999961853027
        ],
        [
          0.3880000114440918,
          0.7160000205039978
        ],
        [
          0.39800000190734863,
          0.7260000109672546
        ],
        [
          0.4099999964237213,
          0.7319999933242798
        ],
        [
          0.45399999618530273,
          0.7319999933242798
        ],
        [
          0.5220000147819519,
          0.7179999947547913
        ],
        [
          0.5479999780654907,
          0.699999988079071
        ],
        [
          0.5699999928474426,
          0.6779999732971191
        ],
        [
          0.5920000076293945,
          0.6639999747276306
        ],
        [
          0.5960000157356262,
          0.656000018119812
        ],
        [
          0.6039999723434448,
          0.6499999761581421
        ],
        [
          0.6060000061988831,
          0.628000020980835
        ],
        [
          0.5820000171661377,
          0.5839999914169312
        ],
        [
          0.5839999914169312,
          0.5299999713897705
        ],
        [
          0.5759999752044678,
          0.5139999985694885
        ],
        [
          0.5559999942779541,
          0.4959999918937683
        ],
        [
          0.5339999794960022,
          0.4860000014305115
        ],
        [
          0.4740000069141388,
          0.48399999737739563
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.46000000834465027,
          0.48399999737739563
        ],
        [
          0.43799999356269836,
          0.49399998784065247
        ],
        [
          0.42800000309944153,
          0.5080000162124634
        ],
        [
          0.41999998688697815,
          0.5120000243186951
        ],
        [
          0.37400001287460327,
          0.515999972820282
        ],
        [
          0.3619999885559082,
          0.527999997138977
        ],
        [
          0.36000001430511475,
          0.5580000281333923
        ],
        [
          0.36399999260902405,
          0.593999981880188
        ],
        [
          0.37400001287460327,
          0.6119999885559082
        ],
        [
          0.3799999952316284,
          0.6359999775886536
        ],
        [
          0.38600000739097595,
          0.6420000195503235
        ],
        [
          0.38600000739097595,
          0.6499999761581421
        ],
        [
          0.3959999978542328,
          0.671999990940094
        ],
        [
          0.4000000059604645,
          0.6919999718666077
        ],
        [
          0.40799999237060547,
          0.7020000219345093
        ],
        [
          0.4099999964237213,
          0.7139999866485596
        ],
        [
          0.4180000126361847,
          0.722000002861023
        ],
        [
          0.4860000014305115,
          0.7200000286102295
        ],
        [
          0.5299999713897705,
          0.7080000042915344
        ],
        [
          0.5680000185966492,
          0.671999990940094
        ],
        [
          0.5879999995231628,
          0.6620000004768372
        ],
        [
          0.6000000238418579,
          0.6520000100135803
        ],
        [
          0.6039999723434448,
          0.6439999938011169
        ],
        [
          0.6019999980926514,
          0.6159999966621399
        ],
        [
          0.5839999914169312,
          0.5740000009536743
        ],
        [
          0.5820000171661377,
          0.527999997138977
        ],
        [
          0.5759999752044678,
          0.515999972820282
        ],
        [
          0.5580000281333923,
          0.5
        ],
        [
          0.527999997138977,
          0.4880000054836273
        ],
        [
          0.4959999918937683,
          0.48399999737739563
        ],
        [
          0.46000000834465027,
          0.48399999737739563
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.46799999475479126,
          0.48399999737739563
        ],
        [
          0.4480000138282776,
          0.49000000953674316
        ],
        [
          0.41200000047683716,
          0.5220000147819519
        ],
        [
          0.37599998712539673,
          0.5220000147819519
        ],
        [
          0.3659999966621399,
          0.527999997138977
        ],
        [
          0.36399999260902405,
          0.5379999876022339
        ],
        [
          0.3659999966621399,
          0.5839999914169312
        ],
        [
          0.3799999952316284,
          0.6039999723434448
        ],
        [
          0.3799999952316284,
          0.6480000019073486
        ],
        [
          0.3880000114440918,
          0.6639999747276306
        ],
        [
          0.38999998569488525,
          0.6759999990463257
        ],
        [
          0.4020000100135803,
          0.6880000233650208
        ],
        [
          0.40400001406669617,
          0.7020000219345093
        ],
        [
          0.40799999237060547,
          0.7039999961853027
        ],
        [
          0.40799999237060547,
          0.7120000123977661
        ],
        [
          0.41200000047683716,
          0.7179999947547913
        ],
        [
          0.46399998664855957,
          0.7200000286102295
        ],
        [
          0.49799999594688416,
          0.7099999785423279
        ],
        [
          0.5199999809265137,
          0.6980000138282776
        ],
        [
          0.5260000228881836,
          0.6880000233650208
        ],
        [
          0.5540000200271606,
          0.671999990940094
        ],
        [
          0.5559999942779541,
          0.6679999828338623
        ],
        [
          0.5720000267028809,
          0.6639999747276306
        ],
        [
          0.5820000171661377,
          0.656000018119812
        ],
        [
          0.5920000076293945,
          0.6539999842643738
        ],
        [
          0.6019999980926514,
          0.6340000033378601
        ],
        [
          0.6000000238418579,
          0.6140000224113464
        ],
        [
          0.5899999737739563,
          0.5920000076293945
        ],
        [
          0.5820000171661377,
          0.5839999914169312
        ],
        [
          0.5699999928474426,
          0.5540000200271606
        ],
        [
          0.5440000295639038,
          0.5199999809265137
        ],
        [
          0.5440000295639038,
          0.5139999985694885
        ],
        [
          0.5180000066757202,
          0.49000000953674316
        ],
        [
          0.46799999475479126,
          0.48399999737739563
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.45399999618530273,
          0.49000000953674316
        ],
        [
          0.44999998807907104,
          0.4959999918937683
        ],
        [
          0.44600000977516174,
          0.4959999918937683
        ],
        [
          0.41999998688697815,
          0.5139999985694885
        ],
        [
          0.4020000100135803,
          0.5320000052452087
        ],
        [
          0.4020000100135803,
          0.5979999899864197
        ],
        [
          0.39800000190734863,
          0.6039999723434448
        ],
        [
          0.3959999978542328,
          0.6200000047683716
        ],
        [
          0.3959999978542328,
          0.656000018119812
        ],
        [
          0.4020000100135803,
          0.6740000247955322
        ],
        [
          0.4099999964237213,
          0.6819999814033508
        ],
        [
          0.4339999854564667,
          0.6919999718666077
        ],
        [
          0.4399999976158142,
          0.699999988079071
        ],
        [
          0.4560000002384186,
          0.7080000042915344
        ],
        [
          0.49000000953674316,
          0.7099999785423279
        ],
        [
          0.5180000066757202,
          0.699999988079071
        ],
        [
          0.5339999794960022,
          0.6840000152587891
        ],
        [
          0.5440000295639038,
          0.6759999990463257
        ],
        [
          0.5559999942779541,
          0.671999990940094
        ],
        [
          0.5580000281333923,
          0.6679999828338623
        ],
        [
          0.578000009059906,
          0.6639999747276306
        ],
        [
          0.5879999995231628,
          0.656000018119812
        ],
        [
          0.6079999804496765,
          0.6480000019073486
        ],
        [
          0.6159999966621399,
          0.6380000114440918
        ],
        [
          0.6179999709129333,
          0.6159999966621399
        ],
        [
          0.6039999723434448,
          0.5860000252723694
        ],
        [
          0.5860000252723694,
          0.5740000009536743
        ],
        [
          0.5839999914169312,
          0.5559999942779541
        ],
        [
          0.5759999752044678,
          0.5440000295639038
        ],
        [
          0.5600000023841858,
          0.527999997138977
        ],
        [
          0.5519999861717224,
          0.527999997138977
        ],
        [
          0.5419999957084656,
          0.5139999985694885
        ],
        [
          0.5339999794960022,
          0.5120000243186951
        ],
        [
          0.5199999809265137,
          0.5
        ],
        [
          0.49000000953674316,
          0.49399998784065247
        ],
        [
          0.4880000054836273,
          0.49000000953674316
        ],
        [
          0.45399999618530273,
          0.49000000953674316
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4580000042915344,
          0.49799999594688416
        ],
        [
          0.421999990940094,
          0.5139999985694885
        ],
        [
          0.41600000858306885,
          0.5139999985694885
        ],
        [
          0.40400001406669617,
          0.5260000228881836
        ],
        [
          0.3919999897480011,
          0.527999997138977
        ],
        [
          0.38199999928474426,
          0.5379999876022339
        ],
        [
          0.38199999928474426,
          0.5839999914169312
        ],
        [
          0.38999998569488525,
          0.6019999980926514
        ],
        [
          0.3919999897480011,
          0.628000020980835
        ],
        [
          0.39800000190734863,
          0.6420000195503235
        ],
        [
          0.3959999978542328,
          0.6480000019073486
        ],
        [
          0.39800000190734863,
          0.6660000085830688
        ],
        [
          0.4180000126361847,
          0.6899999976158142
        ],
        [
          0.4580000042915344,
          0.7039999961853027
        ],
        [
          0.4740000069141388,
          0.7039999961853027
        ],
        [
          0.4880000054836273,
          0.6980000138282776
        ],
        [
          0.4959999918937683,
          0.6980000138282776
        ],
        [
          0.5,
          0.6940000057220459
        ],
        [
          0.5180000066757202,
          0.6899999976158142
        ],
        [
          0.5239999890327454,
          0.6819999814033508
        ],
        [
          0.5759999752044678,
          0.6600000262260437
        ],
        [
          0.5799999833106995,
          0.6520000100135803
        ],
        [
          0.5860000252723694,
          0.6520000100135803
        ],
        [
          0.6159999966621399,
          0.6359999775886536
        ],
        [
          0.6259999871253967,
          0.6240000128746033
        ],
        [
          0.628000020980835,
          0.5600000023841858
        ],
        [
          0.6200000047683716,
          0.5460000038146973
        ],
        [
          0.6079999804496765,
          0.5440000295639038
        ],
        [
          0.6000000238418579,
          0.5379999876022339
        ],
        [
          0.5720000267028809,
          0.5400000214576721
        ],
        [
          0.5559999942779541,
          0.5339999794960022
        ],
        [
          0.5260000228881836,
          0.5139999985694885
        ],
        [
          0.5199999809265137,
          0.5139999985694885
        ],
        [
          0.5,
          0.5040000081062317
        ],
        [
          0.4580000042915344,
          0.49799999594688416
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.47600001096725464,
          0.4819999933242798
        ],
        [
          0.4620000123977661,
          0.4880000054836273
        ],
        [
          0.4359999895095825,
          0.515999972820282
        ],
        [
          0.42399999499320984,
          0.5220000147819519
        ],
        [
          0.41200000047683716,
          0.5360000133514404
        ],
        [
          0.40799999237060547,
          0.5479999780654907
        ],
        [
          0.40400001406669617,
          0.550000011920929
        ],
        [
          0.4020000100135803,
          0.6259999871253967
        ],
        [
          0.40400001406669617,
          0.6399999856948853
        ],
        [
          0.4099999964237213,
          0.6439999938011169
        ],
        [
          0.41200000047683716,
          0.6520000100135803
        ],
        [
          0.42399999499320984,
          0.6539999842643738
        ],
        [
          0.4300000071525574,
          0.6620000004768372
        ],
        [
          0.46000000834465027,
          0.6740000247955322
        ],
        [
          0.4880000054836273,
          0.6819999814033508
        ],
        [
          0.5120000243186951,
          0.6819999814033508
        ],
        [
          0.5699999928474426,
          0.6620000004768372
        ],
        [
          0.5720000267028809,
          0.656000018119812
        ],
        [
          0.5860000252723694,
          0.6539999842643738
        ],
        [
          0.6039999723434448,
          0.6420000195503235
        ],
        [
          0.6119999885559082,
          0.6399999856948853
        ],
        [
          0.6179999709129333,
          0.6359999775886536
        ],
        [
          0.621999979019165,
          0.628000020980835
        ],
        [
          0.6320000290870667,
          0.621999979019165
        ],
        [
          0.6359999775886536,
          0.6119999885559082
        ],
        [
          0.6380000114440918,
          0.5860000252723694
        ],
        [
          0.6359999775886536,
          0.5440000295639038
        ],
        [
          0.6179999709129333,
          0.5339999794960022
        ],
        [
          0.6159999966621399,
          0.5299999713897705
        ],
        [
          0.6079999804496765,
          0.5299999713897705
        ],
        [
          0.5979999899864197,
          0.515999972820282
        ],
        [
          0.5860000252723694,
          0.5120000243186951
        ],
        [
          0.5699999928474426,
          0.5019999742507935
        ],
        [
          0.5659999847412109,
          0.4959999918937683
        ],
        [
          0.5440000295639038,
          0.49399998784065247
        ],
        [
          0.515999972820282,
          0.4819999933242798
        ],
        [
          0.47600001096725464,
          0.4819999933242798
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4779999852180481,
          0.4819999933242798
        ],
        [
          0.46000000834465027,
          0.49000000953674316
        ],
        [
          0.4519999921321869,
          0.49799999594688416
        ],
        [
          0.43799999356269836,
          0.5139999985694885
        ],
        [
          0.4359999895095825,
          0.5239999890327454
        ],
        [
          0.42800000309944153,
          0.5320000052452087
        ],
        [
          0.4099999964237213,
          0.5379999876022339
        ],
        [
          0.40400001406669617,
          0.5440000295639038
        ],
        [
          0.39800000190734863,
          0.5600000023841858
        ],
        [
          0.3959999978542328,
          0.6399999856948853
        ],
        [
          0.4020000100135803,
          0.6740000247955322
        ],
        [
          0.40799999237060547,
          0.6819999814033508
        ],
        [
          0.4320000112056732,
          0.6919999718666077
        ],
        [
          0.49799999594688416,
          0.6859999895095825
        ],
        [
          0.5379999876022339,
          0.6740000247955322
        ],
        [
          0.5419999957084656,
          0.6679999828338623
        ],
        [
          0.5580000281333923,
          0.6600000262260437
        ],
        [
          0.5600000023841858,
          0.656000018119812
        ],
        [
          0.6140000224113464,
          0.6340000033378601
        ],
        [
          0.6159999966621399,
          0.6299999952316284
        ],
        [
          0.6359999775886536,
          0.6259999871253967
        ],
        [
          0.6420000195503235,
          0.6140000224113464
        ],
        [
          0.6420000195503235,
          0.5540000200271606
        ],
        [
          0.6380000114440918,
          0.5460000038146973
        ],
        [
          0.6320000290870667,
          0.5440000295639038
        ],
        [
          0.628000020980835,
          0.5379999876022339
        ],
        [
          0.6119999885559082,
          0.5320000052452087
        ],
        [
          0.6100000143051147,
          0.527999997138977
        ],
        [
          0.6019999980926514,
          0.527999997138977
        ],
        [
          0.5799999833106995,
          0.5199999809265137
        ],
        [
          0.578000009059906,
          0.5139999985694885
        ],
        [
          0.5580000281333923,
          0.5099999904632568
        ],
        [
          0.5299999713897705,
          0.49399998784065247
        ],
        [
          0.5220000147819519,
          0.49399998784065247
        ],
        [
          0.5220000147819519,
          0.49000000953674316
        ],
        [
          0.5139999985694885,
          0.4860000014305115
        ],
        [
          0.49799999594688416,
          0.4819999933242798
        ],
        [
          0.4779999852180481,
          0.4819999933242798
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.46000000834465027,
          0.49000000953674316
        ],
        [
          0.4399999976158142,
          0.4959999918937683
        ],
        [
          0.4259999990463257,
          0.5080000162124634
        ],
        [
          0.41600000858306885,
          0.5120000243186951
        ],
        [
          0.3919999897480011,
          0.5419999957084656
        ],
        [
          0.38999998569488525,
          0.5759999752044678
        ],
        [
          0.3919999897480011,
          0.5920000076293945
        ],
        [
          0.3959999978542328,
          0.593999981880188
        ],
        [
          0.3959999978542328,
          0.6240000128746033
        ],
        [
          0.3919999897480011,
          0.6259999871253967
        ],
        [
          0.3919999897480011,
          0.6499999761581421
        ],
        [
          0.3959999978542328,
          0.6539999842643738
        ],
        [
          0.3959999978542328,
          0.6679999828338623
        ],
        [
          0.40400001406669617,
          0.6859999895095825
        ],
        [
          0.4320000112056732,
          0.6980000138282776
        ],
        [
          0.46000000834465027,
          0.6980000138282776
        ],
        [
          0.5,
          0.6880000233650208
        ],
        [
          0.5120000243186951,
          0.6880000233650208
        ],
        [
          0.5419999957084656,
          0.6779999732971191
        ],
        [
          0.5559999942779541,
          0.6660000085830688
        ],
        [
          0.5759999752044678,
          0.6579999923706055
        ],
        [
          0.5820000171661377,
          0.6499999761581421
        ],
        [
          0.6019999980926514,
          0.6460000276565552
        ],
        [
          0.6299999952316284,
          0.6340000033378601
        ],
        [
          0.6380000114440918,
          0.621999979019165
        ],
        [
          0.6380000114440918,
          0.6000000238418579
        ],
        [
          0.621999979019165,
          0.5680000185966492
        ],
        [
          0.6259999871253967,
          0.5619999766349792
        ],
        [
          0.6259999871253967,
          0.5519999861717224
        ],
        [
          0.6200000047683716,
          0.5440000295639038
        ],
        [
          0.6019999980926514,
          0.5360000133514404
        ],
        [
          0.5960000157356262,
          0.527999997138977
        ],
        [
          0.5899999737739563,
          0.527999997138977
        ],
        [
          0.5879999995231628,
          0.5239999890327454
        ],
        [
          0.5640000104904175,
          0.5239999890327454
        ],
        [
          0.5440000295639038,
          0.5180000066757202
        ],
        [
          0.5260000228881836,
          0.5040000081062317
        ],
        [
          0.5059999823570251,
          0.4959999918937683
        ],
        [
          0.4880000054836273,
          0.49000000953674316
        ],
        [
          0.46000000834465027,
          0.49000000953674316
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4580000042915344,
          0.492000013589859
        ],
        [
          0.4480000138282776,
          0.4959999918937683
        ],
        [
          0.414000004529953,
          0.5339999794960022
        ],
        [
          0.40799999237060547,
          0.5479999780654907
        ],
        [
          0.40400001406669617,
          0.550000011920929
        ],
        [
          0.40400001406669617,
          0.593999981880188
        ],
        [
          0.3959999978542328,
          0.6159999966621399
        ],
        [
          0.3919999897480011,
          0.6179999709129333
        ],
        [
          0.38999998569488525,
          0.6340000033378601
        ],
        [
          0.38600000739097595,
          0.6359999775886536
        ],
        [
          0.3840000033378601,
          0.6460000276565552
        ],
        [
          0.38600000739097595,
          0.6700000166893005
        ],
        [
          0.38999998569488525,
          0.671999990940094
        ],
        [
          0.3919999897480011,
          0.6840000152587891
        ],
        [
          0.40400001406669617,
          0.7020000219345093
        ],
        [
          0.4320000112056732,
          0.7139999866485596
        ],
        [
          0.47200000286102295,
          0.7160000205039978
        ],
        [
          0.5040000081062317,
          0.7120000123977661
        ],
        [
          0.5320000052452087,
          0.7020000219345093
        ],
        [
          0.5339999794960022,
          0.6980000138282776
        ],
        [
          0.5419999957084656,
          0.6959999799728394
        ],
        [
          0.5640000104904175,
          0.6800000071525574
        ],
        [
          0.5680000185966492,
          0.6740000247955322
        ],
        [
          0.5879999995231628,
          0.6639999747276306
        ],
        [
          0.6119999885559082,
          0.6579999923706055
        ],
        [
          0.6200000047683716,
          0.6499999761581421
        ],
        [
          0.6340000033378601,
          0.6499999761581421
        ],
        [
          0.6460000276565552,
          0.6420000195503235
        ],
        [
          0.6480000019073486,
          0.6019999980926514
        ],
        [
          0.6399999856948853,
          0.5659999847412109
        ],
        [
          0.5960000157356262,
          0.5239999890327454
        ],
        [
          0.5879999995231628,
          0.5239999890327454
        ],
        [
          0.578000009059906,
          0.5180000066757202
        ],
        [
          0.5260000228881836,
          0.5120000243186951
        ],
        [
          0.5099999904632568,
          0.5
        ],
        [
          0.5,
          0.49799999594688416
        ],
        [
          0.492000013589859,
          0.492000013589859
        ],
        [
          0.4580000042915344,
          0.492000013589859
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.45399999618530273,
          0.49799999594688416
        ],
        [
          0.4440000057220459,
          0.5019999742507935
        ],
        [
          0.4339999854564667,
          0.5120000243186951
        ],
        [
          0.4300000071525574,
          0.5120000243186951
        ],
        [
          0.41999998688697815,
          0.5239999890327454
        ],
        [
          0.41600000858306885,
          0.5239999890327454
        ],
        [
          0.40400001406669617,
          0.5400000214576721
        ],
        [
          0.4000000059604645,
          0.5619999766349792
        ],
        [
          0.39800000190734863,
          0.6660000085830688
        ],
        [
          0.39800000190734863,
          0.6899999976158142
        ],
        [
          0.40400001406669617,
          0.7080000042915344
        ],
        [
          0.4339999854564667,
          0.7200000286102295
        ],
        [
          0.4740000069141388,
          0.7200000286102295
        ],
        [
          0.5120000243186951,
          0.7139999866485596
        ],
        [
          0.5419999957084656,
          0.7020000219345093
        ],
        [
          0.5460000038146973,
          0.6959999799728394
        ],
        [
          0.5820000171661377,
          0.6779999732971191
        ],
        [
          0.5839999914169312,
          0.6740000247955322
        ],
        [
          0.6159999966621399,
          0.6660000085830688
        ],
        [
          0.6340000033378601,
          0.6539999842643738
        ],
        [
          0.6340000033378601,
          0.6499999761581421
        ],
        [
          0.6399999856948853,
          0.6460000276565552
        ],
        [
          0.6399999856948853,
          0.6240000128746033
        ],
        [
          0.621999979019165,
          0.5899999737739563
        ],
        [
          0.6179999709129333,
          0.5699999928474426
        ],
        [
          0.6119999885559082,
          0.5580000281333923
        ],
        [
          0.5920000076293945,
          0.5379999876022339
        ],
        [
          0.5839999914169312,
          0.5339999794960022
        ],
        [
          0.578000009059906,
          0.5239999890327454
        ],
        [
          0.5360000133514404,
          0.515999972820282
        ],
        [
          0.5339999794960022,
          0.5120000243186951
        ],
        [
          0.5199999809265137,
          0.5120000243186951
        ],
        [
          0.5099999904632568,
          0.5040000081062317
        ],
        [
          0.49399998784065247,
          0.49799999594688416
        ],
        [
          0.45399999618530273,
          0.49799999594688416
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4620000123977661,
          0.492000013589859
        ],
        [
          0.44999998807907104,
          0.49799999594688416
        ],
        [
          0.44600000977516174,
          0.5040000081062317
        ],
        [
          0.4300000071525574,
          0.5120000243186951
        ],
        [
          0.42399999499320984,
          0.5120000243186951
        ],
        [
          0.414000004529953,
          0.5199999809265137
        ],
        [
          0.3959999978542328,
          0.5379999876022339
        ],
        [
          0.38999998569488525,
          0.550000011920929
        ],
        [
          0.38999998569488525,
          0.5740000009536743
        ],
        [
          0.39399999380111694,
          0.5759999752044678
        ],
        [
          0.3959999978542328,
          0.6119999885559082
        ],
        [
          0.4000000059604645,
          0.6140000224113464
        ],
        [
          0.4000000059604645,
          0.6359999775886536
        ],
        [
          0.40400001406669617,
          0.6600000262260437
        ],
        [
          0.40799999237060547,
          0.6620000004768372
        ],
        [
          0.4099999964237213,
          0.6700000166893005
        ],
        [
          0.41200000047683716,
          0.699999988079071
        ],
        [
          0.4259999990463257,
          0.7160000205039978
        ],
        [
          0.4860000014305115,
          0.7200000286102295
        ],
        [
          0.5180000066757202,
          0.7179999947547913
        ],
        [
          0.5320000052452087,
          0.7120000123977661
        ],
        [
          0.5360000133514404,
          0.7059999704360962
        ],
        [
          0.5460000038146973,
          0.7020000219345093
        ],
        [
          0.5659999847412109,
          0.6840000152587891
        ],
        [
          0.578000009059906,
          0.6779999732971191
        ],
        [
          0.6200000047683716,
          0.6679999828338623
        ],
        [
          0.6399999856948853,
          0.6520000100135803
        ],
        [
          0.6420000195503235,
          0.6259999871253967
        ],
        [
          0.6320000290870667,
          0.6000000238418579
        ],
        [
          0.6320000290870667,
          0.5920000076293945
        ],
        [
          0.628000020980835,
          0.5899999737739563
        ],
        [
          0.621999979019165,
          0.5600000023841858
        ],
        [
          0.593999981880188,
          0.5580000281333923
        ],
        [
          0.578000009059906,
          0.5519999861717224
        ],
        [
          0.5519999861717224,
          0.5199999809265137
        ],
        [
          0.5419999957084656,
          0.5120000243186951
        ],
        [
          0.5299999713897705,
          0.5080000162124634
        ],
        [
          0.5239999890327454,
          0.5
        ],
        [
          0.5099999904632568,
          0.492000013589859
        ],
        [
          0.4620000123977661,
          0.492000013589859
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.421999990940094,
          0.5299999713897705
        ],
        [
          0.40799999237060547,
          0.5400000214576721
        ],
        [
          0.40799999237060547,
          0.5540000200271606
        ],
        [
          0.40400001406669617,
          0.5559999942779541
        ],
        [
          0.40400001406669617,
          0.6060000061988831
        ],
        [
          0.3959999978542328,
          0.6320000290870667
        ],
        [
          0.3959999978542328,
          0.6420000195503235
        ],
        [
          0.40400001406669617,
          0.6600000262260437
        ],
        [
          0.421999990940094,
          0.6819999814033508
        ],
        [
          0.4180000126361847,
          0.7120000123977661
        ],
        [
          0.42399999499320984,
          0.722000002861023
        ],
        [
          0.4359999895095825,
          0.7279999852180481
        ],
        [
          0.4699999988079071,
          0.7279999852180481
        ],
        [
          0.47200000286102295,
          0.7319999933242798
        ],
        [
          0.49000000953674316,
          0.7319999933242798
        ],
        [
          0.492000013589859,
          0.7279999852180481
        ],
        [
          0.5239999890327454,
          0.7239999771118164
        ],
        [
          0.5479999780654907,
          0.7139999866485596
        ],
        [
          0.5619999766349792,
          0.699999988079071
        ],
        [
          0.5799999833106995,
          0.6880000233650208
        ],
        [
          0.5879999995231628,
          0.6859999895095825
        ],
        [
          0.5899999737739563,
          0.6819999814033508
        ],
        [
          0.628000020980835,
          0.671999990940094
        ],
        [
          0.6480000019073486,
          0.6579999923706055
        ],
        [
          0.6499999761581421,
          0.621999979019165
        ],
        [
          0.6380000114440918,
          0.6019999980926514
        ],
        [
          0.6320000290870667,
          0.578000009059906
        ],
        [
          0.6259999871253967,
          0.5720000267028809
        ],
        [
          0.5979999899864197,
          0.5699999928474426
        ],
        [
          0.5960000157356262,
          0.5659999847412109
        ],
        [
          0.5899999737739563,
          0.5659999847412109
        ],
        [
          0.5640000104904175,
          0.550000011920929
        ],
        [
          0.5580000281333923,
          0.5419999957084656
        ],
        [
          0.5400000214576721,
          0.5339999794960022
        ],
        [
          0.5239999890327454,
          0.5320000052452087
        ],
        [
          0.5019999742507935,
          0.5360000133514404
        ],
        [
          0.49399998784065247,
          0.5419999957084656
        ],
        [
          0.4740000069141388,
          0.5419999957084656
        ],
        [
          0.46000000834465027,
          0.5339999794960022
        ],
        [
          0.4440000057220459,
          0.5299999713897705
        ],
        [
          0.421999990940094,
          0.5299999713897705
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4860000014305115,
          0.5299999713897705
        ],
        [
          0.46799999475479126,
          0.5320000052452087
        ],
        [
          0.44200000166893005,
          0.5400000214576721
        ],
        [
          0.4339999854564667,
          0.5440000295639038
        ],
        [
          0.4180000126361847,
          0.5600000023841858
        ],
        [
          0.414000004529953,
          0.5759999752044678
        ],
        [
          0.40799999237060547,
          0.5820000171661377
        ],
        [
          0.4059999883174896,
          0.5979999899864197
        ],
        [
          0.4020000100135803,
          0.6000000238418579
        ],
        [
          0.39800000190734863,
          0.6200000047683716
        ],
        [
          0.3959999978542328,
          0.6399999856948853
        ],
        [
          0.4020000100135803,
          0.6639999747276306
        ],
        [
          0.4059999883174896,
          0.6660000085830688
        ],
        [
          0.4099999964237213,
          0.6759999990463257
        ],
        [
          0.4099999964237213,
          0.6880000233650208
        ],
        [
          0.414000004529953,
          0.6899999976158142
        ],
        [
          0.414000004529953,
          0.7039999961853027
        ],
        [
          0.41999998688697815,
          0.7179999947547913
        ],
        [
          0.44600000977516174,
          0.734000027179718
        ],
        [
          0.4560000002384186,
          0.7360000014305115
        ],
        [
          0.4860000014305115,
          0.7360000014305115
        ],
        [
          0.5419999957084656,
          0.722000002861023
        ],
        [
          0.5600000023841858,
          0.7120000123977661
        ],
        [
          0.578000009059906,
          0.6959999799728394
        ],
        [
          0.6019999980926514,
          0.6880000233650208
        ],
        [
          0.6159999966621399,
          0.6779999732971191
        ],
        [
          0.6259999871253967,
          0.6759999990463257
        ],
        [
          0.6439999938011169,
          0.6579999923706055
        ],
        [
          0.6439999938011169,
          0.6200000047683716
        ],
        [
          0.621999979019165,
          0.5899999737739563
        ],
        [
          0.5899999737739563,
          0.5740000009536743
        ],
        [
          0.578000009059906,
          0.5619999766349792
        ],
        [
          0.550000011920929,
          0.5479999780654907
        ],
        [
          0.5479999780654907,
          0.5440000295639038
        ],
        [
          0.5059999823570251,
          0.5320000052452087
        ],
        [
          0.4860000014305115,
          0.5299999713897705
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.4320000112056732,
          0.527999997138977
        ],
        [
          0.421999990940094,
          0.5299999713897705
        ],
        [
          0.414000004529953,
          0.5379999876022339
        ],
        [
          0.41600000858306885,
          0.578000009059906
        ],
        [
          0.41200000047683716,
          0.593999981880188
        ],
        [
          0.4059999883174896,
          0.6000000238418579
        ],
        [
          0.4000000059604645,
          0.6240000128746033
        ],
        [
          0.39399999380111694,
          0.6299999952316284
        ],
        [
          0.38999998569488525,
          0.6600000262260437
        ],
        [
          0.38999998569488525,
          0.6819999814033508
        ],
        [
          0.39399999380111694,
          0.6980000138282776
        ],
        [
          0.41200000047683716,
          0.7139999866485596
        ],
        [
          0.46799999475479126,
          0.7279999852180481
        ],
        [
          0.4699999988079071,
          0.7319999933242798
        ],
        [
          0.5040000081062317,
          0.7319999933242798
        ],
        [
          0.5080000162124634,
          0.7279999852180481
        ],
        [
          0.5440000295639038,
          0.722000002861023
        ],
        [
          0.5600000023841858,
          0.7139999866485596
        ],
        [
          0.5860000252723694,
          0.6940000057220459
        ],
        [
          0.6140000224113464,
          0.6859999895095825
        ],
        [
          0.6159999966621399,
          0.6819999814033508
        ],
        [
          0.6480000019073486,
          0.6660000085830688
        ],
        [
          0.6499999761581421,
          0.6240000128746033
        ],
        [
          0.6320000290870667,
          0.6000000238418579
        ],
        [
          0.6259999871253967,
          0.5860000252723694
        ],
        [
          0.6039999723434448,
          0.5659999847412109
        ],
        [
          0.5799999833106995,
          0.5559999942779541
        ],
        [
          0.5619999766349792,
          0.5419999957084656
        ],
        [
          0.5260000228881836,
          0.5299999713897705
        ],
        [
          0.4320000112056732,
          0.527999997138977
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.47999998927116394,
          0.5339999794960022
        ],
        [
          0.4779999852180481,
          0.5379999876022339
        ],
        [
          0.4699999988079071,
          0.5379999876022339
        ],
        [
          0.4519999921321869,
          0.5460000038146973
        ],
        [
          0.4359999895095825,
          0.5659999847412109
        ],
        [
          0.41999998688697815,
          0.6000000238418579
        ],
        [
          0.414000004529953,
          0.6039999723434448
        ],
        [
          0.40799999237060547,
          0.6200000047683716
        ],
        [
          0.40400001406669617,
          0.621999979019165
        ],
        [
          0.4020000100135803,
          0.6359999775886536
        ],
        [
          0.40400001406669617,
          0.6660000085830688
        ],
        [
          0.40799999237060547,
          0.6679999828338623
        ],
        [
          0.414000004529953,
          0.6800000071525574
        ],
        [
          0.4339999854564667,
          0.6880000233650208
        ],
        [
          0.44200000166893005,
          0.7120000123977661
        ],
        [
          0.44999998807907104,
          0.7239999771118164
        ],
        [
          0.46399998664855957,
          0.7279999852180481
        ],
        [
          0.4659999907016754,
          0.7319999933242798
        ],
        [
          0.49799999594688416,
          0.734000027179718
        ],
        [
          0.527999997138977,
          0.7200000286102295
        ],
        [
          0.5580000281333923,
          0.7139999866485596
        ],
        [
          0.5640000104904175,
          0.7080000042915344
        ],
        [
          0.6060000061988831,
          0.6919999718666077
        ],
        [
          0.6340000033378601,
          0.6740000247955322
        ],
        [
          0.6399999856948853,
          0.6620000004768372
        ],
        [
          0.6399999856948853,
          0.6140000224113464
        ],
        [
          0.6320000290870667,
          0.5979999899864197
        ],
        [
          0.6119999885559082,
          0.5799999833106995
        ],
        [
          0.6100000143051147,
          0.5699999928474426
        ],
        [
          0.6019999980926514,
          0.5619999766349792
        ],
        [
          0.5740000009536743,
          0.5419999957084656
        ],
        [
          0.550000011920929,
          0.5379999876022339
        ],
        [
          0.5479999780654907,
          0.5339999794960022
        ],
        [
          0.47999998927116394,
          0.5339999794960022
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5360000133514404,
          0.5339999794960022
        ],
        [
          0.5339999794960022,
          0.5379999876022339
        ],
        [
          0.48399999737739563,
          0.5419999957084656
        ],
        [
          0.46399998664855957,
          0.550000011920929
        ],
        [
          0.4259999990463257,
          0.5879999995231628
        ],
        [
          0.4020000100135803,
          0.6340000033378601
        ],
        [
          0.4020000100135803,
          0.6639999747276306
        ],
        [
          0.4059999883174896,
          0.6660000085830688
        ],
        [
          0.414000004529953,
          0.6840000152587891
        ],
        [
          0.4480000138282776,
          0.7080000042915344
        ],
        [
          0.45399999618530273,
          0.7200000286102295
        ],
        [
          0.4659999907016754,
          0.7260000109672546
        ],
        [
          0.49799999594688416,
          0.7279999852180481
        ],
        [
          0.5540000200271606,
          0.7120000123977661
        ],
        [
          0.5559999942779541,
          0.7080000042915344
        ],
        [
          0.593999981880188,
          0.6919999718666077
        ],
        [
          0.5979999899864197,
          0.6859999895095825
        ],
        [
          0.6060000061988831,
          0.6840000152587891
        ],
        [
          0.6200000047683716,
          0.6740000247955322
        ],
        [
          0.628000020980835,
          0.6579999923706055
        ],
        [
          0.6320000290870667,
          0.656000018119812
        ],
        [
          0.6320000290870667,
          0.6240000128746033
        ],
        [
          0.628000020980835,
          0.621999979019165
        ],
        [
          0.6240000128746033,
          0.6079999804496765
        ],
        [
          0.6019999980926514,
          0.5820000171661377
        ],
        [
          0.5799999833106995,
          0.5659999847412109
        ],
        [
          0.5640000104904175,
          0.5419999957084656
        ],
        [
          0.5360000133514404,
          0.5339999794960022
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5080000162124634,
          0.5440000295639038
        ],
        [
          0.47999998927116394,
          0.550000011920929
        ],
        [
          0.4779999852180481,
          0.5540000200271606
        ],
        [
          0.4560000002384186,
          0.5619999766349792
        ],
        [
          0.4320000112056732,
          0.5820000171661377
        ],
        [
          0.414000004529953,
          0.6200000047683716
        ],
        [
          0.414000004529953,
          0.6259999871253967
        ],
        [
          0.4020000100135803,
          0.6420000195503235
        ],
        [
          0.4020000100135803,
          0.7160000205039978
        ],
        [
          0.4059999883174896,
          0.7200000286102295
        ],
        [
          0.4259999990463257,
          0.7200000286102295
        ],
        [
          0.43799999356269836,
          0.7260000109672546
        ],
        [
          0.4399999976158142,
          0.7300000190734863
        ],
        [
          0.4699999988079071,
          0.7360000014305115
        ],
        [
          0.527999997138977,
          0.734000027179718
        ],
        [
          0.5419999957084656,
          0.7300000190734863
        ],
        [
          0.5479999780654907,
          0.7239999771118164
        ],
        [
          0.5820000171661377,
          0.7099999785423279
        ],
        [
          0.5839999914169312,
          0.7059999704360962
        ],
        [
          0.6119999885559082,
          0.6899999976158142
        ],
        [
          0.621999979019165,
          0.6779999732971191
        ],
        [
          0.6380000114440918,
          0.6660000085830688
        ],
        [
          0.6420000195503235,
          0.6579999923706055
        ],
        [
          0.6399999856948853,
          0.621999979019165
        ],
        [
          0.593999981880188,
          0.5699999928474426
        ],
        [
          0.5680000185966492,
          0.5600000023841858
        ],
        [
          0.5559999942779541,
          0.550000011920929
        ],
        [
          0.5260000228881836,
          0.5440000295639038
        ],
        [
          0.5080000162124634,
          0.5440000295639038
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5440000295639038,
          0.5379999876022339
        ],
        [
          0.5099999904632568,
          0.5419999957084656
        ],
        [
          0.5080000162124634,
          0.5460000038146973
        ],
        [
          0.5,
          0.5460000038146973
        ],
        [
          0.4740000069141388,
          0.5559999942779541
        ],
        [
          0.46399998664855957,
          0.5659999847412109
        ],
        [
          0.44999998807907104,
          0.5720000267028809
        ],
        [
          0.4339999854564667,
          0.5899999737739563
        ],
        [
          0.4259999990463257,
          0.6119999885559082
        ],
        [
          0.41999998688697815,
          0.6179999709129333
        ],
        [
          0.4099999964237213,
          0.6679999828338623
        ],
        [
          0.4099999964237213,
          0.6859999895095825
        ],
        [
          0.414000004529953,
          0.6980000138282776
        ],
        [
          0.4359999895095825,
          0.7039999961853027
        ],
        [
          0.4699999988079071,
          0.7360000014305115
        ],
        [
          0.5180000066757202,
          0.7419999837875366
        ],
        [
          0.550000011920929,
          0.7400000095367432
        ],
        [
          0.5720000267028809,
          0.722000002861023
        ],
        [
          0.5879999995231628,
          0.7139999866485596
        ],
        [
          0.5899999737739563,
          0.7099999785423279
        ],
        [
          0.6100000143051147,
          0.699999988079071
        ],
        [
          0.6179999709129333,
          0.6859999895095825
        ],
        [
          0.6420000195503235,
          0.6620000004768372
        ],
        [
          0.6460000276565552,
          0.6539999842643738
        ],
        [
          0.6460000276565552,
          0.6159999966621399
        ],
        [
          0.6420000195503235,
          0.6079999804496765
        ],
        [
          0.6359999775886536,
          0.6039999723434448
        ],
        [
          0.6240000128746033,
          0.578000009059906
        ],
        [
          0.6159999966621399,
          0.5699999928474426
        ],
        [
          0.5979999899864197,
          0.5659999847412109
        ],
        [
          0.5960000157356262,
          0.5619999766349792
        ],
        [
          0.5759999752044678,
          0.5540000200271606
        ],
        [
          0.5699999928474426,
          0.5419999957084656
        ],
        [
          0.5440000295639038,
          0.5379999876022339
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5320000052452087,
          0.5360000133514404
        ],
        [
          0.5239999890327454,
          0.5419999957084656
        ],
        [
          0.5059999823570251,
          0.5460000038146973
        ],
        [
          0.4860000014305115,
          0.5559999942779541
        ],
        [
          0.48399999737739563,
          0.5600000023841858
        ],
        [
          0.46000000834465027,
          0.5699999928474426
        ],
        [
          0.4440000057220459,
          0.5820000171661377
        ],
        [
          0.4359999895095825,
          0.5979999899864197
        ],
        [
          0.42800000309944153,
          0.6380000114440918
        ],
        [
          0.42399999499320984,
          0.6399999856948853
        ],
        [
          0.42399999499320984,
          0.6660000085830688
        ],
        [
          0.4339999854564667,
          0.6840000152587891
        ],
        [
          0.4399999976158142,
          0.6919999718666077
        ],
        [
          0.4519999921321869,
          0.6980000138282776
        ],
        [
          0.46399998664855957,
          0.7099999785423279
        ],
        [
          0.47600001096725464,
          0.7300000190734863
        ],
        [
          0.49000000953674316,
          0.7379999756813049
        ],
        [
          0.49799999594688416,
          0.7379999756813049
        ],
        [
          0.5,
          0.7419999837875366
        ],
        [
          0.5360000133514404,
          0.7419999837875366
        ],
        [
          0.5379999876022339,
          0.7379999756813049
        ],
        [
          0.5460000038146973,
          0.7379999756813049
        ],
        [
          0.5680000185966492,
          0.7300000190734863
        ],
        [
          0.5799999833106995,
          0.7179999947547913
        ],
        [
          0.6019999980926514,
          0.7059999704360962
        ],
        [
          0.6060000061988831,
          0.6980000138282776
        ],
        [
          0.6200000047683716,
          0.6940000057220459
        ],
        [
          0.6259999871253967,
          0.6880000233650208
        ],
        [
          0.628000020980835,
          0.6800000071525574
        ],
        [
          0.6380000114440918,
          0.6700000166893005
        ],
        [
          0.6499999761581421,
          0.6399999856948853
        ],
        [
          0.6480000019073486,
          0.6079999804496765
        ],
        [
          0.6359999775886536,
          0.5720000267028809
        ],
        [
          0.6240000128746033,
          0.5619999766349792
        ],
        [
          0.6000000238418579,
          0.5600000023841858
        ],
        [
          0.5759999752044678,
          0.5360000133514404
        ],
        [
          0.5320000052452087,
          0.5360000133514404
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5139999985694885,
          0.5419999957084656
        ],
        [
          0.49000000953674316,
          0.5519999861717224
        ],
        [
          0.48399999737739563,
          0.5600000023841858
        ],
        [
          0.46399998664855957,
          0.5699999928474426
        ],
        [
          0.4480000138282776,
          0.5860000252723694
        ],
        [
          0.4440000057220459,
          0.5979999899864197
        ],
        [
          0.4399999976158142,
          0.6000000238418579
        ],
        [
          0.4359999895095825,
          0.6179999709129333
        ],
        [
          0.4339999854564667,
          0.6299999952316284
        ],
        [
          0.4359999895095825,
          0.6579999923706055
        ],
        [
          0.4440000057220459,
          0.671999990940094
        ],
        [
          0.44999998807907104,
          0.6919999718666077
        ],
        [
          0.4560000002384186,
          0.6980000138282776
        ],
        [
          0.49000000953674316,
          0.7160000205039978
        ],
        [
          0.5019999742507935,
          0.7300000190734863
        ],
        [
          0.5120000243186951,
          0.734000027179718
        ],
        [
          0.5139999985694885,
          0.7379999756813049
        ],
        [
          0.5519999861717224,
          0.7400000095367432
        ],
        [
          0.5860000252723694,
          0.722000002861023
        ],
        [
          0.5860000252723694,
          0.7179999947547913
        ],
        [
          0.6000000238418579,
          0.699999988079071
        ],
        [
          0.6240000128746033,
          0.6759999990463257
        ],
        [
          0.6399999856948853,
          0.6439999938011169
        ],
        [
          0.6439999938011169,
          0.6159999966621399
        ],
        [
          0.6240000128746033,
          0.5759999752044678
        ],
        [
          0.6119999885559082,
          0.5680000185966492
        ],
        [
          0.5920000076293945,
          0.5619999766349792
        ],
        [
          0.578000009059906,
          0.5479999780654907
        ],
        [
          0.5640000104904175,
          0.5419999957084656
        ],
        [
          0.5139999985694885,
          0.5419999957084656
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5740000009536743,
          0.5379999876022339
        ],
        [
          0.527999997138977,
          0.5419999957084656
        ],
        [
          0.515999972820282,
          0.5479999780654907
        ],
        [
          0.5019999742507935,
          0.550000011920929
        ],
        [
          0.5019999742507935,
          0.5540000200271606
        ],
        [
          0.4819999933242798,
          0.5619999766349792
        ],
        [
          0.4699999988079071,
          0.5759999752044678
        ],
        [
          0.46000000834465027,
          0.6100000143051147
        ],
        [
          0.4519999921321869,
          0.621999979019165
        ],
        [
          0.44999998807907104,
          0.6299999952316284
        ],
        [
          0.4519999921321869,
          0.6679999828338623
        ],
        [
          0.4560000002384186,
          0.6700000166893005
        ],
        [
          0.46399998664855957,
          0.6940000057220459
        ],
        [
          0.4779999852180481,
          0.7059999704360962
        ],
        [
          0.4779999852180481,
          0.7099999785423279
        ],
        [
          0.48399999737739563,
          0.7160000205039978
        ],
        [
          0.492000013589859,
          0.7379999756813049
        ],
        [
          0.5040000081062317,
          0.7480000257492065
        ],
        [
          0.5440000295639038,
          0.7559999823570251
        ],
        [
          0.5759999752044678,
          0.7519999742507935
        ],
        [
          0.6200000047683716,
          0.7300000190734863
        ],
        [
          0.6240000128746033,
          0.722000002861023
        ],
        [
          0.6380000114440918,
          0.7120000123977661
        ],
        [
          0.6399999856948853,
          0.7039999961853027
        ],
        [
          0.6499999761581421,
          0.6959999799728394
        ],
        [
          0.6539999842643738,
          0.6700000166893005
        ],
        [
          0.6539999842643738,
          0.621999979019165
        ],
        [
          0.6380000114440918,
          0.5839999914169312
        ],
        [
          0.6299999952316284,
          0.5740000009536743
        ],
        [
          0.6259999871253967,
          0.5619999766349792
        ],
        [
          0.6079999804496765,
          0.5460000038146973
        ],
        [
          0.5960000157356262,
          0.5400000214576721
        ],
        [
          0.5740000009536743,
          0.5379999876022339
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.550000011920929,
          0.527999997138977
        ],
        [
          0.5040000081062317,
          0.5299999713897705
        ],
        [
          0.4880000054836273,
          0.5379999876022339
        ],
        [
          0.4819999933242798,
          0.5479999780654907
        ],
        [
          0.4740000069141388,
          0.5540000200271606
        ],
        [
          0.46399998664855957,
          0.5860000252723694
        ],
        [
          0.44999998807907104,
          0.6140000224113464
        ],
        [
          0.44600000977516174,
          0.6359999775886536
        ],
        [
          0.4519999921321869,
          0.6639999747276306
        ],
        [
          0.47200000286102295,
          0.6980000138282776
        ],
        [
          0.4740000069141388,
          0.7080000042915344
        ],
        [
          0.4819999933242798,
          0.7160000205039978
        ],
        [
          0.4880000054836273,
          0.734000027179718
        ],
        [
          0.49799999594688416,
          0.7459999918937683
        ],
        [
          0.5419999957084656,
          0.7580000162124634
        ],
        [
          0.5879999995231628,
          0.7580000162124634
        ],
        [
          0.621999979019165,
          0.7480000257492065
        ],
        [
          0.6259999871253967,
          0.7419999837875366
        ],
        [
          0.6399999856948853,
          0.7379999756813049
        ],
        [
          0.6499999761581421,
          0.7279999852180481
        ],
        [
          0.6520000100135803,
          0.7200000286102295
        ],
        [
          0.6579999923706055,
          0.7160000205039978
        ],
        [
          0.6679999828338623,
          0.6880000233650208
        ],
        [
          0.6660000085830688,
          0.6299999952316284
        ],
        [
          0.6600000262260437,
          0.6140000224113464
        ],
        [
          0.6520000100135803,
          0.6079999804496765
        ],
        [
          0.6499999761581421,
          0.5979999899864197
        ],
        [
          0.6399999856948853,
          0.5860000252723694
        ],
        [
          0.6399999856948853,
          0.5799999833106995
        ],
        [
          0.628000020980835,
          0.5580000281333923
        ],
        [
          0.6019999980926514,
          0.5320000052452087
        ],
        [
          0.5839999914169312,
          0.527999997138977
        ],
        [
          0.550000011920929,
          0.527999997138977
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5120000243186951,
          0.527999997138977
        ],
        [
          0.49000000953674316,
          0.5320000052452087
        ],
        [
          0.4779999852180481,
          0.5460000038146973
        ],
        [
          0.46399998664855957,
          0.5839999914169312
        ],
        [
          0.4480000138282776,
          0.6000000238418579
        ],
        [
          0.43799999356269836,
          0.6200000047683716
        ],
        [
          0.43799999356269836,
          0.6460000276565552
        ],
        [
          0.4440000057220459,
          0.6660000085830688
        ],
        [
          0.45399999618530273,
          0.6880000233650208
        ],
        [
          0.46399998664855957,
          0.6980000138282776
        ],
        [
          0.47999998927116394,
          0.7360000014305115
        ],
        [
          0.49000000953674316,
          0.75
        ],
        [
          0.5400000214576721,
          0.7620000243186951
        ],
        [
          0.6100000143051147,
          0.7599999904632568
        ],
        [
          0.6380000114440918,
          0.75
        ],
        [
          0.6539999842643738,
          0.7319999933242798
        ],
        [
          0.6579999923706055,
          0.7179999947547913
        ],
        [
          0.6660000085830688,
          0.7099999785423279
        ],
        [
          0.671999990940094,
          0.6940000057220459
        ],
        [
          0.6740000247955322,
          0.6779999732971191
        ],
        [
          0.671999990940094,
          0.5740000009536743
        ],
        [
          0.6299999952316284,
          0.5600000023841858
        ],
        [
          0.5860000252723694,
          0.5299999713897705
        ],
        [
          0.5120000243186951,
          0.527999997138977
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5080000162124634,
          0.5260000228881836
        ],
        [
          0.4819999933242798,
          0.5400000214576721
        ],
        [
          0.4659999907016754,
          0.5759999752044678
        ],
        [
          0.4620000123977661,
          0.578000009059906
        ],
        [
          0.4580000042915344,
          0.5899999737739563
        ],
        [
          0.4399999976158142,
          0.6200000047683716
        ],
        [
          0.43799999356269836,
          0.6320000290870667
        ],
        [
          0.4339999854564667,
          0.6340000033378601
        ],
        [
          0.4339999854564667,
          0.6539999842643738
        ],
        [
          0.43799999356269836,
          0.656000018119812
        ],
        [
          0.4580000042915344,
          0.7059999704360962
        ],
        [
          0.4620000123977661,
          0.7279999852180481
        ],
        [
          0.46799999475479126,
          0.734000027179718
        ],
        [
          0.46799999475479126,
          0.7459999918937683
        ],
        [
          0.47600001096725464,
          0.7559999823570251
        ],
        [
          0.5,
          0.7620000243186951
        ],
        [
          0.5419999957084656,
          0.7620000243186951
        ],
        [
          0.5440000295639038,
          0.765999972820282
        ],
        [
          0.5839999914169312,
          0.7699999809265137
        ],
        [
          0.6119999885559082,
          0.765999972820282
        ],
        [
          0.6140000224113464,
          0.7620000243186951
        ],
        [
          0.6340000033378601,
          0.7519999742507935
        ],
        [
          0.6480000019073486,
          0.7379999756813049
        ],
        [
          0.6539999842643738,
          0.7260000109672546
        ],
        [
          0.6600000262260437,
          0.6899999976158142
        ],
        [
          0.6660000085830688,
          0.6840000152587891
        ],
        [
          0.6679999828338623,
          0.6679999828338623
        ],
        [
          0.6660000085830688,
          0.628000020980835
        ],
        [
          0.6480000019073486,
          0.6060000061988831
        ],
        [
          0.6399999856948853,
          0.5860000252723694
        ],
        [
          0.6380000114440918,
          0.5699999928474426
        ],
        [
          0.6060000061988831,
          0.5400000214576721
        ],
        [
          0.5899999737739563,
          0.5320000052452087
        ],
        [
          0.5699999928474426,
          0.527999997138977
        ],
        [
          0.5080000162124634,
          0.5260000228881836
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5220000147819519,
          0.5339999794960022
        ],
        [
          0.5199999809265137,
          0.5379999876022339
        ],
        [
          0.5,
          0.5400000214576721
        ],
        [
          0.48399999737739563,
          0.5519999861717224
        ],
        [
          0.48399999737739563,
          0.5559999942779541
        ],
        [
          0.47600001096725464,
          0.5619999766349792
        ],
        [
          0.4580000042915344,
          0.6000000238418579
        ],
        [
          0.4399999976158142,
          0.621999979019165
        ],
        [
          0.4320000112056732,
          0.6480000019073486
        ],
        [
          0.4320000112056732,
          0.6620000004768372
        ],
        [
          0.4399999976158142,
          0.6919999718666077
        ],
        [
          0.44600000977516174,
          0.7020000219345093
        ],
        [
          0.45399999618530273,
          0.7080000042915344
        ],
        [
          0.46399998664855957,
          0.734000027179718
        ],
        [
          0.47200000286102295,
          0.7459999918937683
        ],
        [
          0.49000000953674316,
          0.7599999904632568
        ],
        [
          0.5019999742507935,
          0.7639999985694885
        ],
        [
          0.5820000171661377,
          0.765999972820282
        ],
        [
          0.5839999914169312,
          0.7699999809265137
        ],
        [
          0.6159999966621399,
          0.765999972820282
        ],
        [
          0.6320000290870667,
          0.7580000162124634
        ],
        [
          0.6520000100135803,
          0.7360000014305115
        ],
        [
          0.6600000262260437,
          0.7080000042915344
        ],
        [
          0.6660000085830688,
          0.6940000057220459
        ],
        [
          0.6700000166893005,
          0.6919999718666077
        ],
        [
          0.6700000166893005,
          0.6420000195503235
        ],
        [
          0.6579999923706055,
          0.628000020980835
        ],
        [
          0.6579999923706055,
          0.6240000128746033
        ],
        [
          0.6460000276565552,
          0.6159999966621399
        ],
        [
          0.6420000195503235,
          0.6060000061988831
        ],
        [
          0.6380000114440918,
          0.6039999723434448
        ],
        [
          0.6320000290870667,
          0.5720000267028809
        ],
        [
          0.6159999966621399,
          0.5479999780654907
        ],
        [
          0.6000000238418579,
          0.5400000214576721
        ],
        [
          0.5879999995231628,
          0.5379999876022339
        ],
        [
          0.5839999914169312,
          0.5339999794960022
        ],
        [
          0.5220000147819519,
          0.5339999794960022
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5019999742507935,
          0.5379999876022339
        ],
        [
          0.4819999933242798,
          0.5519999861717224
        ],
        [
          0.46000000834465027,
          0.6060000061988831
        ],
        [
          0.4480000138282776,
          0.621999979019165
        ],
        [
          0.4440000057220459,
          0.6359999775886536
        ],
        [
          0.43799999356269836,
          0.6399999856948853
        ],
        [
          0.4359999895095825,
          0.6460000276565552
        ],
        [
          0.4359999895095825,
          0.6679999828338623
        ],
        [
          0.4399999976158142,
          0.6779999732971191
        ],
        [
          0.4440000057220459,
          0.6800000071525574
        ],
        [
          0.45399999618530273,
          0.7200000286102295
        ],
        [
          0.46399998664855957,
          0.7419999837875366
        ],
        [
          0.47999998927116394,
          0.7580000162124634
        ],
        [
          0.4959999918937683,
          0.7620000243186951
        ],
        [
          0.550000011920929,
          0.7599999904632568
        ],
        [
          0.5740000009536743,
          0.7620000243186951
        ],
        [
          0.5759999752044678,
          0.765999972820282
        ],
        [
          0.5899999737739563,
          0.7680000066757202
        ],
        [
          0.6240000128746033,
          0.765999972820282
        ],
        [
          0.6520000100135803,
          0.7440000176429749
        ],
        [
          0.6700000166893005,
          0.7059999704360962
        ],
        [
          0.6700000166893005,
          0.6859999895095825
        ],
        [
          0.6740000247955322,
          0.6819999814033508
        ],
        [
          0.6740000247955322,
          0.6480000019073486
        ],
        [
          0.6700000166893005,
          0.6460000276565552
        ],
        [
          0.6700000166893005,
          0.6380000114440918
        ],
        [
          0.6620000004768372,
          0.6259999871253967
        ],
        [
          0.6420000195503235,
          0.6039999723434448
        ],
        [
          0.6299999952316284,
          0.5600000023841858
        ],
        [
          0.6140000224113464,
          0.5440000295639038
        ],
        [
          0.6019999980926514,
          0.5379999876022339
        ],
        [
          0.5740000009536743,
          0.5400000214576721
        ],
        [
          0.5019999742507935,
          0.5379999876022339
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5839999914169312,
          0.5419999957084656
        ],
        [
          0.5260000228881836,
          0.5460000038146973
        ],
        [
          0.5,
          0.5519999861717224
        ],
        [
          0.47999998927116394,
          0.5680000185966492
        ],
        [
          0.47600001096725464,
          0.5759999752044678
        ],
        [
          0.4699999988079071,
          0.5960000157356262
        ],
        [
          0.46799999475479126,
          0.6200000047683716
        ],
        [
          0.4620000123977661,
          0.6380000114440918
        ],
        [
          0.4580000042915344,
          0.6399999856948853
        ],
        [
          0.4560000002384186,
          0.6579999923706055
        ],
        [
          0.4580000042915344,
          0.6700000166893005
        ],
        [
          0.4620000123977661,
          0.671999990940094
        ],
        [
          0.4740000069141388,
          0.6980000138282776
        ],
        [
          0.47999998927116394,
          0.7260000109672546
        ],
        [
          0.48399999737739563,
          0.7279999852180481
        ],
        [
          0.49000000953674316,
          0.7400000095367432
        ],
        [
          0.5019999742507935,
          0.7459999918937683
        ],
        [
          0.5519999861717224,
          0.7459999918937683
        ],
        [
          0.5920000076293945,
          0.7360000014305115
        ],
        [
          0.6100000143051147,
          0.7360000014305115
        ],
        [
          0.6200000047683716,
          0.7260000109672546
        ],
        [
          0.6340000033378601,
          0.7200000286102295
        ],
        [
          0.6520000100135803,
          0.7179999947547913
        ],
        [
          0.6539999842643738,
          0.7139999866485596
        ],
        [
          0.6679999828338623,
          0.7099999785423279
        ],
        [
          0.671999990940094,
          0.7039999961853027
        ],
        [
          0.6759999990463257,
          0.6940000057220459
        ],
        [
          0.6779999732971191,
          0.6439999938011169
        ],
        [
          0.6759999990463257,
          0.5720000267028809
        ],
        [
          0.6660000085830688,
          0.5640000104904175
        ],
        [
          0.6359999775886536,
          0.5559999942779541
        ],
        [
          0.6340000033378601,
          0.5519999861717224
        ],
        [
          0.6200000047683716,
          0.5460000038146973
        ],
        [
          0.6039999723434448,
          0.5419999957084656
        ],
        [
          0.5839999914169312,
          0.5419999957084656
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5239999890327454,
          0.5440000295639038
        ],
        [
          0.4959999918937683,
          0.5540000200271606
        ],
        [
          0.47600001096725464,
          0.5740000009536743
        ],
        [
          0.4699999988079071,
          0.5879999995231628
        ],
        [
          0.46799999475479126,
          0.628000020980835
        ],
        [
          0.46399998664855957,
          0.6439999938011169
        ],
        [
          0.46000000834465027,
          0.6460000276565552
        ],
        [
          0.46000000834465027,
          0.6700000166893005
        ],
        [
          0.46399998664855957,
          0.671999990940094
        ],
        [
          0.4740000069141388,
          0.7020000219345093
        ],
        [
          0.47999998927116394,
          0.7360000014305115
        ],
        [
          0.4959999918937683,
          0.7519999742507935
        ],
        [
          0.5440000295639038,
          0.7580000162124634
        ],
        [
          0.5460000038146973,
          0.7620000243186951
        ],
        [
          0.5699999928474426,
          0.7620000243186951
        ],
        [
          0.5720000267028809,
          0.7580000162124634
        ],
        [
          0.5960000157356262,
          0.7519999742507935
        ],
        [
          0.6119999885559082,
          0.7540000081062317
        ],
        [
          0.621999979019165,
          0.7480000257492065
        ],
        [
          0.6299999952316284,
          0.7480000257492065
        ],
        [
          0.6359999775886536,
          0.7419999837875366
        ],
        [
          0.6539999842643738,
          0.7400000095367432
        ],
        [
          0.6759999990463257,
          0.7139999866485596
        ],
        [
          0.6800000071525574,
          0.6840000152587891
        ],
        [
          0.6779999732971191,
          0.628000020980835
        ],
        [
          0.6660000085830688,
          0.6140000224113464
        ],
        [
          0.6600000262260437,
          0.6119999885559082
        ],
        [
          0.6539999842643738,
          0.6000000238418579
        ],
        [
          0.6520000100135803,
          0.5820000171661377
        ],
        [
          0.656000018119812,
          0.5680000185966492
        ],
        [
          0.6399999856948853,
          0.5559999942779541
        ],
        [
          0.6159999966621399,
          0.5479999780654907
        ],
        [
          0.5920000076293945,
          0.5479999780654907
        ],
        [
          0.5740000009536743,
          0.5440000295639038
        ],
        [
          0.5239999890327454,
          0.5440000295639038
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5220000147819519,
          0.5460000038146973
        ],
        [
          0.5080000162124634,
          0.550000011920929
        ],
        [
          0.47999998927116394,
          0.5720000267028809
        ],
        [
          0.4699999988079071,
          0.5920000076293945
        ],
        [
          0.46399998664855957,
          0.628000020980835
        ],
        [
          0.46000000834465027,
          0.6299999952316284
        ],
        [
          0.45399999618530273,
          0.6480000019073486
        ],
        [
          0.4560000002384186,
          0.6899999976158142
        ],
        [
          0.47200000286102295,
          0.7120000123977661
        ],
        [
          0.4819999933242798,
          0.7360000014305115
        ],
        [
          0.4860000014305115,
          0.7379999756813049
        ],
        [
          0.49399998784065247,
          0.7519999742507935
        ],
        [
          0.5080000162124634,
          0.7559999823570251
        ],
        [
          0.5400000214576721,
          0.7580000162124634
        ],
        [
          0.5419999957084656,
          0.7620000243186951
        ],
        [
          0.5659999847412109,
          0.7620000243186951
        ],
        [
          0.5680000185966492,
          0.7580000162124634
        ],
        [
          0.6100000143051147,
          0.7480000257492065
        ],
        [
          0.6140000224113464,
          0.7419999837875366
        ],
        [
          0.6200000047683716,
          0.7419999837875366
        ],
        [
          0.6639999747276306,
          0.7200000286102295
        ],
        [
          0.6740000247955322,
          0.7039999961853027
        ],
        [
          0.6740000247955322,
          0.6460000276565552
        ],
        [
          0.6679999828338623,
          0.6340000033378601
        ],
        [
          0.6539999842643738,
          0.6200000047683716
        ],
        [
          0.6460000276565552,
          0.5979999899864197
        ],
        [
          0.6420000195503235,
          0.5699999928474426
        ],
        [
          0.6359999775886536,
          0.5619999766349792
        ],
        [
          0.6140000224113464,
          0.550000011920929
        ],
        [
          0.6000000238418579,
          0.5479999780654907
        ],
        [
          0.5220000147819519,
          0.5460000038146973
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.527999997138977,
          0.5559999942779541
        ],
        [
          0.5,
          0.5600000023841858
        ],
        [
          0.49000000953674316,
          0.5659999847412109
        ],
        [
          0.4740000069141388,
          0.5799999833106995
        ],
        [
          0.4659999907016754,
          0.5960000157356262
        ],
        [
          0.4620000123977661,
          0.5979999899864197
        ],
        [
          0.4560000002384186,
          0.628000020980835
        ],
        [
          0.4560000002384186,
          0.6740000247955322
        ],
        [
          0.46000000834465027,
          0.6959999799728394
        ],
        [
          0.4480000138282776,
          0.7120000123977661
        ],
        [
          0.4480000138282776,
          0.7160000205039978
        ],
        [
          0.4440000057220459,
          0.7179999947547913
        ],
        [
          0.44200000166893005,
          0.7260000109672546
        ],
        [
          0.44999998807907104,
          0.7519999742507935
        ],
        [
          0.4659999907016754,
          0.7599999904632568
        ],
        [
          0.5,
          0.7559999823570251
        ],
        [
          0.5720000267028809,
          0.7639999985694885
        ],
        [
          0.6079999804496765,
          0.7580000162124634
        ],
        [
          0.6159999966621399,
          0.7519999742507935
        ],
        [
          0.6480000019073486,
          0.7440000176429749
        ],
        [
          0.6639999747276306,
          0.7279999852180481
        ],
        [
          0.6679999828338623,
          0.7179999947547913
        ],
        [
          0.6759999990463257,
          0.7099999785423279
        ],
        [
          0.6759999990463257,
          0.6480000019073486
        ],
        [
          0.6740000247955322,
          0.6380000114440918
        ],
        [
          0.6679999828338623,
          0.6320000290870667
        ],
        [
          0.6660000085830688,
          0.6200000047683716
        ],
        [
          0.6480000019073486,
          0.5979999899864197
        ],
        [
          0.6359999775886536,
          0.5680000185966492
        ],
        [
          0.6200000047683716,
          0.5580000281333923
        ],
        [
          0.6060000061988831,
          0.5559999942779541
        ],
        [
          0.5740000009536743,
          0.5580000281333923
        ],
        [
          0.527999997138977,
          0.5559999942779541
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.5139999985694885,
          0.5580000281333923
        ],
        [
          0.49399998784065247,
          0.5680000185966492
        ],
        [
          0.4819999933242798,
          0.5799999833106995
        ],
        [
          0.4740000069141388,
          0.593999981880188
        ],
        [
          0.46799999475479126,
          0.6259999871253967
        ],
        [
          0.46399998664855957,
          0.628000020980835
        ],
        [
          0.4560000002384186,
          0.6959999799728394
        ],
        [
          0.4519999921321869,
          0.7059999704360962
        ],
        [
          0.4359999895095825,
          0.7260000109672546
        ],
        [
          0.43799999356269836,
          0.7720000147819519
        ],
        [
          0.4519999921321869,
          0.7760000228881836
        ],
        [
          0.46799999475479126,
          0.7760000228881836
        ],
        [
          0.4880000054836273,
          0.7720000147819519
        ],
        [
          0.492000013589859,
          0.765999972820282
        ],
        [
          0.49799999594688416,
          0.7639999985694885
        ],
        [
          0.5239999890327454,
          0.7639999985694885
        ],
        [
          0.5360000133514404,
          0.765999972820282
        ],
        [
          0.5379999876022339,
          0.7699999809265137
        ],
        [
          0.5640000104904175,
          0.7739999890327454
        ],
        [
          0.6140000224113464,
          0.7739999890327454
        ],
        [
          0.6320000290870667,
          0.7620000243186951
        ],
        [
          0.6420000195503235,
          0.7620000243186951
        ],
        [
          0.6639999747276306,
          0.7419999837875366
        ],
        [
          0.6700000166893005,
          0.7260000109672546
        ],
        [
          0.6759999990463257,
          0.722000002861023
        ],
        [
          0.6859999895095825,
          0.7039999961853027
        ],
        [
          0.6880000233650208,
          0.6840000152587891
        ],
        [
          0.6919999718666077,
          0.6819999814033508
        ],
        [
          0.6919999718666077,
          0.6420000195503235
        ],
        [
          0.6880000233650208,
          0.6399999856948853
        ],
        [
          0.6880000233650208,
          0.6320000290870667
        ],
        [
          0.6819999814033508,
          0.6200000047683716
        ],
        [
          0.6639999747276306,
          0.6019999980926514
        ],
        [
          0.6600000262260437,
          0.5879999995231628
        ],
        [
          0.6620000004768372,
          0.5740000009536743
        ],
        [
          0.6499999761581421,
          0.5600000023841858
        ],
        [
          0.6439999938011169,
          0.5580000281333923
        ],
        [
          0.5139999985694885,
          0.5580000281333923
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6179999709129333,
          0.5559999942779541
        ],
        [
          0.5860000252723694,
          0.5600000023841858
        ],
        [
          0.5839999914169312,
          0.5640000104904175
        ],
        [
          0.5080000162124634,
          0.5699999928474426
        ],
        [
          0.4860000014305115,
          0.5860000252723694
        ],
        [
          0.47600001096725464,
          0.6079999804496765
        ],
        [
          0.47200000286102295,
          0.6359999775886536
        ],
        [
          0.46799999475479126,
          0.6380000114440918
        ],
        [
          0.46799999475479126,
          0.6460000276565552
        ],
        [
          0.4580000042915344,
          0.6740000247955322
        ],
        [
          0.4440000057220459,
          0.6980000138282776
        ],
        [
          0.4320000112056732,
          0.7099999785423279
        ],
        [
          0.4300000071525574,
          0.7580000162124634
        ],
        [
          0.4339999854564667,
          0.765999972820282
        ],
        [
          0.45399999618530273,
          0.7739999890327454
        ],
        [
          0.4819999933242798,
          0.7739999890327454
        ],
        [
          0.5,
          0.7699999809265137
        ],
        [
          0.578000009059906,
          0.7699999809265137
        ],
        [
          0.5799999833106995,
          0.765999972820282
        ],
        [
          0.5899999737739563,
          0.7620000243186951
        ],
        [
          0.6119999885559082,
          0.7580000162124634
        ],
        [
          0.6200000047683716,
          0.75
        ],
        [
          0.6320000290870667,
          0.75
        ],
        [
          0.6399999856948853,
          0.7419999837875366
        ],
        [
          0.6460000276565552,
          0.7419999837875366
        ],
        [
          0.6480000019073486,
          0.7379999756813049
        ],
        [
          0.6539999842643738,
          0.7379999756813049
        ],
        [
          0.6579999923706055,
          0.7419999837875366
        ],
        [
          0.6700000166893005,
          0.7300000190734863
        ],
        [
          0.6700000166893005,
          0.7260000109672546
        ],
        [
          0.6819999814033508,
          0.7179999947547913
        ],
        [
          0.6880000233650208,
          0.7039999961853027
        ],
        [
          0.6899999976158142,
          0.6480000019073486
        ],
        [
          0.6880000233650208,
          0.6380000114440918
        ],
        [
          0.6679999828338623,
          0.6119999885559082
        ],
        [
          0.6639999747276306,
          0.5960000157356262
        ],
        [
          0.6600000262260437,
          0.593999981880188
        ],
        [
          0.6639999747276306,
          0.5740000009536743
        ],
        [
          0.6480000019073486,
          0.5580000281333923
        ],
        [
          0.6179999709129333,
          0.5559999942779541
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6019999980926514,
          0.5540000200271606
        ],
        [
          0.5920000076293945,
          0.5559999942779541
        ],
        [
          0.5899999737739563,
          0.5600000023841858
        ],
        [
          0.5559999942779541,
          0.5659999847412109
        ],
        [
          0.5220000147819519,
          0.5680000185966492
        ],
        [
          0.5199999809265137,
          0.5720000267028809
        ],
        [
          0.5,
          0.578000009059906
        ],
        [
          0.4880000054836273,
          0.5899999737739563
        ],
        [
          0.47999998927116394,
          0.6060000061988831
        ],
        [
          0.47999998927116394,
          0.6119999885559082
        ],
        [
          0.47600001096725464,
          0.6140000224113464
        ],
        [
          0.47200000286102295,
          0.6439999938011169
        ],
        [
          0.46399998664855957,
          0.6679999828338623
        ],
        [
          0.4580000042915344,
          0.6740000247955322
        ],
        [
          0.44999998807907104,
          0.7059999704360962
        ],
        [
          0.4359999895095825,
          0.7239999771118164
        ],
        [
          0.4339999854564667,
          0.7360000014305115
        ],
        [
          0.4359999895095825,
          0.7680000066757202
        ],
        [
          0.4560000002384186,
          0.7760000228881836
        ],
        [
          0.4880000054836273,
          0.7739999890327454
        ],
        [
          0.49000000953674316,
          0.7699999809265137
        ],
        [
          0.5299999713897705,
          0.765999972820282
        ],
        [
          0.6140000224113464,
          0.7680000066757202
        ],
        [
          0.6259999871253967,
          0.7559999823570251
        ],
        [
          0.656000018119812,
          0.7480000257492065
        ],
        [
          0.6700000166893005,
          0.7360000014305115
        ],
        [
          0.671999990940094,
          0.7279999852180481
        ],
        [
          0.6840000152587891,
          0.7139999866485596
        ],
        [
          0.6880000233650208,
          0.7020000219345093
        ],
        [
          0.6899999976158142,
          0.6460000276565552
        ],
        [
          0.6840000152587891,
          0.621999979019165
        ],
        [
          0.6740000247955322,
          0.6140000224113464
        ],
        [
          0.6700000166893005,
          0.6039999723434448
        ],
        [
          0.6679999828338623,
          0.5659999847412109
        ],
        [
          0.6539999842643738,
          0.5540000200271606
        ],
        [
          0.6019999980926514,
          0.5540000200271606
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6240000128746033,
          0.5519999861717224
        ],
        [
          0.6200000047683716,
          0.5559999942779541
        ],
        [
          0.5659999847412109,
          0.5600000023841858
        ],
        [
          0.5479999780654907,
          0.5640000104904175
        ],
        [
          0.5460000038146973,
          0.5680000185966492
        ],
        [
          0.5339999794960022,
          0.5680000185966492
        ],
        [
          0.5040000081062317,
          0.5799999833106995
        ],
        [
          0.49000000953674316,
          0.593999981880188
        ],
        [
          0.4819999933242798,
          0.6179999709129333
        ],
        [
          0.4819999933242798,
          0.6359999775886536
        ],
        [
          0.4779999852180481,
          0.6380000114440918
        ],
        [
          0.47600001096725464,
          0.6600000262260437
        ],
        [
          0.4699999988079071,
          0.671999990940094
        ],
        [
          0.4659999907016754,
          0.6980000138282776
        ],
        [
          0.4620000123977661,
          0.699999988079071
        ],
        [
          0.4580000042915344,
          0.734000027179718
        ],
        [
          0.45399999618530273,
          0.7400000095367432
        ],
        [
          0.4560000002384186,
          0.7680000066757202
        ],
        [
          0.46799999475479126,
          0.7720000147819519
        ],
        [
          0.5820000171661377,
          0.7699999809265137
        ],
        [
          0.6079999804496765,
          0.7580000162124634
        ],
        [
          0.6119999885559082,
          0.7519999742507935
        ],
        [
          0.6320000290870667,
          0.7440000176429749
        ],
        [
          0.6340000033378601,
          0.7400000095367432
        ],
        [
          0.6439999938011169,
          0.7379999756813049
        ],
        [
          0.6639999747276306,
          0.7400000095367432
        ],
        [
          0.6779999732971191,
          0.722000002861023
        ],
        [
          0.6859999895095825,
          0.7179999947547913
        ],
        [
          0.6919999718666077,
          0.699999988079071
        ],
        [
          0.6919999718666077,
          0.6380000114440918
        ],
        [
          0.6859999895095825,
          0.621999979019165
        ],
        [
          0.6800000071525574,
          0.6200000047683716
        ],
        [
          0.671999990940094,
          0.6000000238418579
        ],
        [
          0.671999990940094,
          0.5860000252723694
        ],
        [
          0.6779999732971191,
          0.5799999833106995
        ],
        [
          0.6779999732971191,
          0.5740000009536743
        ],
        [
          0.671999990940094,
          0.5619999766349792
        ],
        [
          0.656000018119812,
          0.5559999942779541
        ],
        [
          0.6539999842643738,
          0.5519999861717224
        ],
        [
          0.6240000128746033,
          0.5519999861717224
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6119999885559082,
          0.5600000023841858
        ],
        [
          0.5740000009536743,
          0.5659999847412109
        ],
        [
          0.5619999766349792,
          0.5720000267028809
        ],
        [
          0.5400000214576721,
          0.5740000009536743
        ],
        [
          0.5199999809265137,
          0.5799999833106995
        ],
        [
          0.5019999742507935,
          0.5899999737739563
        ],
        [
          0.492000013589859,
          0.6019999980926514
        ],
        [
          0.49000000953674316,
          0.6119999885559082
        ],
        [
          0.48399999737739563,
          0.6159999966621399
        ],
        [
          0.4819999933242798,
          0.6620000004768372
        ],
        [
          0.47200000286102295,
          0.6819999814033508
        ],
        [
          0.46000000834465027,
          0.7440000176429749
        ],
        [
          0.46000000834465027,
          0.7639999985694885
        ],
        [
          0.46399998664855957,
          0.7720000147819519
        ],
        [
          0.49000000953674316,
          0.7820000052452087
        ],
        [
          0.5199999809265137,
          0.7820000052452087
        ],
        [
          0.527999997138977,
          0.7799999713897705
        ],
        [
          0.5299999713897705,
          0.7760000228881836
        ],
        [
          0.5559999942779541,
          0.7720000147819519
        ],
        [
          0.6200000047683716,
          0.7739999890327454
        ],
        [
          0.6380000114440918,
          0.7620000243186951
        ],
        [
          0.6499999761581421,
          0.7599999904632568
        ],
        [
          0.6679999828338623,
          0.7459999918937683
        ],
        [
          0.6700000166893005,
          0.7379999756813049
        ],
        [
          0.6759999990463257,
          0.734000027179718
        ],
        [
          0.6940000057220459,
          0.7020000219345093
        ],
        [
          0.6940000057220459,
          0.6359999775886536
        ],
        [
          0.6700000166893005,
          0.6039999723434448
        ],
        [
          0.6639999747276306,
          0.5799999833106995
        ],
        [
          0.6520000100135803,
          0.5659999847412109
        ],
        [
          0.628000020980835,
          0.5600000023841858
        ],
        [
          0.6119999885559082,
          0.5600000023841858
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6000000238418579,
          0.5680000185966492
        ],
        [
          0.527999997138977,
          0.5860000252723694
        ],
        [
          0.5180000066757202,
          0.593999981880188
        ],
        [
          0.5059999823570251,
          0.5960000157356262
        ],
        [
          0.4959999918937683,
          0.6100000143051147
        ],
        [
          0.49000000953674316,
          0.6119999885559082
        ],
        [
          0.4860000014305115,
          0.628000020980835
        ],
        [
          0.47999998927116394,
          0.6340000033378601
        ],
        [
          0.4779999852180481,
          0.6779999732971191
        ],
        [
          0.46399998664855957,
          0.7139999866485596
        ],
        [
          0.46399998664855957,
          0.7720000147819519
        ],
        [
          0.4779999852180481,
          0.7839999794960022
        ],
        [
          0.5059999823570251,
          0.7879999876022339
        ],
        [
          0.527999997138977,
          0.7839999794960022
        ],
        [
          0.5320000052452087,
          0.777999997138977
        ],
        [
          0.5519999861717224,
          0.7739999890327454
        ],
        [
          0.5699999928474426,
          0.7739999890327454
        ],
        [
          0.6000000238418579,
          0.7799999713897705
        ],
        [
          0.6320000290870667,
          0.777999997138977
        ],
        [
          0.6460000276565552,
          0.7720000147819519
        ],
        [
          0.6520000100135803,
          0.7639999985694885
        ],
        [
          0.6600000262260437,
          0.7620000243186951
        ],
        [
          0.6800000071525574,
          0.7360000014305115
        ],
        [
          0.6800000071525574,
          0.7319999933242798
        ],
        [
          0.6859999895095825,
          0.7279999852180481
        ],
        [
          0.6919999718666077,
          0.7080000042915344
        ],
        [
          0.6980000138282776,
          0.7020000219345093
        ],
        [
          0.7039999961853027,
          0.6800000071525574
        ],
        [
          0.7039999961853027,
          0.6480000019073486
        ],
        [
          0.6980000138282776,
          0.6340000033378601
        ],
        [
          0.6859999895095825,
          0.6240000128746033
        ],
        [
          0.6840000152587891,
          0.6179999709129333
        ],
        [
          0.6779999732971191,
          0.6159999966621399
        ],
        [
          0.671999990940094,
          0.5960000157356262
        ],
        [
          0.6679999828338623,
          0.593999981880188
        ],
        [
          0.6660000085830688,
          0.5820000171661377
        ],
        [
          0.6579999923706055,
          0.5759999752044678
        ],
        [
          0.6259999871253967,
          0.5680000185966492
        ],
        [
          0.6000000238418579,
          0.5680000185966492
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6019999980926514,
          0.5680000185966492
        ],
        [
          0.5879999995231628,
          0.5720000267028809
        ],
        [
          0.5860000252723694,
          0.5759999752044678
        ],
        [
          0.5440000295639038,
          0.5839999914169312
        ],
        [
          0.5419999957084656,
          0.5879999995231628
        ],
        [
          0.5220000147819519,
          0.593999981880188
        ],
        [
          0.5080000162124634,
          0.6019999980926514
        ],
        [
          0.4880000054836273,
          0.6240000128746033
        ],
        [
          0.47999998927116394,
          0.6460000276565552
        ],
        [
          0.4779999852180481,
          0.6800000071525574
        ],
        [
          0.4740000069141388,
          0.6819999814033508
        ],
        [
          0.46399998664855957,
          0.7239999771118164
        ],
        [
          0.4659999907016754,
          0.777999997138977
        ],
        [
          0.4819999933242798,
          0.7860000133514404
        ],
        [
          0.49799999594688416,
          0.7879999876022339
        ],
        [
          0.527999997138977,
          0.7839999794960022
        ],
        [
          0.5299999713897705,
          0.7799999713897705
        ],
        [
          0.5519999861717224,
          0.7760000228881836
        ],
        [
          0.5820000171661377,
          0.7760000228881836
        ],
        [
          0.6039999723434448,
          0.7799999713897705
        ],
        [
          0.6079999804496765,
          0.7839999794960022
        ],
        [
          0.628000020980835,
          0.7839999794960022
        ],
        [
          0.6299999952316284,
          0.7799999713897705
        ],
        [
          0.6460000276565552,
          0.7739999890327454
        ],
        [
          0.6679999828338623,
          0.7580000162124634
        ],
        [
          0.6880000233650208,
          0.7300000190734863
        ],
        [
          0.6919999718666077,
          0.7139999866485596
        ],
        [
          0.6959999799728394,
          0.7120000123977661
        ],
        [
          0.7020000219345093,
          0.6980000138282776
        ],
        [
          0.7059999704360962,
          0.6759999990463257
        ],
        [
          0.7099999785423279,
          0.6740000247955322
        ],
        [
          0.7099999785423279,
          0.6460000276565552
        ],
        [
          0.7059999704360962,
          0.6460000276565552
        ],
        [
          0.699999988079071,
          0.6200000047683716
        ],
        [
          0.6880000233650208,
          0.6119999885559082
        ],
        [
          0.6819999814033508,
          0.5920000076293945
        ],
        [
          0.6660000085830688,
          0.578000009059906
        ],
        [
          0.6299999952316284,
          0.5680000185966492
        ],
        [
          0.6019999980926514,
          0.5680000185966492
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.593999981880188,
          0.578000009059906
        ],
        [
          0.5419999957084656,
          0.5860000252723694
        ],
        [
          0.5400000214576721,
          0.5899999737739563
        ],
        [
          0.5180000066757202,
          0.593999981880188
        ],
        [
          0.5120000243186951,
          0.6000000238418579
        ],
        [
          0.5059999823570251,
          0.6000000238418579
        ],
        [
          0.492000013589859,
          0.6140000224113464
        ],
        [
          0.48399999737739563,
          0.6340000033378601
        ],
        [
          0.48399999737739563,
          0.6439999938011169
        ],
        [
          0.47999998927116394,
          0.6460000276565552
        ],
        [
          0.4779999852180481,
          0.6800000071525574
        ],
        [
          0.47200000286102295,
          0.6919999718666077
        ],
        [
          0.47200000286102295,
          0.699999988079071
        ],
        [
          0.46799999475479126,
          0.7020000219345093
        ],
        [
          0.46399998664855957,
          0.722000002861023
        ],
        [
          0.4620000123977661,
          0.7760000228881836
        ],
        [
          0.47200000286102295,
          0.7860000133514404
        ],
        [
          0.48399999737739563,
          0.7900000214576721
        ],
        [
          0.5120000243186951,
          0.7900000214576721
        ],
        [
          0.550000011920929,
          0.777999997138977
        ],
        [
          0.5799999833106995,
          0.777999997138977
        ],
        [
          0.6019999980926514,
          0.7820000052452087
        ],
        [
          0.6299999952316284,
          0.7799999713897705
        ],
        [
          0.6600000262260437,
          0.7639999985694885
        ],
        [
          0.6759999990463257,
          0.7480000257492065
        ],
        [
          0.6800000071525574,
          0.7379999756813049
        ],
        [
          0.6940000057220459,
          0.7200000286102295
        ],
        [
          0.6980000138282776,
          0.7099999785423279
        ],
        [
          0.6980000138282776,
          0.6840000152587891
        ],
        [
          0.7020000219345093,
          0.6819999814033508
        ],
        [
          0.7020000219345093,
          0.6480000019073486
        ],
        [
          0.6980000138282776,
          0.6480000019073486
        ],
        [
          0.6980000138282776,
          0.6340000033378601
        ],
        [
          0.6759999990463257,
          0.5960000157356262
        ],
        [
          0.6579999923706055,
          0.5899999737739563
        ],
        [
          0.656000018119812,
          0.5860000252723694
        ],
        [
          0.6380000114440918,
          0.5820000171661377
        ],
        [
          0.6179999709129333,
          0.578000009059906
        ],
        [
          0.593999981880188,
          0.578000009059906
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6079999804496765,
          0.5619999766349792
        ],
        [
          0.6060000061988831,
          0.5659999847412109
        ],
        [
          0.593999981880188,
          0.5680000185966492
        ],
        [
          0.5839999914169312,
          0.5720000267028809
        ],
        [
          0.5820000171661377,
          0.5759999752044678
        ],
        [
          0.5600000023841858,
          0.5820000171661377
        ],
        [
          0.5540000200271606,
          0.5879999995231628
        ],
        [
          0.5339999794960022,
          0.5920000076293945
        ],
        [
          0.5260000228881836,
          0.6000000238418579
        ],
        [
          0.5080000162124634,
          0.6079999804496765
        ],
        [
          0.4959999918937683,
          0.6200000047683716
        ],
        [
          0.492000013589859,
          0.6340000033378601
        ],
        [
          0.4860000014305115,
          0.6380000114440918
        ],
        [
          0.4819999933242798,
          0.6859999895095825
        ],
        [
          0.47600001096725464,
          0.6959999799728394
        ],
        [
          0.47200000286102295,
          0.7139999866485596
        ],
        [
          0.4740000069141388,
          0.7459999918937683
        ],
        [
          0.4819999933242798,
          0.7639999985694885
        ],
        [
          0.4959999918937683,
          0.7680000066757202
        ],
        [
          0.5059999823570251,
          0.7760000228881836
        ],
        [
          0.5239999890327454,
          0.7799999713897705
        ],
        [
          0.6299999952316284,
          0.7799999713897705
        ],
        [
          0.6639999747276306,
          0.7620000243186951
        ],
        [
          0.6819999814033508,
          0.7419999837875366
        ],
        [
          0.6940000057220459,
          0.7200000286102295
        ],
        [
          0.699999988079071,
          0.699999988079071
        ],
        [
          0.7039999961853027,
          0.6980000138282776
        ],
        [
          0.7059999704360962,
          0.6460000276565552
        ],
        [
          0.6880000233650208,
          0.6200000047683716
        ],
        [
          0.6800000071525574,
          0.6000000238418579
        ],
        [
          0.6639999747276306,
          0.5820000171661377
        ],
        [
          0.6439999938011169,
          0.5680000185966492
        ],
        [
          0.6299999952316284,
          0.5659999847412109
        ],
        [
          0.6259999871253967,
          0.5619999766349792
        ],
        [
          0.6079999804496765,
          0.5619999766349792
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6299999952316284,
          0.5740000009536743
        ],
        [
          0.6000000238418579,
          0.5799999833106995
        ],
        [
          0.593999981880188,
          0.5860000252723694
        ],
        [
          0.5740000009536743,
          0.5899999737739563
        ],
        [
          0.5680000185966492,
          0.5960000157356262
        ],
        [
          0.5460000038146973,
          0.6000000238418579
        ],
        [
          0.5440000295639038,
          0.6039999723434448
        ],
        [
          0.5339999794960022,
          0.6060000061988831
        ],
        [
          0.5,
          0.6399999856948853
        ],
        [
          0.49399998784065247,
          0.6639999747276306
        ],
        [
          0.492000013589859,
          0.6959999799728394
        ],
        [
          0.4880000054836273,
          0.699999988079071
        ],
        [
          0.4819999933242798,
          0.7239999771118164
        ],
        [
          0.4819999933242798,
          0.7480000257492065
        ],
        [
          0.4860000014305115,
          0.7580000162124634
        ],
        [
          0.5040000081062317,
          0.7620000243186951
        ],
        [
          0.5199999809265137,
          0.7760000228881836
        ],
        [
          0.5339999794960022,
          0.7820000052452087
        ],
        [
          0.5979999899864197,
          0.7820000052452087
        ],
        [
          0.6000000238418579,
          0.7860000133514404
        ],
        [
          0.6299999952316284,
          0.7879999876022339
        ],
        [
          0.6380000114440918,
          0.7799999713897705
        ],
        [
          0.6480000019073486,
          0.777999997138977
        ],
        [
          0.671999990940094,
          0.7599999904632568
        ],
        [
          0.6919999718666077,
          0.7379999756813049
        ],
        [
          0.699999988079071,
          0.722000002861023
        ],
        [
          0.699999988079071,
          0.7160000205039978
        ],
        [
          0.7039999961853027,
          0.7139999866485596
        ],
        [
          0.7139999866485596,
          0.6679999828338623
        ],
        [
          0.7179999947547913,
          0.6639999747276306
        ],
        [
          0.7179999947547913,
          0.6000000238418579
        ],
        [
          0.7139999866485596,
          0.5979999899864197
        ],
        [
          0.7099999785423279,
          0.5879999995231628
        ],
        [
          0.7039999961853027,
          0.5860000252723694
        ],
        [
          0.6940000057220459,
          0.5740000009536743
        ],
        [
          0.6299999952316284,
          0.5740000009536743
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6460000276565552,
          0.5799999833106995
        ],
        [
          0.6439999938011169,
          0.5839999914169312
        ],
        [
          0.6119999885559082,
          0.5860000252723694
        ],
        [
          0.6000000238418579,
          0.5899999737739563
        ],
        [
          0.5979999899864197,
          0.593999981880188
        ],
        [
          0.5740000009536743,
          0.6000000238418579
        ],
        [
          0.5720000267028809,
          0.6039999723434448
        ],
        [
          0.550000011920929,
          0.6060000061988831
        ],
        [
          0.5320000052452087,
          0.6119999885559082
        ],
        [
          0.5299999713897705,
          0.6159999966621399
        ],
        [
          0.515999972820282,
          0.6200000047683716
        ],
        [
          0.49399998784065247,
          0.6420000195503235
        ],
        [
          0.49399998784065247,
          0.6460000276565552
        ],
        [
          0.49000000953674316,
          0.6480000019073486
        ],
        [
          0.49000000953674316,
          0.6579999923706055
        ],
        [
          0.4860000014305115,
          0.6600000262260437
        ],
        [
          0.4779999852180481,
          0.7400000095367432
        ],
        [
          0.4740000069141388,
          0.7419999837875366
        ],
        [
          0.47200000286102295,
          0.7760000228881836
        ],
        [
          0.4779999852180481,
          0.7860000133514404
        ],
        [
          0.49000000953674316,
          0.7860000133514404
        ],
        [
          0.492000013589859,
          0.7900000214576721
        ],
        [
          0.5040000081062317,
          0.7919999957084656
        ],
        [
          0.5400000214576721,
          0.7919999957084656
        ],
        [
          0.5860000252723694,
          0.7820000052452087
        ],
        [
          0.6100000143051147,
          0.7820000052452087
        ],
        [
          0.6259999871253967,
          0.7860000133514404
        ],
        [
          0.6499999761581421,
          0.7799999713897705
        ],
        [
          0.6779999732971191,
          0.7559999823570251
        ],
        [
          0.6919999718666077,
          0.7360000014305115
        ],
        [
          0.6959999799728394,
          0.7239999771118164
        ],
        [
          0.699999988079071,
          0.722000002861023
        ],
        [
          0.7080000042915344,
          0.6919999718666077
        ],
        [
          0.7120000123977661,
          0.6899999976158142
        ],
        [
          0.7139999866485596,
          0.6399999856948853
        ],
        [
          0.7120000123977661,
          0.6320000290870667
        ],
        [
          0.7059999704360962,
          0.6259999871253967
        ],
        [
          0.7059999704360962,
          0.6200000047683716
        ],
        [
          0.6940000057220459,
          0.6100000143051147
        ],
        [
          0.6779999732971191,
          0.5860000252723694
        ],
        [
          0.6660000085830688,
          0.5839999914169312
        ],
        [
          0.6620000004768372,
          0.5799999833106995
        ],
        [
          0.6460000276565552,
          0.5799999833106995
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6359999775886536,
          0.5759999752044678
        ],
        [
          0.6140000224113464,
          0.5799999833106995
        ],
        [
          0.6119999885559082,
          0.5839999914169312
        ],
        [
          0.5899999737739563,
          0.5899999737739563
        ],
        [
          0.5879999995231628,
          0.593999981880188
        ],
        [
          0.5759999752044678,
          0.5979999899864197
        ],
        [
          0.5559999942779541,
          0.6000000238418579
        ],
        [
          0.5540000200271606,
          0.6039999723434448
        ],
        [
          0.5360000133514404,
          0.6100000143051147
        ],
        [
          0.5320000052452087,
          0.6159999966621399
        ],
        [
          0.5220000147819519,
          0.6179999709129333
        ],
        [
          0.5,
          0.6420000195503235
        ],
        [
          0.49399998784065247,
          0.6679999828338623
        ],
        [
          0.49000000953674316,
          0.6700000166893005
        ],
        [
          0.48399999737739563,
          0.7099999785423279
        ],
        [
          0.48399999737739563,
          0.7620000243186951
        ],
        [
          0.5080000162124634,
          0.7760000228881836
        ],
        [
          0.5099999904632568,
          0.7820000052452087
        ],
        [
          0.5239999890327454,
          0.7860000133514404
        ],
        [
          0.527999997138977,
          0.7900000214576721
        ],
        [
          0.5580000281333923,
          0.7900000214576721
        ],
        [
          0.5600000023841858,
          0.7860000133514404
        ],
        [
          0.5899999737739563,
          0.7839999794960022
        ],
        [
          0.6179999709129333,
          0.7940000295639038
        ],
        [
          0.6439999938011169,
          0.7900000214576721
        ],
        [
          0.6460000276565552,
          0.7860000133514404
        ],
        [
          0.6579999923706055,
          0.7820000052452087
        ],
        [
          0.671999990940094,
          0.7699999809265137
        ],
        [
          0.6919999718666077,
          0.7459999918937683
        ],
        [
          0.6959999799728394,
          0.7360000014305115
        ],
        [
          0.7020000219345093,
          0.7319999933242798
        ],
        [
          0.7099999785423279,
          0.7039999961853027
        ],
        [
          0.7160000205039978,
          0.6980000138282776
        ],
        [
          0.7200000286102295,
          0.6679999828338623
        ],
        [
          0.7239999771118164,
          0.6660000085830688
        ],
        [
          0.7239999771118164,
          0.6320000290870667
        ],
        [
          0.7200000286102295,
          0.6299999952316284
        ],
        [
          0.7200000286102295,
          0.6100000143051147
        ],
        [
          0.7139999866485596,
          0.6000000238418579
        ],
        [
          0.6959999799728394,
          0.5960000157356262
        ],
        [
          0.6779999732971191,
          0.5799999833106995
        ],
        [
          0.6579999923706055,
          0.5759999752044678
        ],
        [
          0.6359999775886536,
          0.5759999752044678
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6259999871253967,
          0.5820000171661377
        ],
        [
          0.5979999899864197,
          0.5879999995231628
        ],
        [
          0.5960000157356262,
          0.5920000076293945
        ],
        [
          0.5519999861717224,
          0.5979999899864197
        ],
        [
          0.5479999780654907,
          0.6039999723434448
        ],
        [
          0.5440000295639038,
          0.6039999723434448
        ],
        [
          0.5320000052452087,
          0.6140000224113464
        ],
        [
          0.5180000066757202,
          0.6299999952316284
        ],
        [
          0.5139999985694885,
          0.6439999938011169
        ],
        [
          0.5059999823570251,
          0.6480000019073486
        ],
        [
          0.5059999823570251,
          0.6679999828338623
        ],
        [
          0.5040000081062317,
          0.6759999990463257
        ],
        [
          0.5,
          0.6779999732971191
        ],
        [
          0.4959999918937683,
          0.6980000138282776
        ],
        [
          0.49399998784065247,
          0.7160000205039978
        ],
        [
          0.4959999918937683,
          0.7360000014305115
        ],
        [
          0.492000013589859,
          0.7639999985694885
        ],
        [
          0.4959999918937683,
          0.7799999713897705
        ],
        [
          0.5059999823570251,
          0.7879999876022339
        ],
        [
          0.5360000133514404,
          0.7900000214576721
        ],
        [
          0.5580000281333923,
          0.7860000133514404
        ],
        [
          0.5820000171661377,
          0.7860000133514404
        ],
        [
          0.5960000157356262,
          0.7879999876022339
        ],
        [
          0.6100000143051147,
          0.7960000038146973
        ],
        [
          0.6359999775886536,
          0.7960000038146973
        ],
        [
          0.6620000004768372,
          0.7799999713897705
        ],
        [
          0.6940000057220459,
          0.7459999918937683
        ],
        [
          0.699999988079071,
          0.7300000190734863
        ],
        [
          0.7059999704360962,
          0.7239999771118164
        ],
        [
          0.7160000205039978,
          0.6940000057220459
        ],
        [
          0.7179999947547913,
          0.656000018119812
        ],
        [
          0.7139999866485596,
          0.6399999856948853
        ],
        [
          0.699999988079071,
          0.6259999871253967
        ],
        [
          0.6919999718666077,
          0.6039999723434448
        ],
        [
          0.6800000071525574,
          0.5920000076293945
        ],
        [
          0.6800000071525574,
          0.5879999995231628
        ],
        [
          0.6639999747276306,
          0.5820000171661377
        ],
        [
          0.6259999871253967,
          0.5820000171661377
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6200000047683716,
          0.5799999833106995
        ],
        [
          0.6119999885559082,
          0.5820000171661377
        ],
        [
          0.6100000143051147,
          0.5860000252723694
        ],
        [
          0.5879999995231628,
          0.5920000076293945
        ],
        [
          0.5860000252723694,
          0.5960000157356262
        ],
        [
          0.5540000200271606,
          0.6019999980926514
        ],
        [
          0.527999997138977,
          0.6179999709129333
        ],
        [
          0.5199999809265137,
          0.6399999856948853
        ],
        [
          0.5099999904632568,
          0.656000018119812
        ],
        [
          0.5099999904632568,
          0.6679999828338623
        ],
        [
          0.5059999823570251,
          0.6700000166893005
        ],
        [
          0.5,
          0.7319999933242798
        ],
        [
          0.4959999918937683,
          0.734000027179718
        ],
        [
          0.4880000054836273,
          0.7620000243186951
        ],
        [
          0.4779999852180481,
          0.7739999890327454
        ],
        [
          0.4779999852180481,
          0.8119999766349792
        ],
        [
          0.5040000081062317,
          0.8119999766349792
        ],
        [
          0.5099999904632568,
          0.8040000200271606
        ],
        [
          0.527999997138977,
          0.800000011920929
        ],
        [
          0.5379999876022339,
          0.7940000295639038
        ],
        [
          0.5540000200271606,
          0.7919999957084656
        ],
        [
          0.6340000033378601,
          0.7940000295639038
        ],
        [
          0.6639999747276306,
          0.7799999713897705
        ],
        [
          0.6859999895095825,
          0.7599999904632568
        ],
        [
          0.6919999718666077,
          0.7440000176429749
        ],
        [
          0.6980000138282776,
          0.7400000095367432
        ],
        [
          0.7020000219345093,
          0.7260000109672546
        ],
        [
          0.7059999704360962,
          0.7239999771118164
        ],
        [
          0.7120000123977661,
          0.6959999799728394
        ],
        [
          0.7160000205039978,
          0.6940000057220459
        ],
        [
          0.7179999947547913,
          0.6859999895095825
        ],
        [
          0.722000002861023,
          0.6499999761581421
        ],
        [
          0.7160000205039978,
          0.628000020980835
        ],
        [
          0.7120000123977661,
          0.6259999871253967
        ],
        [
          0.7120000123977661,
          0.6200000047683716
        ],
        [
          0.699999988079071,
          0.6140000224113464
        ],
        [
          0.6980000138282776,
          0.6060000061988831
        ],
        [
          0.6700000166893005,
          0.5820000171661377
        ],
        [
          0.6200000047683716,
          0.5799999833106995
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6299999952316284,
          0.5860000252723694
        ],
        [
          0.5860000252723694,
          0.5979999899864197
        ],
        [
          0.5759999752044678,
          0.6060000061988831
        ],
        [
          0.5640000104904175,
          0.6079999804496765
        ],
        [
          0.5600000023841858,
          0.6140000224113464
        ],
        [
          0.5360000133514404,
          0.6179999709129333
        ],
        [
          0.5360000133514404,
          0.6240000128746033
        ],
        [
          0.527999997138977,
          0.6259999871253967
        ],
        [
          0.5180000066757202,
          0.6359999775886536
        ],
        [
          0.5139999985694885,
          0.6460000276565552
        ],
        [
          0.5080000162124634,
          0.6460000276565552
        ],
        [
          0.5059999823570251,
          0.6840000152587891
        ],
        [
          0.5040000081062317,
          0.6940000057220459
        ],
        [
          0.5,
          0.6959999799728394
        ],
        [
          0.5,
          0.7139999866485596
        ],
        [
          0.49399998784065247,
          0.7459999918937683
        ],
        [
          0.492000013589859,
          0.7540000081062317
        ],
        [
          0.48399999737739563,
          0.7639999985694885
        ],
        [
          0.4819999933242798,
          0.7739999890327454
        ],
        [
          0.47600001096725464,
          0.777999997138977
        ],
        [
          0.47600001096725464,
          0.8140000104904175
        ],
        [
          0.48399999737739563,
          0.8180000185966492
        ],
        [
          0.492000013589859,
          0.8159999847412109
        ],
        [
          0.5,
          0.8080000281333923
        ],
        [
          0.5040000081062317,
          0.8080000281333923
        ],
        [
          0.5080000162124634,
          0.800000011920929
        ],
        [
          0.5759999752044678,
          0.7979999780654907
        ],
        [
          0.5960000157356262,
          0.800000011920929
        ],
        [
          0.5979999899864197,
          0.8040000200271606
        ],
        [
          0.6140000224113464,
          0.8040000200271606
        ],
        [
          0.6159999966621399,
          0.800000011920929
        ],
        [
          0.6399999856948853,
          0.7960000038146973
        ],
        [
          0.6439999938011169,
          0.7900000214576721
        ],
        [
          0.6579999923706055,
          0.7860000133514404
        ],
        [
          0.6819999814033508,
          0.7599999904632568
        ],
        [
          0.6859999895095825,
          0.75
        ],
        [
          0.6940000057220459,
          0.7440000176429749
        ],
        [
          0.699999988079071,
          0.7279999852180481
        ],
        [
          0.7039999961853027,
          0.7260000109672546
        ],
        [
          0.7099999785423279,
          0.7059999704360962
        ],
        [
          0.7139999866485596,
          0.7039999961853027
        ],
        [
          0.7179999947547913,
          0.6880000233650208
        ],
        [
          0.7179999947547913,
          0.6480000019073486
        ],
        [
          0.7139999866485596,
          0.6359999775886536
        ],
        [
          0.7099999785423279,
          0.6340000033378601
        ],
        [
          0.7080000042915344,
          0.6259999871253967
        ],
        [
          0.6980000138282776,
          0.6159999966621399
        ],
        [
          0.6959999799728394,
          0.6079999804496765
        ],
        [
          0.6859999895095825,
          0.5960000157356262
        ],
        [
          0.6740000247955322,
          0.5920000076293945
        ],
        [
          0.671999990940094,
          0.5879999995231628
        ],
        [
          0.6299999952316284,
          0.5860000252723694
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6159999966621399,
          0.593999981880188
        ],
        [
          0.6019999980926514,
          0.5979999899864197
        ],
        [
          0.6000000238418579,
          0.6019999980926514
        ],
        [
          0.5899999737739563,
          0.6060000061988831
        ],
        [
          0.5799999833106995,
          0.6060000061988831
        ],
        [
          0.5720000267028809,
          0.6079999804496765
        ],
        [
          0.5699999928474426,
          0.6119999885559082
        ],
        [
          0.5460000038146973,
          0.6159999966621399
        ],
        [
          0.5419999957084656,
          0.6200000047683716
        ],
        [
          0.5320000052452087,
          0.6200000047683716
        ],
        [
          0.5059999823570251,
          0.6399999856948853
        ],
        [
          0.5059999823570251,
          0.6959999799728394
        ],
        [
          0.5,
          0.7020000219345093
        ],
        [
          0.49799999594688416,
          0.7160000205039978
        ],
        [
          0.49399998784065247,
          0.722000002861023
        ],
        [
          0.492000013589859,
          0.7440000176429749
        ],
        [
          0.4880000054836273,
          0.7459999918937683
        ],
        [
          0.4819999933242798,
          0.7639999985694885
        ],
        [
          0.46799999475479126,
          0.7760000228881836
        ],
        [
          0.46399998664855957,
          0.7860000133514404
        ],
        [
          0.46399998664855957,
          0.8240000009536743
        ],
        [
          0.47200000286102295,
          0.8320000171661377
        ],
        [
          0.4880000054836273,
          0.8360000252723694
        ],
        [
          0.492000013589859,
          0.8399999737739563
        ],
        [
          0.5640000104904175,
          0.8420000076293945
        ],
        [
          0.5720000267028809,
          0.8399999737739563
        ],
        [
          0.5740000009536743,
          0.8360000252723694
        ],
        [
          0.6019999980926514,
          0.8299999833106995
        ],
        [
          0.6039999723434448,
          0.8259999752044678
        ],
        [
          0.6100000143051147,
          0.8259999752044678
        ],
        [
          0.6340000033378601,
          0.8140000104904175
        ],
        [
          0.6380000114440918,
          0.8080000281333923
        ],
        [
          0.6460000276565552,
          0.8059999942779541
        ],
        [
          0.6700000166893005,
          0.7839999794960022
        ],
        [
          0.6759999990463257,
          0.7820000052452087
        ],
        [
          0.6959999799728394,
          0.7559999823570251
        ],
        [
          0.7020000219345093,
          0.7400000095367432
        ],
        [
          0.7059999704360962,
          0.7379999756813049
        ],
        [
          0.7139999866485596,
          0.7080000042915344
        ],
        [
          0.7179999947547913,
          0.7059999704360962
        ],
        [
          0.7200000286102295,
          0.6460000276565552
        ],
        [
          0.7099999785423279,
          0.6320000290870667
        ],
        [
          0.7020000219345093,
          0.6299999952316284
        ],
        [
          0.699999988079071,
          0.621999979019165
        ],
        [
          0.6859999895095825,
          0.6060000061988831
        ],
        [
          0.6700000166893005,
          0.5979999899864197
        ],
        [
          0.6539999842643738,
          0.593999981880188
        ],
        [
          0.6159999966621399,
          0.593999981880188
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6340000033378601,
          0.5920000076293945
        ],
        [
          0.6039999723434448,
          0.5979999899864197
        ],
        [
          0.6019999980926514,
          0.6019999980926514
        ],
        [
          0.5820000171661377,
          0.6039999723434448
        ],
        [
          0.5699999928474426,
          0.6079999804496765
        ],
        [
          0.5680000185966492,
          0.6119999885559082
        ],
        [
          0.550000011920929,
          0.6159999966621399
        ],
        [
          0.5479999780654907,
          0.6200000047683716
        ],
        [
          0.5379999876022339,
          0.6200000047683716
        ],
        [
          0.5360000133514404,
          0.6259999871253967
        ],
        [
          0.5320000052452087,
          0.6259999871253967
        ],
        [
          0.5180000066757202,
          0.6399999856948853
        ],
        [
          0.5139999985694885,
          0.6499999761581421
        ],
        [
          0.5080000162124634,
          0.6499999761581421
        ],
        [
          0.5059999823570251,
          0.7020000219345093
        ],
        [
          0.5040000081062317,
          0.7099999785423279
        ],
        [
          0.5,
          0.7120000123977661
        ],
        [
          0.49399998784065247,
          0.7459999918937683
        ],
        [
          0.4880000054836273,
          0.75
        ],
        [
          0.4860000014305115,
          0.7580000162124634
        ],
        [
          0.4659999907016754,
          0.7820000052452087
        ],
        [
          0.46000000834465027,
          0.7979999780654907
        ],
        [
          0.4620000123977661,
          0.8299999833106995
        ],
        [
          0.4740000069141388,
          0.8360000252723694
        ],
        [
          0.4779999852180481,
          0.8420000076293945
        ],
        [
          0.5299999713897705,
          0.8460000157356262
        ],
        [
          0.5320000052452087,
          0.8500000238418579
        ],
        [
          0.5519999861717224,
          0.8500000238418579
        ],
        [
          0.5559999942779541,
          0.8460000157356262
        ],
        [
          0.5680000185966492,
          0.8460000157356262
        ],
        [
          0.5899999737739563,
          0.8399999737739563
        ],
        [
          0.5920000076293945,
          0.8360000252723694
        ],
        [
          0.6119999885559082,
          0.8299999833106995
        ],
        [
          0.6140000224113464,
          0.8259999752044678
        ],
        [
          0.6259999871253967,
          0.8220000267028809
        ],
        [
          0.6499999761581421,
          0.8040000200271606
        ],
        [
          0.6539999842643738,
          0.8040000200271606
        ],
        [
          0.6880000233650208,
          0.7739999890327454
        ],
        [
          0.7099999785423279,
          0.7459999918937683
        ],
        [
          0.722000002861023,
          0.7200000286102295
        ],
        [
          0.7239999771118164,
          0.7020000219345093
        ],
        [
          0.7279999852180481,
          0.699999988079071
        ],
        [
          0.7279999852180481,
          0.6499999761581421
        ],
        [
          0.7239999771118164,
          0.6499999761581421
        ],
        [
          0.7200000286102295,
          0.6340000033378601
        ],
        [
          0.7139999866485596,
          0.6299999952316284
        ],
        [
          0.7099999785423279,
          0.6200000047683716
        ],
        [
          0.6899999976158142,
          0.6039999723434448
        ],
        [
          0.6639999747276306,
          0.5920000076293945
        ],
        [
          0.6340000033378601,
          0.5920000076293945
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6200000047683716,
          0.5839999914169312
        ],
        [
          0.5979999899864197,
          0.5879999995231628
        ],
        [
          0.5920000076293945,
          0.593999981880188
        ],
        [
          0.578000009059906,
          0.5960000157356262
        ],
        [
          0.5540000200271606,
          0.6119999885559082
        ],
        [
          0.5339999794960022,
          0.6200000047683716
        ],
        [
          0.5139999985694885,
          0.6439999938011169
        ],
        [
          0.5080000162124634,
          0.6579999923706055
        ],
        [
          0.5080000162124634,
          0.6800000071525574
        ],
        [
          0.5120000243186951,
          0.6819999814033508
        ],
        [
          0.5120000243186951,
          0.6980000138282776
        ],
        [
          0.5080000162124634,
          0.699999988079071
        ],
        [
          0.5080000162124634,
          0.7239999771118164
        ],
        [
          0.5040000081062317,
          0.7260000109672546
        ],
        [
          0.5040000081062317,
          0.7540000081062317
        ],
        [
          0.4959999918937683,
          0.7720000147819519
        ],
        [
          0.4880000054836273,
          0.7799999713897705
        ],
        [
          0.4880000054836273,
          0.8100000023841858
        ],
        [
          0.49799999594688416,
          0.8119999766349792
        ],
        [
          0.5040000081062317,
          0.8080000281333923
        ],
        [
          0.5419999957084656,
          0.8059999942779541
        ],
        [
          0.5440000295639038,
          0.8019999861717224
        ],
        [
          0.5699999928474426,
          0.8019999861717224
        ],
        [
          0.5740000009536743,
          0.8080000281333923
        ],
        [
          0.5820000171661377,
          0.8080000281333923
        ],
        [
          0.5879999995231628,
          0.8119999766349792
        ],
        [
          0.6060000061988831,
          0.8119999766349792
        ],
        [
          0.6079999804496765,
          0.8159999847412109
        ],
        [
          0.6119999885559082,
          0.8159999847412109
        ],
        [
          0.6140000224113464,
          0.8119999766349792
        ],
        [
          0.6340000033378601,
          0.8080000281333923
        ],
        [
          0.6399999856948853,
          0.8019999861717224
        ],
        [
          0.6579999923706055,
          0.7960000038146973
        ],
        [
          0.6899999976158142,
          0.7639999985694885
        ],
        [
          0.6919999718666077,
          0.7559999823570251
        ],
        [
          0.6980000138282776,
          0.7519999742507935
        ],
        [
          0.7039999961853027,
          0.7360000014305115
        ],
        [
          0.7080000042915344,
          0.734000027179718
        ],
        [
          0.722000002861023,
          0.6899999976158142
        ],
        [
          0.7239999771118164,
          0.6579999923706055
        ],
        [
          0.7200000286102295,
          0.6439999938011169
        ],
        [
          0.7039999961853027,
          0.6259999871253967
        ],
        [
          0.7039999961853027,
          0.621999979019165
        ],
        [
          0.6919999718666077,
          0.6060000061988831
        ],
        [
          0.6700000166893005,
          0.5879999995231628
        ],
        [
          0.6480000019073486,
          0.5839999914169312
        ],
        [
          0.6200000047683716,
          0.5839999914169312
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6240000128746033,
          0.5820000171661377
        ],
        [
          0.5640000104904175,
          0.6019999980926514
        ],
        [
          0.5619999766349792,
          0.6060000061988831
        ],
        [
          0.5400000214576721,
          0.6179999709129333
        ],
        [
          0.5120000243186951,
          0.6460000276565552
        ],
        [
          0.5059999823570251,
          0.6660000085830688
        ],
        [
          0.5040000081062317,
          0.7639999985694885
        ],
        [
          0.5,
          0.765999972820282
        ],
        [
          0.4880000054836273,
          0.7900000214576721
        ],
        [
          0.4880000054836273,
          0.8140000104904175
        ],
        [
          0.49799999594688416,
          0.8220000267028809
        ],
        [
          0.5059999823570251,
          0.8140000104904175
        ],
        [
          0.5120000243186951,
          0.8140000104904175
        ],
        [
          0.515999972820282,
          0.8100000023841858
        ],
        [
          0.5379999876022339,
          0.8059999942779541
        ],
        [
          0.578000009059906,
          0.8059999942779541
        ],
        [
          0.6060000061988831,
          0.8100000023841858
        ],
        [
          0.6100000143051147,
          0.8140000104904175
        ],
        [
          0.6240000128746033,
          0.8140000104904175
        ],
        [
          0.6259999871253967,
          0.8100000023841858
        ],
        [
          0.6439999938011169,
          0.8059999942779541
        ],
        [
          0.6460000276565552,
          0.8019999861717224
        ],
        [
          0.6520000100135803,
          0.8019999861717224
        ],
        [
          0.6639999747276306,
          0.7960000038146973
        ],
        [
          0.6700000166893005,
          0.7879999876022339
        ],
        [
          0.6740000247955322,
          0.7879999876022339
        ],
        [
          0.6959999799728394,
          0.765999972820282
        ],
        [
          0.699999988079071,
          0.7559999823570251
        ],
        [
          0.7160000205039978,
          0.7379999756813049
        ],
        [
          0.722000002861023,
          0.7179999947547913
        ],
        [
          0.7260000109672546,
          0.7139999866485596
        ],
        [
          0.7300000190734863,
          0.6940000057220459
        ],
        [
          0.7319999933242798,
          0.6600000262260437
        ],
        [
          0.7279999852180481,
          0.6439999938011169
        ],
        [
          0.6840000152587891,
          0.5920000076293945
        ],
        [
          0.6579999923706055,
          0.5820000171661377
        ],
        [
          0.6240000128746033,
          0.5820000171661377
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6340000033378601,
          0.5879999995231628
        ],
        [
          0.6200000047683716,
          0.5899999737739563
        ],
        [
          0.6159999966621399,
          0.593999981880188
        ],
        [
          0.6000000238418579,
          0.5979999899864197
        ],
        [
          0.5720000267028809,
          0.6000000238418579
        ],
        [
          0.5699999928474426,
          0.6039999723434448
        ],
        [
          0.5640000104904175,
          0.6039999723434448
        ],
        [
          0.5479999780654907,
          0.6140000224113464
        ],
        [
          0.5199999809265137,
          0.6439999938011169
        ],
        [
          0.5099999904632568,
          0.6499999761581421
        ],
        [
          0.5,
          0.6919999718666077
        ],
        [
          0.49799999594688416,
          0.7559999823570251
        ],
        [
          0.47999998927116394,
          0.7860000133514404
        ],
        [
          0.47600001096725464,
          0.800000011920929
        ],
        [
          0.47200000286102295,
          0.8019999861717224
        ],
        [
          0.47200000286102295,
          0.8220000267028809
        ],
        [
          0.4819999933242798,
          0.8360000252723694
        ],
        [
          0.492000013589859,
          0.8399999737739563
        ],
        [
          0.5759999752044678,
          0.8399999737739563
        ],
        [
          0.5960000157356262,
          0.8339999914169312
        ],
        [
          0.6060000061988831,
          0.8220000267028809
        ],
        [
          0.6240000128746033,
          0.8180000185966492
        ],
        [
          0.6259999871253967,
          0.8140000104904175
        ],
        [
          0.6439999938011169,
          0.8080000281333923
        ],
        [
          0.656000018119812,
          0.7960000038146973
        ],
        [
          0.6639999747276306,
          0.7940000295639038
        ],
        [
          0.6940000057220459,
          0.7639999985694885
        ],
        [
          0.699999988079071,
          0.75
        ],
        [
          0.7039999961853027,
          0.7480000257492065
        ],
        [
          0.7099999785423279,
          0.7300000190734863
        ],
        [
          0.7139999866485596,
          0.7279999852180481
        ],
        [
          0.7200000286102295,
          0.7039999961853027
        ],
        [
          0.7239999771118164,
          0.7020000219345093
        ],
        [
          0.7279999852180481,
          0.6840000152587891
        ],
        [
          0.7279999852180481,
          0.656000018119812
        ],
        [
          0.7239999771118164,
          0.6420000195503235
        ],
        [
          0.6899999976158142,
          0.6000000238418579
        ],
        [
          0.6639999747276306,
          0.5879999995231628
        ],
        [
          0.6340000033378601,
          0.5879999995231628
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6480000019073486,
          0.5860000252723694
        ],
        [
          0.6140000224113464,
          0.5899999737739563
        ],
        [
          0.6119999885559082,
          0.593999981880188
        ],
        [
          0.593999981880188,
          0.5979999899864197
        ],
        [
          0.5920000076293945,
          0.6019999980926514
        ],
        [
          0.5799999833106995,
          0.6060000061988831
        ],
        [
          0.5659999847412109,
          0.6159999966621399
        ],
        [
          0.5659999847412109,
          0.6200000047683716
        ],
        [
          0.5260000228881836,
          0.6579999923706055
        ],
        [
          0.5199999809265137,
          0.6800000071525574
        ],
        [
          0.515999972820282,
          0.6819999814033508
        ],
        [
          0.515999972820282,
          0.6899999976158142
        ],
        [
          0.5120000243186951,
          0.6919999718666077
        ],
        [
          0.5099999904632568,
          0.7300000190734863
        ],
        [
          0.5059999823570251,
          0.7319999933242798
        ],
        [
          0.5059999823570251,
          0.7480000257492065
        ],
        [
          0.4819999933242798,
          0.7900000214576721
        ],
        [
          0.47600001096725464,
          0.7940000295639038
        ],
        [
          0.47200000286102295,
          0.8119999766349792
        ],
        [
          0.46799999475479126,
          0.8159999847412109
        ],
        [
          0.47200000286102295,
          0.8240000009536743
        ],
        [
          0.47200000286102295,
          0.8360000252723694
        ],
        [
          0.4880000054836273,
          0.8539999723434448
        ],
        [
          0.5619999766349792,
          0.8560000061988831
        ],
        [
          0.5860000252723694,
          0.8500000238418579
        ],
        [
          0.5899999737739563,
          0.8460000157356262
        ],
        [
          0.6039999723434448,
          0.8420000076293945
        ],
        [
          0.6060000061988831,
          0.8379999995231628
        ],
        [
          0.621999979019165,
          0.8339999914169312
        ],
        [
          0.6240000128746033,
          0.8299999833106995
        ],
        [
          0.6600000262260437,
          0.8100000023841858
        ],
        [
          0.671999990940094,
          0.7960000038146973
        ],
        [
          0.6800000071525574,
          0.7919999957084656
        ],
        [
          0.6899999976158142,
          0.777999997138977
        ],
        [
          0.6980000138282776,
          0.7739999890327454
        ],
        [
          0.6980000138282776,
          0.7699999809265137
        ],
        [
          0.7179999947547913,
          0.7480000257492065
        ],
        [
          0.7300000190734863,
          0.7239999771118164
        ],
        [
          0.734000027179718,
          0.7080000042915344
        ],
        [
          0.734000027179718,
          0.6819999814033508
        ],
        [
          0.7379999756813049,
          0.6800000071525574
        ],
        [
          0.7379999756813049,
          0.671999990940094
        ],
        [
          0.734000027179718,
          0.6700000166893005
        ],
        [
          0.734000027179718,
          0.6499999761581421
        ],
        [
          0.7300000190734863,
          0.6380000114440918
        ],
        [
          0.699999988079071,
          0.6039999723434448
        ],
        [
          0.6919999718666077,
          0.6019999980926514
        ],
        [
          0.6880000233650208,
          0.5960000157356262
        ],
        [
          0.6800000071525574,
          0.593999981880188
        ],
        [
          0.6779999732971191,
          0.5899999737739563
        ],
        [
          0.6480000019073486,
          0.5860000252723694
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6439999938011169,
          0.5899999737739563
        ],
        [
          0.6420000195503235,
          0.593999981880188
        ],
        [
          0.6079999804496765,
          0.5979999899864197
        ],
        [
          0.6060000061988831,
          0.6019999980926514
        ],
        [
          0.5879999995231628,
          0.6039999723434448
        ],
        [
          0.5820000171661377,
          0.6100000143051147
        ],
        [
          0.5640000104904175,
          0.6140000224113464
        ],
        [
          0.5519999861717224,
          0.6299999952316284
        ],
        [
          0.5479999780654907,
          0.6299999952316284
        ],
        [
          0.5419999957084656,
          0.6359999775886536
        ],
        [
          0.5419999957084656,
          0.6439999938011169
        ],
        [
          0.5360000133514404,
          0.6499999761581421
        ],
        [
          0.5220000147819519,
          0.699999988079071
        ],
        [
          0.5180000066757202,
          0.7020000219345093
        ],
        [
          0.5180000066757202,
          0.7080000042915344
        ],
        [
          0.5139999985694885,
          0.7099999785423279
        ],
        [
          0.5120000243186951,
          0.7160000205039978
        ],
        [
          0.5120000243186951,
          0.734000027179718
        ],
        [
          0.5080000162124634,
          0.7379999756813049
        ],
        [
          0.5040000081062317,
          0.7559999823570251
        ],
        [
          0.47999998927116394,
          0.7879999876022339
        ],
        [
          0.47600001096725464,
          0.7979999780654907
        ],
        [
          0.47600001096725464,
          0.8320000171661377
        ],
        [
          0.4860000014305115,
          0.843999981880188
        ],
        [
          0.5040000081062317,
          0.8479999899864197
        ],
        [
          0.5059999823570251,
          0.8519999980926514
        ],
        [
          0.5759999752044678,
          0.8519999980926514
        ],
        [
          0.578000009059906,
          0.8479999899864197
        ],
        [
          0.5960000157356262,
          0.843999981880188
        ],
        [
          0.5979999899864197,
          0.8399999737739563
        ],
        [
          0.6119999885559082,
          0.8360000252723694
        ],
        [
          0.6140000224113464,
          0.8320000171661377
        ],
        [
          0.6299999952316284,
          0.828000009059906
        ],
        [
          0.6460000276565552,
          0.8140000104904175
        ],
        [
          0.6600000262260437,
          0.8080000281333923
        ],
        [
          0.7059999704360962,
          0.7639999985694885
        ],
        [
          0.7059999704360962,
          0.7599999904632568
        ],
        [
          0.7200000286102295,
          0.7440000176429749
        ],
        [
          0.7260000109672546,
          0.7239999771118164
        ],
        [
          0.7300000190734863,
          0.722000002861023
        ],
        [
          0.7319999933242798,
          0.7099999785423279
        ],
        [
          0.7319999933242798,
          0.6679999828338623
        ],
        [
          0.7300000190734863,
          0.6600000262260437
        ],
        [
          0.7260000109672546,
          0.6579999923706055
        ],
        [
          0.7260000109672546,
          0.6460000276565552
        ],
        [
          0.722000002861023,
          0.6420000195503235
        ],
        [
          0.7200000286102295,
          0.628000020980835
        ],
        [
          0.7020000219345093,
          0.6039999723434448
        ],
        [
          0.6940000057220459,
          0.6019999980926514
        ],
        [
          0.6899999976158142,
          0.5960000157356262
        ],
        [
          0.6740000247955322,
          0.593999981880188
        ],
        [
          0.671999990940094,
          0.5899999737739563
        ],
        [
          0.6439999938011169,
          0.5899999737739563
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6380000114440918,
          0.5899999737739563
        ],
        [
          0.6140000224113464,
          0.5920000076293945
        ],
        [
          0.6119999885559082,
          0.5960000157356262
        ],
        [
          0.5899999737739563,
          0.6000000238418579
        ],
        [
          0.5799999833106995,
          0.6060000061988831
        ],
        [
          0.5580000281333923,
          0.6240000128746033
        ],
        [
          0.5460000038146973,
          0.6480000019073486
        ],
        [
          0.5419999957084656,
          0.6480000019073486
        ],
        [
          0.5320000052452087,
          0.6980000138282776
        ],
        [
          0.527999997138977,
          0.699999988079071
        ],
        [
          0.5239999890327454,
          0.7160000205039978
        ],
        [
          0.5199999809265137,
          0.7179999947547913
        ],
        [
          0.515999972820282,
          0.7480000257492065
        ],
        [
          0.5099999904632568,
          0.75
        ],
        [
          0.5080000162124634,
          0.7639999985694885
        ],
        [
          0.47200000286102295,
          0.800000011920929
        ],
        [
          0.46399998664855957,
          0.8159999847412109
        ],
        [
          0.46399998664855957,
          0.8399999737739563
        ],
        [
          0.4819999933242798,
          0.8579999804496765
        ],
        [
          0.5540000200271606,
          0.8600000143051147
        ],
        [
          0.5979999899864197,
          0.8479999899864197
        ],
        [
          0.6000000238418579,
          0.843999981880188
        ],
        [
          0.6299999952316284,
          0.8320000171661377
        ],
        [
          0.6520000100135803,
          0.8159999847412109
        ],
        [
          0.656000018119812,
          0.8159999847412109
        ],
        [
          0.7020000219345093,
          0.7739999890327454
        ],
        [
          0.7059999704360962,
          0.7639999985694885
        ],
        [
          0.7139999866485596,
          0.7559999823570251
        ],
        [
          0.7179999947547913,
          0.7419999837875366
        ],
        [
          0.722000002861023,
          0.7400000095367432
        ],
        [
          0.7260000109672546,
          0.7300000190734863
        ],
        [
          0.7260000109672546,
          0.7239999771118164
        ],
        [
          0.7300000190734863,
          0.722000002861023
        ],
        [
          0.7319999933242798,
          0.7080000042915344
        ],
        [
          0.734000027179718,
          0.6399999856948853
        ],
        [
          0.7300000190734863,
          0.6259999871253967
        ],
        [
          0.722000002861023,
          0.6159999966621399
        ],
        [
          0.7179999947547913,
          0.6159999966621399
        ],
        [
          0.7080000042915344,
          0.6060000061988831
        ],
        [
          0.6779999732971191,
          0.5960000157356262
        ],
        [
          0.6759999990463257,
          0.5920000076293945
        ],
        [
          0.6380000114440918,
          0.5899999737739563
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6159999966621399,
          0.593999981880188
        ],
        [
          0.6140000224113464,
          0.5979999899864197
        ],
        [
          0.6019999980926514,
          0.6000000238418579
        ],
        [
          0.5759999752044678,
          0.6140000224113464
        ],
        [
          0.5519999861717224,
          0.6460000276565552
        ],
        [
          0.5460000038146973,
          0.6480000019073486
        ],
        [
          0.5360000133514404,
          0.6919999718666077
        ],
        [
          0.5320000052452087,
          0.6940000057220459
        ],
        [
          0.527999997138977,
          0.722000002861023
        ],
        [
          0.5239999890327454,
          0.7239999771118164
        ],
        [
          0.5220000147819519,
          0.7300000190734863
        ],
        [
          0.5199999809265137,
          0.7480000257492065
        ],
        [
          0.5139999985694885,
          0.75
        ],
        [
          0.5099999904632568,
          0.7680000066757202
        ],
        [
          0.48399999737739563,
          0.7919999957084656
        ],
        [
          0.4740000069141388,
          0.8040000200271606
        ],
        [
          0.4740000069141388,
          0.8080000281333923
        ],
        [
          0.46799999475479126,
          0.8119999766349792
        ],
        [
          0.4659999907016754,
          0.8460000157356262
        ],
        [
          0.48399999737739563,
          0.8640000224113464
        ],
        [
          0.5580000281333923,
          0.8640000224113464
        ],
        [
          0.5680000185966492,
          0.8619999885559082
        ],
        [
          0.5699999928474426,
          0.8579999804496765
        ],
        [
          0.5839999914169312,
          0.8560000061988831
        ],
        [
          0.5899999737739563,
          0.8500000238418579
        ],
        [
          0.6039999723434448,
          0.8460000157356262
        ],
        [
          0.6060000061988831,
          0.8420000076293945
        ],
        [
          0.6119999885559082,
          0.8420000076293945
        ],
        [
          0.6259999871253967,
          0.8339999914169312
        ],
        [
          0.6340000033378601,
          0.8259999752044678
        ],
        [
          0.6439999938011169,
          0.8240000009536743
        ],
        [
          0.6740000247955322,
          0.8019999861717224
        ],
        [
          0.6919999718666077,
          0.7839999794960022
        ],
        [
          0.6959999799728394,
          0.7839999794960022
        ],
        [
          0.7020000219345093,
          0.7699999809265137
        ],
        [
          0.7179999947547913,
          0.7480000257492065
        ],
        [
          0.7300000190734863,
          0.7080000042915344
        ],
        [
          0.7260000109672546,
          0.6380000114440918
        ],
        [
          0.722000002861023,
          0.6359999775886536
        ],
        [
          0.7200000286102295,
          0.6159999966621399
        ],
        [
          0.7080000042915344,
          0.6060000061988831
        ],
        [
          0.6800000071525574,
          0.5979999899864197
        ],
        [
          0.6779999732971191,
          0.593999981880188
        ],
        [
          0.6159999966621399,
          0.593999981880188
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6480000019073486,
          0.593999981880188
        ],
        [
          0.6240000128746033,
          0.5979999899864197
        ],
        [
          0.621999979019165,
          0.6019999980926514
        ],
        [
          0.5860000252723694,
          0.6140000224113464
        ],
        [
          0.5680000185966492,
          0.6359999775886536
        ],
        [
          0.5519999861717224,
          0.6499999761581421
        ],
        [
          0.5479999780654907,
          0.6620000004768372
        ],
        [
          0.5400000214576721,
          0.6700000166893005
        ],
        [
          0.5400000214576721,
          0.6819999814033508
        ],
        [
          0.5339999794960022,
          0.6899999976158142
        ],
        [
          0.527999997138977,
          0.7160000205039978
        ],
        [
          0.5239999890327454,
          0.7179999947547913
        ],
        [
          0.5199999809265137,
          0.75
        ],
        [
          0.5120000243186951,
          0.7580000162124634
        ],
        [
          0.5099999904632568,
          0.7720000147819519
        ],
        [
          0.4699999988079071,
          0.8159999847412109
        ],
        [
          0.46799999475479126,
          0.8519999980926514
        ],
        [
          0.4779999852180481,
          0.8619999885559082
        ],
        [
          0.5659999847412109,
          0.8619999885559082
        ],
        [
          0.6140000224113464,
          0.843999981880188
        ],
        [
          0.6299999952316284,
          0.8360000252723694
        ],
        [
          0.6420000195503235,
          0.8240000009536743
        ],
        [
          0.656000018119812,
          0.8199999928474426
        ],
        [
          0.6679999828338623,
          0.8059999942779541
        ],
        [
          0.6819999814033508,
          0.7979999780654907
        ],
        [
          0.6840000152587891,
          0.7919999957084656
        ],
        [
          0.7020000219345093,
          0.7760000228881836
        ],
        [
          0.7039999961853027,
          0.7680000066757202
        ],
        [
          0.7179999947547913,
          0.7519999742507935
        ],
        [
          0.7319999933242798,
          0.7099999785423279
        ],
        [
          0.7260000109672546,
          0.6140000224113464
        ],
        [
          0.722000002861023,
          0.6140000224113464
        ],
        [
          0.7099999785423279,
          0.6019999980926514
        ],
        [
          0.7039999961853027,
          0.6019999980926514
        ],
        [
          0.7020000219345093,
          0.5979999899864197
        ],
        [
          0.6779999732971191,
          0.593999981880188
        ],
        [
          0.6480000019073486,
          0.593999981880188
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6740000247955322,
          0.6000000238418579
        ],
        [
          0.6520000100135803,
          0.6039999723434448
        ],
        [
          0.6499999761581421,
          0.6079999804496765
        ],
        [
          0.6259999871253967,
          0.6100000143051147
        ],
        [
          0.6240000128746033,
          0.6140000224113464
        ],
        [
          0.6000000238418579,
          0.6159999966621399
        ],
        [
          0.5979999899864197,
          0.621999979019165
        ],
        [
          0.5879999995231628,
          0.6259999871253967
        ],
        [
          0.5720000267028809,
          0.6460000276565552
        ],
        [
          0.5640000104904175,
          0.6480000019073486
        ],
        [
          0.5640000104904175,
          0.6539999842643738
        ],
        [
          0.5559999942779541,
          0.6620000004768372
        ],
        [
          0.5540000200271606,
          0.671999990940094
        ],
        [
          0.5440000295639038,
          0.6800000071525574
        ],
        [
          0.5440000295639038,
          0.6880000233650208
        ],
        [
          0.527999997138977,
          0.7059999704360962
        ],
        [
          0.5260000228881836,
          0.7160000205039978
        ],
        [
          0.5199999809265137,
          0.7239999771118164
        ],
        [
          0.5199999809265137,
          0.7319999933242798
        ],
        [
          0.5139999985694885,
          0.734000027179718
        ],
        [
          0.5120000243186951,
          0.7680000066757202
        ],
        [
          0.49399998784065247,
          0.7919999957084656
        ],
        [
          0.48399999737739563,
          0.8119999766349792
        ],
        [
          0.4819999933242798,
          0.8399999737739563
        ],
        [
          0.49000000953674316,
          0.843999981880188
        ],
        [
          0.4959999918937683,
          0.8539999723434448
        ],
        [
          0.5299999713897705,
          0.8579999804496765
        ],
        [
          0.5720000267028809,
          0.8579999804496765
        ],
        [
          0.5899999737739563,
          0.8539999723434448
        ],
        [
          0.5920000076293945,
          0.8500000238418579
        ],
        [
          0.5979999899864197,
          0.8500000238418579
        ],
        [
          0.6100000143051147,
          0.8420000076293945
        ],
        [
          0.6240000128746033,
          0.8399999737739563
        ],
        [
          0.6259999871253967,
          0.8360000252723694
        ],
        [
          0.6380000114440918,
          0.8320000171661377
        ],
        [
          0.6740000247955322,
          0.8040000200271606
        ],
        [
          0.6779999732971191,
          0.8040000200271606
        ],
        [
          0.699999988079071,
          0.7820000052452087
        ],
        [
          0.699999988079071,
          0.777999997138977
        ],
        [
          0.7239999771118164,
          0.7459999918937683
        ],
        [
          0.7260000109672546,
          0.734000027179718
        ],
        [
          0.7300000190734863,
          0.7319999933242798
        ],
        [
          0.734000027179718,
          0.7200000286102295
        ],
        [
          0.7360000014305115,
          0.7039999961853027
        ],
        [
          0.7400000095367432,
          0.7020000219345093
        ],
        [
          0.7400000095367432,
          0.6359999775886536
        ],
        [
          0.7300000190734863,
          0.6140000224113464
        ],
        [
          0.7179999947547913,
          0.6039999723434448
        ],
        [
          0.6740000247955322,
          0.6000000238418579
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6759999990463257,
          0.6039999723434448
        ],
        [
          0.656000018119812,
          0.6060000061988831
        ],
        [
          0.6539999842643738,
          0.6100000143051147
        ],
        [
          0.6460000276565552,
          0.6119999885559082
        ],
        [
          0.6140000224113464,
          0.6140000224113464
        ],
        [
          0.5640000104904175,
          0.6579999923706055
        ],
        [
          0.550000011920929,
          0.6859999895095825
        ],
        [
          0.5440000295639038,
          0.6880000233650208
        ],
        [
          0.5419999957084656,
          0.7020000219345093
        ],
        [
          0.5360000133514404,
          0.7059999704360962
        ],
        [
          0.5339999794960022,
          0.7179999947547913
        ],
        [
          0.527999997138977,
          0.722000002861023
        ],
        [
          0.5239999890327454,
          0.7480000257492065
        ],
        [
          0.5199999809265137,
          0.75
        ],
        [
          0.5180000066757202,
          0.7599999904632568
        ],
        [
          0.5099999904632568,
          0.7680000066757202
        ],
        [
          0.5099999904632568,
          0.7760000228881836
        ],
        [
          0.492000013589859,
          0.8059999942779541
        ],
        [
          0.4880000054836273,
          0.828000009059906
        ],
        [
          0.48399999737739563,
          0.8299999833106995
        ],
        [
          0.48399999737739563,
          0.8420000076293945
        ],
        [
          0.5,
          0.8579999804496765
        ],
        [
          0.5720000267028809,
          0.8600000143051147
        ],
        [
          0.593999981880188,
          0.8560000061988831
        ],
        [
          0.5960000157356262,
          0.8519999980926514
        ],
        [
          0.6019999980926514,
          0.8519999980926514
        ],
        [
          0.6119999885559082,
          0.8479999899864197
        ],
        [
          0.6140000224113464,
          0.843999981880188
        ],
        [
          0.6240000128746033,
          0.8420000076293945
        ],
        [
          0.6380000114440918,
          0.8339999914169312
        ],
        [
          0.6399999856948853,
          0.8299999833106995
        ],
        [
          0.6639999747276306,
          0.8180000185966492
        ],
        [
          0.6740000247955322,
          0.8059999942779541
        ],
        [
          0.6840000152587891,
          0.8019999861717224
        ],
        [
          0.7020000219345093,
          0.7820000052452087
        ],
        [
          0.7059999704360962,
          0.7820000052452087
        ],
        [
          0.7260000109672546,
          0.75
        ],
        [
          0.7279999852180481,
          0.7419999837875366
        ],
        [
          0.7319999933242798,
          0.7400000095367432
        ],
        [
          0.7360000014305115,
          0.722000002861023
        ],
        [
          0.7400000095367432,
          0.7200000286102295
        ],
        [
          0.7459999918937683,
          0.6880000233650208
        ],
        [
          0.7440000176429749,
          0.6439999938011169
        ],
        [
          0.7400000095367432,
          0.6320000290870667
        ],
        [
          0.7200000286102295,
          0.6119999885559082
        ],
        [
          0.7020000219345093,
          0.6100000143051147
        ],
        [
          0.699999988079071,
          0.6060000061988831
        ],
        [
          0.6759999990463257,
          0.6039999723434448
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6959999799728394,
          0.6079999804496765
        ],
        [
          0.6579999923706055,
          0.6119999885559082
        ],
        [
          0.656000018119812,
          0.6159999966621399
        ],
        [
          0.6460000276565552,
          0.6159999966621399
        ],
        [
          0.6420000195503235,
          0.621999979019165
        ],
        [
          0.6159999966621399,
          0.6259999871253967
        ],
        [
          0.6140000224113464,
          0.6299999952316284
        ],
        [
          0.6060000061988831,
          0.6320000290870667
        ],
        [
          0.5960000157356262,
          0.6399999856948853
        ],
        [
          0.5580000281333923,
          0.6779999732971191
        ],
        [
          0.5419999957084656,
          0.6980000138282776
        ],
        [
          0.5400000214576721,
          0.7059999704360962
        ],
        [
          0.5339999794960022,
          0.7099999785423279
        ],
        [
          0.5299999713897705,
          0.7300000190734863
        ],
        [
          0.5239999890327454,
          0.7379999756813049
        ],
        [
          0.5220000147819519,
          0.7599999904632568
        ],
        [
          0.5099999904632568,
          0.7760000228881836
        ],
        [
          0.5059999823570251,
          0.7960000038146973
        ],
        [
          0.5019999742507935,
          0.7979999780654907
        ],
        [
          0.5,
          0.8059999942779541
        ],
        [
          0.49399998784065247,
          0.8119999766349792
        ],
        [
          0.49399998784065247,
          0.843999981880188
        ],
        [
          0.5099999904632568,
          0.8519999980926514
        ],
        [
          0.5360000133514404,
          0.8539999723434448
        ],
        [
          0.5400000214576721,
          0.8579999804496765
        ],
        [
          0.5960000157356262,
          0.8579999804496765
        ],
        [
          0.5979999899864197,
          0.8539999723434448
        ],
        [
          0.6140000224113464,
          0.8500000238418579
        ],
        [
          0.6159999966621399,
          0.8460000157356262
        ],
        [
          0.6299999952316284,
          0.8420000076293945
        ],
        [
          0.6320000290870667,
          0.8379999995231628
        ],
        [
          0.656000018119812,
          0.8259999752044678
        ],
        [
          0.7139999866485596,
          0.7739999890327454
        ],
        [
          0.7239999771118164,
          0.7540000081062317
        ],
        [
          0.7319999933242798,
          0.7459999918937683
        ],
        [
          0.734000027179718,
          0.7379999756813049
        ],
        [
          0.7379999756813049,
          0.7360000014305115
        ],
        [
          0.7419999837875366,
          0.7160000205039978
        ],
        [
          0.7480000257492065,
          0.7080000042915344
        ],
        [
          0.75,
          0.6340000033378601
        ],
        [
          0.7480000257492065,
          0.6259999871253967
        ],
        [
          0.734000027179718,
          0.6119999885559082
        ],
        [
          0.6959999799728394,
          0.6079999804496765
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6940000057220459,
          0.6119999885559082
        ],
        [
          0.6639999747276306,
          0.6159999966621399
        ],
        [
          0.6620000004768372,
          0.6200000047683716
        ],
        [
          0.656000018119812,
          0.6200000047683716
        ],
        [
          0.6539999842643738,
          0.6259999871253967
        ],
        [
          0.6320000290870667,
          0.628000020980835
        ],
        [
          0.6119999885559082,
          0.6359999775886536
        ],
        [
          0.5759999752044678,
          0.6679999828338623
        ],
        [
          0.5759999752044678,
          0.671999990940094
        ],
        [
          0.5580000281333923,
          0.6899999976158142
        ],
        [
          0.5580000281333923,
          0.6940000057220459
        ],
        [
          0.5440000295639038,
          0.7039999961853027
        ],
        [
          0.5320000052452087,
          0.734000027179718
        ],
        [
          0.527999997138977,
          0.7360000014305115
        ],
        [
          0.5260000228881836,
          0.7480000257492065
        ],
        [
          0.515999972820282,
          0.7620000243186951
        ],
        [
          0.5099999904632568,
          0.7860000133514404
        ],
        [
          0.492000013589859,
          0.8199999928474426
        ],
        [
          0.492000013589859,
          0.8320000171661377
        ],
        [
          0.4880000054836273,
          0.8339999914169312
        ],
        [
          0.4880000054836273,
          0.8379999995231628
        ],
        [
          0.492000013589859,
          0.8399999737739563
        ],
        [
          0.49399998784065247,
          0.8479999899864197
        ],
        [
          0.5080000162124634,
          0.8560000061988831
        ],
        [
          0.5339999794960022,
          0.8579999804496765
        ],
        [
          0.5360000133514404,
          0.8619999885559082
        ],
        [
          0.5580000281333923,
          0.8640000224113464
        ],
        [
          0.5920000076293945,
          0.8619999885559082
        ],
        [
          0.5960000157356262,
          0.8579999804496765
        ],
        [
          0.6140000224113464,
          0.8539999723434448
        ],
        [
          0.6159999966621399,
          0.8500000238418579
        ],
        [
          0.6299999952316284,
          0.8460000157356262
        ],
        [
          0.6320000290870667,
          0.8420000076293945
        ],
        [
          0.656000018119812,
          0.8299999833106995
        ],
        [
          0.7139999866485596,
          0.777999997138977
        ],
        [
          0.7139999866485596,
          0.7739999890327454
        ],
        [
          0.7260000109672546,
          0.7620000243186951
        ],
        [
          0.7279999852180481,
          0.7519999742507935
        ],
        [
          0.734000027179718,
          0.7480000257492065
        ],
        [
          0.7459999918937683,
          0.7099999785423279
        ],
        [
          0.75,
          0.7059999704360962
        ],
        [
          0.75,
          0.6439999938011169
        ],
        [
          0.7459999918937683,
          0.6420000195503235
        ],
        [
          0.7440000176429749,
          0.6259999871253967
        ],
        [
          0.734000027179718,
          0.6140000224113464
        ],
        [
          0.6940000057220459,
          0.6119999885559082
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7020000219345093,
          0.6179999709129333
        ],
        [
          0.6740000247955322,
          0.6200000047683716
        ],
        [
          0.671999990940094,
          0.6259999871253967
        ],
        [
          0.6660000085830688,
          0.6259999871253967
        ],
        [
          0.6639999747276306,
          0.6299999952316284
        ],
        [
          0.621999979019165,
          0.6399999856948853
        ],
        [
          0.5899999737739563,
          0.6679999828338623
        ],
        [
          0.5740000009536743,
          0.6880000233650208
        ],
        [
          0.5699999928474426,
          0.6880000233650208
        ],
        [
          0.5460000038146973,
          0.7099999785423279
        ],
        [
          0.5419999957084656,
          0.7239999771118164
        ],
        [
          0.527999997138977,
          0.7459999918937683
        ],
        [
          0.5260000228881836,
          0.7599999904632568
        ],
        [
          0.5199999809265137,
          0.7720000147819519
        ],
        [
          0.5139999985694885,
          0.7739999890327454
        ],
        [
          0.5019999742507935,
          0.8140000104904175
        ],
        [
          0.49799999594688416,
          0.8159999847412109
        ],
        [
          0.492000013589859,
          0.828000009059906
        ],
        [
          0.49000000953674316,
          0.8500000238418579
        ],
        [
          0.5019999742507935,
          0.8640000224113464
        ],
        [
          0.5199999809265137,
          0.8659999966621399
        ],
        [
          0.5220000147819519,
          0.8700000047683716
        ],
        [
          0.5659999847412109,
          0.8700000047683716
        ],
        [
          0.5680000185966492,
          0.8659999966621399
        ],
        [
          0.5920000076293945,
          0.8640000224113464
        ],
        [
          0.593999981880188,
          0.8600000143051147
        ],
        [
          0.6159999966621399,
          0.8560000061988831
        ],
        [
          0.6179999709129333,
          0.8519999980926514
        ],
        [
          0.6299999952316284,
          0.8500000238418579
        ],
        [
          0.6320000290870667,
          0.8460000157356262
        ],
        [
          0.6460000276565552,
          0.8420000076293945
        ],
        [
          0.6499999761581421,
          0.8360000252723694
        ],
        [
          0.6660000085830688,
          0.828000009059906
        ],
        [
          0.7179999947547913,
          0.7820000052452087
        ],
        [
          0.722000002861023,
          0.7720000147819519
        ],
        [
          0.734000027179718,
          0.7580000162124634
        ],
        [
          0.7379999756813049,
          0.7440000176429749
        ],
        [
          0.7440000176429749,
          0.7360000014305115
        ],
        [
          0.7459999918937683,
          0.7239999771118164
        ],
        [
          0.75,
          0.722000002861023
        ],
        [
          0.7519999742507935,
          0.671999990940094
        ],
        [
          0.75,
          0.6600000262260437
        ],
        [
          0.734000027179718,
          0.6320000290870667
        ],
        [
          0.7300000190734863,
          0.6299999952316284
        ],
        [
          0.7260000109672546,
          0.6179999709129333
        ],
        [
          0.7020000219345093,
          0.6179999709129333
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6840000152587891,
          0.6320000290870667
        ],
        [
          0.6740000247955322,
          0.6340000033378601
        ],
        [
          0.671999990940094,
          0.6380000114440918
        ],
        [
          0.6460000276565552,
          0.6420000195503235
        ],
        [
          0.6380000114440918,
          0.6480000019073486
        ],
        [
          0.6240000128746033,
          0.6480000019073486
        ],
        [
          0.6200000047683716,
          0.656000018119812
        ],
        [
          0.6159999966621399,
          0.656000018119812
        ],
        [
          0.5979999899864197,
          0.6700000166893005
        ],
        [
          0.5820000171661377,
          0.6919999718666077
        ],
        [
          0.5360000133514404,
          0.7400000095367432
        ],
        [
          0.5220000147819519,
          0.765999972820282
        ],
        [
          0.515999972820282,
          0.7680000066757202
        ],
        [
          0.5120000243186951,
          0.7879999876022339
        ],
        [
          0.5080000162124634,
          0.7900000214576721
        ],
        [
          0.5080000162124634,
          0.7940000295639038
        ],
        [
          0.5,
          0.8019999861717224
        ],
        [
          0.49799999594688416,
          0.8100000023841858
        ],
        [
          0.49399998784065247,
          0.8119999766349792
        ],
        [
          0.49399998784065247,
          0.8159999847412109
        ],
        [
          0.4779999852180481,
          0.8379999995231628
        ],
        [
          0.4819999933242798,
          0.8519999980926514
        ],
        [
          0.49799999594688416,
          0.8679999709129333
        ],
        [
          0.5139999985694885,
          0.8700000047683716
        ],
        [
          0.5139999985694885,
          0.8740000128746033
        ],
        [
          0.5659999847412109,
          0.8740000128746033
        ],
        [
          0.5680000185966492,
          0.8700000047683716
        ],
        [
          0.6000000238418579,
          0.8659999966621399
        ],
        [
          0.6520000100135803,
          0.8399999737739563
        ],
        [
          0.6679999828338623,
          0.8259999752044678
        ],
        [
          0.671999990940094,
          0.8259999752044678
        ],
        [
          0.6840000152587891,
          0.8119999766349792
        ],
        [
          0.6880000233650208,
          0.8119999766349792
        ],
        [
          0.7080000042915344,
          0.7940000295639038
        ],
        [
          0.7080000042915344,
          0.7900000214576721
        ],
        [
          0.7139999866485596,
          0.7879999876022339
        ],
        [
          0.7139999866485596,
          0.7839999794960022
        ],
        [
          0.7200000286102295,
          0.7799999713897705
        ],
        [
          0.7200000286102295,
          0.7760000228881836
        ],
        [
          0.734000027179718,
          0.7559999823570251
        ],
        [
          0.7459999918937683,
          0.7200000286102295
        ],
        [
          0.75,
          0.7179999947547913
        ],
        [
          0.7519999742507935,
          0.6919999718666077
        ],
        [
          0.7559999823570251,
          0.6899999976158142
        ],
        [
          0.7519999742507935,
          0.6880000233650208
        ],
        [
          0.7519999742507935,
          0.6679999828338623
        ],
        [
          0.7440000176429749,
          0.6480000019073486
        ],
        [
          0.7300000190734863,
          0.6340000033378601
        ],
        [
          0.6840000152587891,
          0.6320000290870667
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7020000219345093,
          0.6439999938011169
        ],
        [
          0.6980000138282776,
          0.6480000019073486
        ],
        [
          0.6579999923706055,
          0.6499999761581421
        ],
        [
          0.6480000019073486,
          0.6579999923706055
        ],
        [
          0.6380000114440918,
          0.6579999923706055
        ],
        [
          0.6359999775886536,
          0.6620000004768372
        ],
        [
          0.6119999885559082,
          0.6700000166893005
        ],
        [
          0.6060000061988831,
          0.6759999990463257
        ],
        [
          0.5979999899864197,
          0.6779999732971191
        ],
        [
          0.5879999995231628,
          0.6899999976158142
        ],
        [
          0.5839999914169312,
          0.6899999976158142
        ],
        [
          0.5640000104904175,
          0.7120000123977661
        ],
        [
          0.5600000023841858,
          0.7120000123977661
        ],
        [
          0.5559999942779541,
          0.722000002861023
        ],
        [
          0.550000011920929,
          0.722000002861023
        ],
        [
          0.5139999985694885,
          0.7580000162124634
        ],
        [
          0.5040000081062317,
          0.7720000147819519
        ],
        [
          0.5040000081062317,
          0.777999997138977
        ],
        [
          0.4959999918937683,
          0.7860000133514404
        ],
        [
          0.4880000054836273,
          0.8059999942779541
        ],
        [
          0.47600001096725464,
          0.8199999928474426
        ],
        [
          0.47200000286102295,
          0.8320000171661377
        ],
        [
          0.4740000069141388,
          0.8519999980926514
        ],
        [
          0.4819999933242798,
          0.8600000143051147
        ],
        [
          0.49799999594688416,
          0.8679999709129333
        ],
        [
          0.5059999823570251,
          0.8679999709129333
        ],
        [
          0.5099999904632568,
          0.871999979019165
        ],
        [
          0.5419999957084656,
          0.8740000128746033
        ],
        [
          0.5759999752044678,
          0.871999979019165
        ],
        [
          0.5799999833106995,
          0.8679999709129333
        ],
        [
          0.6119999885559082,
          0.8600000143051147
        ],
        [
          0.6140000224113464,
          0.8560000061988831
        ],
        [
          0.6259999871253967,
          0.8539999723434448
        ],
        [
          0.6420000195503235,
          0.8460000157356262
        ],
        [
          0.6439999938011169,
          0.8420000076293945
        ],
        [
          0.6579999923706055,
          0.8379999995231628
        ],
        [
          0.6819999814033508,
          0.8199999928474426
        ],
        [
          0.6919999718666077,
          0.8080000281333923
        ],
        [
          0.7099999785423279,
          0.7979999780654907
        ],
        [
          0.7260000109672546,
          0.777999997138977
        ],
        [
          0.7300000190734863,
          0.765999972820282
        ],
        [
          0.734000027179718,
          0.7639999985694885
        ],
        [
          0.7459999918937683,
          0.7300000190734863
        ],
        [
          0.75,
          0.7260000109672546
        ],
        [
          0.7519999742507935,
          0.7099999785423279
        ],
        [
          0.7559999823570251,
          0.7059999704360962
        ],
        [
          0.7559999823570251,
          0.6779999732971191
        ],
        [
          0.7519999742507935,
          0.6759999990463257
        ],
        [
          0.75,
          0.6620000004768372
        ],
        [
          0.7300000190734863,
          0.6439999938011169
        ],
        [
          0.7020000219345093,
          0.6439999938011169
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7160000205039978,
          0.6480000019073486
        ],
        [
          0.7020000219345093,
          0.6480000019073486
        ],
        [
          0.699999988079071,
          0.6520000100135803
        ],
        [
          0.6899999976158142,
          0.6520000100135803
        ],
        [
          0.6859999895095825,
          0.6579999923706055
        ],
        [
          0.6539999842643738,
          0.6620000004768372
        ],
        [
          0.6520000100135803,
          0.6660000085830688
        ],
        [
          0.6380000114440918,
          0.6679999828338623
        ],
        [
          0.6359999775886536,
          0.671999990940094
        ],
        [
          0.621999979019165,
          0.6740000247955322
        ],
        [
          0.6179999709129333,
          0.6779999732971191
        ],
        [
          0.6019999980926514,
          0.6819999814033508
        ],
        [
          0.6000000238418579,
          0.6859999895095825
        ],
        [
          0.5920000076293945,
          0.6880000233650208
        ],
        [
          0.5759999752044678,
          0.7020000219345093
        ],
        [
          0.5720000267028809,
          0.7020000219345093
        ],
        [
          0.5619999766349792,
          0.7139999866485596
        ],
        [
          0.5479999780654907,
          0.722000002861023
        ],
        [
          0.5460000038146973,
          0.7260000109672546
        ],
        [
          0.5419999957084656,
          0.7260000109672546
        ],
        [
          0.5379999876022339,
          0.7319999933242798
        ],
        [
          0.5260000228881836,
          0.7360000014305115
        ],
        [
          0.5080000162124634,
          0.7559999823570251
        ],
        [
          0.5059999823570251,
          0.765999972820282
        ],
        [
          0.5019999742507935,
          0.7680000066757202
        ],
        [
          0.4959999918937683,
          0.7799999713897705
        ],
        [
          0.492000013589859,
          0.7940000295639038
        ],
        [
          0.47200000286102295,
          0.8259999752044678
        ],
        [
          0.4699999988079071,
          0.8460000157356262
        ],
        [
          0.47600001096725464,
          0.8500000238418579
        ],
        [
          0.47600001096725464,
          0.8539999723434448
        ],
        [
          0.49399998784065247,
          0.8619999885559082
        ],
        [
          0.4959999918937683,
          0.8659999966621399
        ],
        [
          0.5379999876022339,
          0.8700000047683716
        ],
        [
          0.5400000214576721,
          0.8740000128746033
        ],
        [
          0.5699999928474426,
          0.8740000128746033
        ],
        [
          0.5720000267028809,
          0.8700000047683716
        ],
        [
          0.5860000252723694,
          0.8700000047683716
        ],
        [
          0.6000000238418579,
          0.8659999966621399
        ],
        [
          0.6019999980926514,
          0.8619999885559082
        ],
        [
          0.6159999966621399,
          0.8600000143051147
        ],
        [
          0.6179999709129333,
          0.8560000061988831
        ],
        [
          0.6299999952316284,
          0.8539999723434448
        ],
        [
          0.6320000290870667,
          0.8500000238418579
        ],
        [
          0.6460000276565552,
          0.8460000157356262
        ],
        [
          0.6480000019073486,
          0.8420000076293945
        ],
        [
          0.6539999842643738,
          0.8420000076293945
        ],
        [
          0.6639999747276306,
          0.8339999914169312
        ],
        [
          0.6740000247955322,
          0.8320000171661377
        ],
        [
          0.7020000219345093,
          0.8019999861717224
        ],
        [
          0.7059999704360962,
          0.8019999861717224
        ],
        [
          0.722000002861023,
          0.7860000133514404
        ],
        [
          0.722000002861023,
          0.7820000052452087
        ],
        [
          0.7360000014305115,
          0.765999972820282
        ],
        [
          0.7400000095367432,
          0.7540000081062317
        ],
        [
          0.7440000176429749,
          0.7519999742507935
        ],
        [
          0.7480000257492065,
          0.734000027179718
        ],
        [
          0.7519999742507935,
          0.7319999933242798
        ],
        [
          0.7540000081062317,
          0.7200000286102295
        ],
        [
          0.7580000162124634,
          0.7179999947547913
        ],
        [
          0.7580000162124634,
          0.6740000247955322
        ],
        [
          0.7459999918937683,
          0.6600000262260437
        ],
        [
          0.7440000176429749,
          0.6520000100135803
        ],
        [
          0.7400000095367432,
          0.6520000100135803
        ],
        [
          0.7379999756813049,
          0.6480000019073486
        ],
        [
          0.7160000205039978,
          0.6480000019073486
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6819999814033508,
          0.6579999923706055
        ],
        [
          0.6620000004768372,
          0.6600000262260437
        ],
        [
          0.6499999761581421,
          0.6700000166893005
        ],
        [
          0.6299999952316284,
          0.6740000247955322
        ],
        [
          0.628000020980835,
          0.6779999732971191
        ],
        [
          0.6140000224113464,
          0.6800000071525574
        ],
        [
          0.6060000061988831,
          0.6859999895095825
        ],
        [
          0.6000000238418579,
          0.6859999895095825
        ],
        [
          0.5979999899864197,
          0.6899999976158142
        ],
        [
          0.5879999995231628,
          0.6919999718666077
        ],
        [
          0.5759999752044678,
          0.7039999961853027
        ],
        [
          0.5479999780654907,
          0.7200000286102295
        ],
        [
          0.5479999780654907,
          0.7239999771118164
        ],
        [
          0.5400000214576721,
          0.7300000190734863
        ],
        [
          0.5320000052452087,
          0.7319999933242798
        ],
        [
          0.5120000243186951,
          0.7459999918937683
        ],
        [
          0.5019999742507935,
          0.7639999985694885
        ],
        [
          0.5019999742507935,
          0.7699999809265137
        ],
        [
          0.49799999594688416,
          0.7720000147819519
        ],
        [
          0.49799999594688416,
          0.7820000052452087
        ],
        [
          0.49000000953674316,
          0.7960000038146973
        ],
        [
          0.49000000953674316,
          0.8040000200271606
        ],
        [
          0.48399999737739563,
          0.8140000104904175
        ],
        [
          0.47999998927116394,
          0.8339999914169312
        ],
        [
          0.4819999933242798,
          0.8539999723434448
        ],
        [
          0.4959999918937683,
          0.8679999709129333
        ],
        [
          0.5139999985694885,
          0.8700000047683716
        ],
        [
          0.5180000066757202,
          0.8740000128746033
        ],
        [
          0.578000009059906,
          0.8740000128746033
        ],
        [
          0.5799999833106995,
          0.8700000047683716
        ],
        [
          0.5920000076293945,
          0.8700000047683716
        ],
        [
          0.6079999804496765,
          0.8619999885559082
        ],
        [
          0.621999979019165,
          0.8600000143051147
        ],
        [
          0.6240000128746033,
          0.8560000061988831
        ],
        [
          0.6359999775886536,
          0.8539999723434448
        ],
        [
          0.6380000114440918,
          0.8500000238418579
        ],
        [
          0.6579999923706055,
          0.8420000076293945
        ],
        [
          0.6620000004768372,
          0.8360000252723694
        ],
        [
          0.671999990940094,
          0.8339999914169312
        ],
        [
          0.7059999704360962,
          0.8019999861717224
        ],
        [
          0.7099999785423279,
          0.8019999861717224
        ],
        [
          0.7319999933242798,
          0.777999997138977
        ],
        [
          0.7459999918937683,
          0.7519999742507935
        ],
        [
          0.75,
          0.7319999933242798
        ],
        [
          0.7540000081062317,
          0.7300000190734863
        ],
        [
          0.7580000162124634,
          0.7059999704360962
        ],
        [
          0.7559999823570251,
          0.6840000152587891
        ],
        [
          0.7319999933242798,
          0.6600000262260437
        ],
        [
          0.6819999814033508,
          0.6579999923706055
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6959999799728394,
          0.6520000100135803
        ],
        [
          0.6940000057220459,
          0.6579999923706055
        ],
        [
          0.6800000071525574,
          0.6579999923706055
        ],
        [
          0.6779999732971191,
          0.6620000004768372
        ],
        [
          0.6579999923706055,
          0.6639999747276306
        ],
        [
          0.656000018119812,
          0.6679999828338623
        ],
        [
          0.6340000033378601,
          0.671999990940094
        ],
        [
          0.6320000290870667,
          0.6759999990463257
        ],
        [
          0.6200000047683716,
          0.6779999732971191
        ],
        [
          0.6179999709129333,
          0.6819999814033508
        ],
        [
          0.6100000143051147,
          0.6840000152587891
        ],
        [
          0.5879999995231628,
          0.699999988079071
        ],
        [
          0.5659999847412109,
          0.722000002861023
        ],
        [
          0.515999972820282,
          0.7599999904632568
        ],
        [
          0.5120000243186951,
          0.7860000133514404
        ],
        [
          0.5080000162124634,
          0.7900000214576721
        ],
        [
          0.5040000081062317,
          0.8100000023841858
        ],
        [
          0.5,
          0.8119999766349792
        ],
        [
          0.4959999918937683,
          0.8360000252723694
        ],
        [
          0.49799999594688416,
          0.8619999885559082
        ],
        [
          0.5080000162124634,
          0.8740000128746033
        ],
        [
          0.527999997138977,
          0.8759999871253967
        ],
        [
          0.5299999713897705,
          0.8799999952316284
        ],
        [
          0.5600000023841858,
          0.8799999952316284
        ],
        [
          0.5640000104904175,
          0.8759999871253967
        ],
        [
          0.5899999737739563,
          0.8740000128746033
        ],
        [
          0.6100000143051147,
          0.8640000224113464
        ],
        [
          0.628000020980835,
          0.8600000143051147
        ],
        [
          0.6639999747276306,
          0.8420000076293945
        ],
        [
          0.6800000071525574,
          0.8299999833106995
        ],
        [
          0.7039999961853027,
          0.8059999942779541
        ],
        [
          0.7080000042915344,
          0.8059999942779541
        ],
        [
          0.7200000286102295,
          0.7960000038146973
        ],
        [
          0.734000027179718,
          0.7799999713897705
        ],
        [
          0.7419999837875366,
          0.765999972820282
        ],
        [
          0.7459999918937683,
          0.7639999985694885
        ],
        [
          0.75,
          0.7459999918937683
        ],
        [
          0.7540000081062317,
          0.7419999837875366
        ],
        [
          0.7580000162124634,
          0.7139999866485596
        ],
        [
          0.7620000243186951,
          0.7099999785423279
        ],
        [
          0.7620000243186951,
          0.6899999976158142
        ],
        [
          0.7580000162124634,
          0.6880000233650208
        ],
        [
          0.7559999823570251,
          0.6779999732971191
        ],
        [
          0.7419999837875366,
          0.6639999747276306
        ],
        [
          0.734000027179718,
          0.6620000004768372
        ],
        [
          0.7319999933242798,
          0.6579999923706055
        ],
        [
          0.7260000109672546,
          0.6579999923706055
        ],
        [
          0.7239999771118164,
          0.6520000100135803
        ],
        [
          0.6959999799728394,
          0.6520000100135803
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7099999785423279,
          0.6539999842643738
        ],
        [
          0.6819999814033508,
          0.6579999923706055
        ],
        [
          0.6779999732971191,
          0.6620000004768372
        ],
        [
          0.6639999747276306,
          0.6639999747276306
        ],
        [
          0.6620000004768372,
          0.6679999828338623
        ],
        [
          0.6380000114440918,
          0.6759999990463257
        ],
        [
          0.6159999966621399,
          0.6899999976158142
        ],
        [
          0.5799999833106995,
          0.7200000286102295
        ],
        [
          0.5759999752044678,
          0.7200000286102295
        ],
        [
          0.5400000214576721,
          0.7519999742507935
        ],
        [
          0.5299999713897705,
          0.7739999890327454
        ],
        [
          0.5199999809265137,
          0.7839999794960022
        ],
        [
          0.515999972820282,
          0.8040000200271606
        ],
        [
          0.5099999904632568,
          0.8100000023841858
        ],
        [
          0.5099999904632568,
          0.8159999847412109
        ],
        [
          0.5059999823570251,
          0.8180000185966492
        ],
        [
          0.5019999742507935,
          0.8640000224113464
        ],
        [
          0.5120000243186951,
          0.8799999952316284
        ],
        [
          0.5260000228881836,
          0.8820000290870667
        ],
        [
          0.5799999833106995,
          0.8799999952316284
        ],
        [
          0.5820000171661377,
          0.8759999871253967
        ],
        [
          0.6060000061988831,
          0.8740000128746033
        ],
        [
          0.628000020980835,
          0.8619999885559082
        ],
        [
          0.6380000114440918,
          0.8600000143051147
        ],
        [
          0.6399999856948853,
          0.8560000061988831
        ],
        [
          0.6480000019073486,
          0.8539999723434448
        ],
        [
          0.6919999718666077,
          0.8220000267028809
        ],
        [
          0.7360000014305115,
          0.777999997138977
        ],
        [
          0.7360000014305115,
          0.7739999890327454
        ],
        [
          0.7480000257492065,
          0.7599999904632568
        ],
        [
          0.7559999823570251,
          0.734000027179718
        ],
        [
          0.7599999904632568,
          0.7319999933242798
        ],
        [
          0.7680000066757202,
          0.6940000057220459
        ],
        [
          0.7639999985694885,
          0.6899999976158142
        ],
        [
          0.7620000243186951,
          0.6759999990463257
        ],
        [
          0.7459999918937683,
          0.6579999923706055
        ],
        [
          0.734000027179718,
          0.6539999842643738
        ],
        [
          0.7099999785423279,
          0.6539999842643738
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7139999866485596,
          0.6420000195503235
        ],
        [
          0.7120000123977661,
          0.6460000276565552
        ],
        [
          0.7059999704360962,
          0.6480000019073486
        ],
        [
          0.6899999976158142,
          0.6480000019073486
        ],
        [
          0.6880000233650208,
          0.6520000100135803
        ],
        [
          0.6840000152587891,
          0.6520000100135803
        ],
        [
          0.6819999814033508,
          0.6579999923706055
        ],
        [
          0.6639999747276306,
          0.6600000262260437
        ],
        [
          0.6620000004768372,
          0.6639999747276306
        ],
        [
          0.656000018119812,
          0.6639999747276306
        ],
        [
          0.6399999856948853,
          0.671999990940094
        ],
        [
          0.6240000128746033,
          0.6859999895095825
        ],
        [
          0.6200000047683716,
          0.6859999895095825
        ],
        [
          0.6100000143051147,
          0.6980000138282776
        ],
        [
          0.6060000061988831,
          0.6980000138282776
        ],
        [
          0.5440000295639038,
          0.7599999904632568
        ],
        [
          0.5379999876022339,
          0.7720000147819519
        ],
        [
          0.5339999794960022,
          0.7739999890327454
        ],
        [
          0.5260000228881836,
          0.7979999780654907
        ],
        [
          0.5199999809265137,
          0.800000011920929
        ],
        [
          0.5180000066757202,
          0.8059999942779541
        ],
        [
          0.515999972820282,
          0.843999981880188
        ],
        [
          0.5120000243186951,
          0.8479999899864197
        ],
        [
          0.5120000243186951,
          0.8700000047683716
        ],
        [
          0.5180000066757202,
          0.8759999871253967
        ],
        [
          0.5260000228881836,
          0.8759999871253967
        ],
        [
          0.5299999713897705,
          0.8799999952316284
        ],
        [
          0.5759999752044678,
          0.8799999952316284
        ],
        [
          0.5799999833106995,
          0.8759999871253967
        ],
        [
          0.6019999980926514,
          0.8740000128746033
        ],
        [
          0.6039999723434448,
          0.8700000047683716
        ],
        [
          0.6179999709129333,
          0.8679999709129333
        ],
        [
          0.6200000047683716,
          0.8640000224113464
        ],
        [
          0.6320000290870667,
          0.8619999885559082
        ],
        [
          0.6340000033378601,
          0.8579999804496765
        ],
        [
          0.6600000262260437,
          0.8479999899864197
        ],
        [
          0.7319999933242798,
          0.7879999876022339
        ],
        [
          0.7459999918937683,
          0.7680000066757202
        ],
        [
          0.75,
          0.75
        ],
        [
          0.7540000081062317,
          0.7480000257492065
        ],
        [
          0.7559999823570251,
          0.734000027179718
        ],
        [
          0.7599999904632568,
          0.7300000190734863
        ],
        [
          0.7639999985694885,
          0.6859999895095825
        ],
        [
          0.7620000243186951,
          0.6740000247955322
        ],
        [
          0.7540000081062317,
          0.6600000262260437
        ],
        [
          0.7360000014305115,
          0.6420000195503235
        ],
        [
          0.7139999866485596,
          0.6420000195503235
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7139999866485596,
          0.6460000276565552
        ],
        [
          0.7099999785423279,
          0.6499999761581421
        ],
        [
          0.6819999814033508,
          0.6520000100135803
        ],
        [
          0.6800000071525574,
          0.6579999923706055
        ],
        [
          0.6620000004768372,
          0.6600000262260437
        ],
        [
          0.6600000262260437,
          0.6639999747276306
        ],
        [
          0.6480000019073486,
          0.6660000085830688
        ],
        [
          0.6460000276565552,
          0.6700000166893005
        ],
        [
          0.6340000033378601,
          0.671999990940094
        ],
        [
          0.6320000290870667,
          0.6759999990463257
        ],
        [
          0.6240000128746033,
          0.6779999732971191
        ],
        [
          0.6100000143051147,
          0.6899999976158142
        ],
        [
          0.6060000061988831,
          0.6899999976158142
        ],
        [
          0.5879999995231628,
          0.7099999785423279
        ],
        [
          0.5839999914169312,
          0.7099999785423279
        ],
        [
          0.5839999914169312,
          0.7139999866485596
        ],
        [
          0.5699999928474426,
          0.7260000109672546
        ],
        [
          0.5680000185966492,
          0.7319999933242798
        ],
        [
          0.5619999766349792,
          0.734000027179718
        ],
        [
          0.5619999766349792,
          0.7379999756813049
        ],
        [
          0.5419999957084656,
          0.7599999904632568
        ],
        [
          0.5320000052452087,
          0.8080000281333923
        ],
        [
          0.527999997138977,
          0.8100000023841858
        ],
        [
          0.5260000228881836,
          0.8220000267028809
        ],
        [
          0.5199999809265137,
          0.8259999752044678
        ],
        [
          0.5199999809265137,
          0.8659999966621399
        ],
        [
          0.5400000214576721,
          0.8759999871253967
        ],
        [
          0.5680000185966492,
          0.878000020980835
        ],
        [
          0.6019999980926514,
          0.8759999871253967
        ],
        [
          0.6039999723434448,
          0.871999979019165
        ],
        [
          0.6179999709129333,
          0.8700000047683716
        ],
        [
          0.6200000047683716,
          0.8659999966621399
        ],
        [
          0.6299999952316284,
          0.8640000224113464
        ],
        [
          0.6320000290870667,
          0.8600000143051147
        ],
        [
          0.671999990940094,
          0.8399999737739563
        ],
        [
          0.6759999990463257,
          0.8339999914169312
        ],
        [
          0.6880000233650208,
          0.828000009059906
        ],
        [
          0.7179999947547913,
          0.8019999861717224
        ],
        [
          0.7239999771118164,
          0.7940000295639038
        ],
        [
          0.7279999852180481,
          0.7940000295639038
        ],
        [
          0.7279999852180481,
          0.7900000214576721
        ],
        [
          0.7360000014305115,
          0.7820000052452087
        ],
        [
          0.7440000176429749,
          0.7639999985694885
        ],
        [
          0.75,
          0.7580000162124634
        ],
        [
          0.7519999742507935,
          0.7459999918937683
        ],
        [
          0.7559999823570251,
          0.7440000176429749
        ],
        [
          0.7599999904632568,
          0.7260000109672546
        ],
        [
          0.7639999985694885,
          0.722000002861023
        ],
        [
          0.765999972820282,
          0.6840000152587891
        ],
        [
          0.7639999985694885,
          0.6759999990463257
        ],
        [
          0.7459999918937683,
          0.6499999761581421
        ],
        [
          0.7379999756813049,
          0.6460000276565552
        ],
        [
          0.7139999866485596,
          0.6460000276565552
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7239999771118164,
          0.6460000276565552
        ],
        [
          0.7179999947547913,
          0.6460000276565552
        ],
        [
          0.7099999785423279,
          0.656000018119812
        ],
        [
          0.6940000057220459,
          0.6579999923706055
        ],
        [
          0.6899999976158142,
          0.6620000004768372
        ],
        [
          0.6620000004768372,
          0.6700000166893005
        ],
        [
          0.6600000262260437,
          0.6740000247955322
        ],
        [
          0.6480000019073486,
          0.6759999990463257
        ],
        [
          0.6460000276565552,
          0.6800000071525574
        ],
        [
          0.6380000114440918,
          0.6819999814033508
        ],
        [
          0.6100000143051147,
          0.7020000219345093
        ],
        [
          0.5960000157356262,
          0.7179999947547913
        ],
        [
          0.5920000076293945,
          0.7179999947547913
        ],
        [
          0.5820000171661377,
          0.7300000190734863
        ],
        [
          0.5699999928474426,
          0.7360000014305115
        ],
        [
          0.5600000023841858,
          0.7480000257492065
        ],
        [
          0.550000011920929,
          0.75
        ],
        [
          0.5460000038146973,
          0.765999972820282
        ],
        [
          0.5419999957084656,
          0.7680000066757202
        ],
        [
          0.5400000214576721,
          0.777999997138977
        ],
        [
          0.5360000133514404,
          0.7799999713897705
        ],
        [
          0.5339999794960022,
          0.7960000038146973
        ],
        [
          0.5199999809265137,
          0.8100000023841858
        ],
        [
          0.5180000066757202,
          0.8220000267028809
        ],
        [
          0.49399998784065247,
          0.8539999723434448
        ],
        [
          0.49399998784065247,
          0.8700000047683716
        ],
        [
          0.5080000162124634,
          0.8820000290870667
        ],
        [
          0.5180000066757202,
          0.8840000033378601
        ],
        [
          0.5879999995231628,
          0.8820000290870667
        ],
        [
          0.5899999737739563,
          0.878000020980835
        ],
        [
          0.6240000128746033,
          0.8700000047683716
        ],
        [
          0.6259999871253967,
          0.8659999966621399
        ],
        [
          0.6460000276565552,
          0.8579999804496765
        ],
        [
          0.6480000019073486,
          0.8539999723434448
        ],
        [
          0.6579999923706055,
          0.8519999980926514
        ],
        [
          0.6600000262260437,
          0.8479999899864197
        ],
        [
          0.6679999828338623,
          0.8460000157356262
        ],
        [
          0.6819999814033508,
          0.8339999914169312
        ],
        [
          0.6859999895095825,
          0.8339999914169312
        ],
        [
          0.7179999947547913,
          0.8040000200271606
        ],
        [
          0.722000002861023,
          0.8040000200271606
        ],
        [
          0.7440000176429749,
          0.777999997138977
        ],
        [
          0.7459999918937683,
          0.7680000066757202
        ],
        [
          0.7559999823570251,
          0.7559999823570251
        ],
        [
          0.7599999904632568,
          0.7419999837875366
        ],
        [
          0.7639999985694885,
          0.7379999756813049
        ],
        [
          0.7720000147819519,
          0.7139999866485596
        ],
        [
          0.7720000147819519,
          0.6819999814033508
        ],
        [
          0.765999972820282,
          0.6639999747276306
        ],
        [
          0.7519999742507935,
          0.6460000276565552
        ],
        [
          0.7239999771118164,
          0.6460000276565552
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7419999837875366,
          0.6480000019073486
        ],
        [
          0.722000002861023,
          0.6499999761581421
        ],
        [
          0.7160000205039978,
          0.6600000262260437
        ],
        [
          0.7080000042915344,
          0.6620000004768372
        ],
        [
          0.7059999704360962,
          0.6660000085830688
        ],
        [
          0.6899999976158142,
          0.6679999828338623
        ],
        [
          0.6880000233650208,
          0.671999990940094
        ],
        [
          0.6679999828338623,
          0.6759999990463257
        ],
        [
          0.6660000085830688,
          0.6800000071525574
        ],
        [
          0.656000018119812,
          0.6819999814033508
        ],
        [
          0.6240000128746033,
          0.7059999704360962
        ],
        [
          0.6200000047683716,
          0.7059999704360962
        ],
        [
          0.5899999737739563,
          0.734000027179718
        ],
        [
          0.5860000252723694,
          0.734000027179718
        ],
        [
          0.5519999861717224,
          0.7599999904632568
        ],
        [
          0.5519999861717224,
          0.7680000066757202
        ],
        [
          0.5460000038146973,
          0.7739999890327454
        ],
        [
          0.5440000295639038,
          0.7839999794960022
        ],
        [
          0.5320000052452087,
          0.7979999780654907
        ],
        [
          0.5320000052452087,
          0.8019999861717224
        ],
        [
          0.5180000066757202,
          0.8140000104904175
        ],
        [
          0.49799999594688416,
          0.8460000157356262
        ],
        [
          0.4959999918937683,
          0.8579999804496765
        ],
        [
          0.492000013589859,
          0.8600000143051147
        ],
        [
          0.492000013589859,
          0.8700000047683716
        ],
        [
          0.4959999918937683,
          0.871999979019165
        ],
        [
          0.4959999918937683,
          0.8759999871253967
        ],
        [
          0.5099999904632568,
          0.8880000114440918
        ],
        [
          0.5299999713897705,
          0.8899999856948853
        ],
        [
          0.5699999928474426,
          0.8880000114440918
        ],
        [
          0.5720000267028809,
          0.8840000033378601
        ],
        [
          0.6000000238418579,
          0.8820000290870667
        ],
        [
          0.6039999723434448,
          0.878000020980835
        ],
        [
          0.6179999709129333,
          0.8759999871253967
        ],
        [
          0.6200000047683716,
          0.871999979019165
        ],
        [
          0.6320000290870667,
          0.8700000047683716
        ],
        [
          0.6340000033378601,
          0.8659999966621399
        ],
        [
          0.6539999842643738,
          0.8579999804496765
        ],
        [
          0.7300000190734863,
          0.7979999780654907
        ],
        [
          0.7540000081062317,
          0.7720000147819519
        ],
        [
          0.7580000162124634,
          0.7559999823570251
        ],
        [
          0.7620000243186951,
          0.7540000081062317
        ],
        [
          0.7699999809265137,
          0.7300000190734863
        ],
        [
          0.7739999890327454,
          0.7279999852180481
        ],
        [
          0.7760000228881836,
          0.7160000205039978
        ],
        [
          0.7760000228881836,
          0.6759999990463257
        ],
        [
          0.7559999823570251,
          0.6480000019073486
        ],
        [
          0.7419999837875366,
          0.6480000019073486
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7260000109672546,
          0.6460000276565552
        ],
        [
          0.7239999771118164,
          0.6499999761581421
        ],
        [
          0.7200000286102295,
          0.6499999761581421
        ],
        [
          0.7179999947547913,
          0.656000018119812
        ],
        [
          0.7059999704360962,
          0.6579999923706055
        ],
        [
          0.7039999961853027,
          0.6620000004768372
        ],
        [
          0.6859999895095825,
          0.6679999828338623
        ],
        [
          0.6819999814033508,
          0.6740000247955322
        ],
        [
          0.6700000166893005,
          0.6759999990463257
        ],
        [
          0.656000018119812,
          0.6880000233650208
        ],
        [
          0.6520000100135803,
          0.6880000233650208
        ],
        [
          0.6480000019073486,
          0.6940000057220459
        ],
        [
          0.6320000290870667,
          0.7020000219345093
        ],
        [
          0.628000020980835,
          0.7080000042915344
        ],
        [
          0.6240000128746033,
          0.7080000042915344
        ],
        [
          0.6019999980926514,
          0.7260000109672546
        ],
        [
          0.5979999899864197,
          0.7260000109672546
        ],
        [
          0.5820000171661377,
          0.7419999837875366
        ],
        [
          0.578000009059906,
          0.7419999837875366
        ],
        [
          0.5619999766349792,
          0.7599999904632568
        ],
        [
          0.5339999794960022,
          0.8059999942779541
        ],
        [
          0.5059999823570251,
          0.8360000252723694
        ],
        [
          0.5059999823570251,
          0.8399999737739563
        ],
        [
          0.4959999918937683,
          0.8479999899864197
        ],
        [
          0.49399998784065247,
          0.8600000143051147
        ],
        [
          0.49000000953674316,
          0.8640000224113464
        ],
        [
          0.49000000953674316,
          0.8759999871253967
        ],
        [
          0.5019999742507935,
          0.8899999856948853
        ],
        [
          0.5059999823570251,
          0.8899999856948853
        ],
        [
          0.5080000162124634,
          0.8939999938011169
        ],
        [
          0.5540000200271606,
          0.8939999938011169
        ],
        [
          0.5540000200271606,
          0.8899999856948853
        ],
        [
          0.5960000157356262,
          0.8880000114440918
        ],
        [
          0.5979999899864197,
          0.8840000033378601
        ],
        [
          0.6159999966621399,
          0.8820000290870667
        ],
        [
          0.6179999709129333,
          0.878000020980835
        ],
        [
          0.6420000195503235,
          0.8700000047683716
        ],
        [
          0.6439999938011169,
          0.8659999966621399
        ],
        [
          0.6520000100135803,
          0.8640000224113464
        ],
        [
          0.6700000166893005,
          0.8519999980926514
        ],
        [
          0.7400000095367432,
          0.7900000214576721
        ],
        [
          0.7400000095367432,
          0.7860000133514404
        ],
        [
          0.75,
          0.777999997138977
        ],
        [
          0.75,
          0.7739999890327454
        ],
        [
          0.7559999823570251,
          0.7680000066757202
        ],
        [
          0.7699999809265137,
          0.7379999756813049
        ],
        [
          0.7739999890327454,
          0.7120000123977661
        ],
        [
          0.777999997138977,
          0.7080000042915344
        ],
        [
          0.777999997138977,
          0.6819999814033508
        ],
        [
          0.7739999890327454,
          0.6800000071525574
        ],
        [
          0.7720000147819519,
          0.6679999828338623
        ],
        [
          0.7580000162124634,
          0.6499999761581421
        ],
        [
          0.7519999742507935,
          0.6460000276565552
        ],
        [
          0.7260000109672546,
          0.6460000276565552
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7360000014305115,
          0.6499999761581421
        ],
        [
          0.734000027179718,
          0.6539999842643738
        ],
        [
          0.7239999771118164,
          0.6539999842643738
        ],
        [
          0.722000002861023,
          0.6600000262260437
        ],
        [
          0.7039999961853027,
          0.6620000004768372
        ],
        [
          0.7020000219345093,
          0.6660000085830688
        ],
        [
          0.6759999990463257,
          0.6740000247955322
        ],
        [
          0.6740000247955322,
          0.6779999732971191
        ],
        [
          0.6700000166893005,
          0.6779999732971191
        ],
        [
          0.6499999761581421,
          0.6919999718666077
        ],
        [
          0.6359999775886536,
          0.7080000042915344
        ],
        [
          0.621999979019165,
          0.7160000205039978
        ],
        [
          0.5960000157356262,
          0.7400000095367432
        ],
        [
          0.5920000076293945,
          0.7400000095367432
        ],
        [
          0.5839999914169312,
          0.75
        ],
        [
          0.5799999833106995,
          0.75
        ],
        [
          0.5640000104904175,
          0.7699999809265137
        ],
        [
          0.5540000200271606,
          0.7760000228881836
        ],
        [
          0.550000011920929,
          0.7979999780654907
        ],
        [
          0.5040000081062317,
          0.8479999899864197
        ],
        [
          0.49799999594688416,
          0.8640000224113464
        ],
        [
          0.49399998784065247,
          0.8659999966621399
        ],
        [
          0.49399998784065247,
          0.878000020980835
        ],
        [
          0.5139999985694885,
          0.8939999938011169
        ],
        [
          0.5339999794960022,
          0.8960000276565552
        ],
        [
          0.5600000023841858,
          0.8939999938011169
        ],
        [
          0.5640000104904175,
          0.8899999856948853
        ],
        [
          0.6019999980926514,
          0.8880000114440918
        ],
        [
          0.6039999723434448,
          0.8840000033378601
        ],
        [
          0.621999979019165,
          0.8820000290870667
        ],
        [
          0.6240000128746033,
          0.878000020980835
        ],
        [
          0.6359999775886536,
          0.8759999871253967
        ],
        [
          0.6380000114440918,
          0.871999979019165
        ],
        [
          0.6480000019073486,
          0.8700000047683716
        ],
        [
          0.6579999923706055,
          0.8600000143051147
        ],
        [
          0.6620000004768372,
          0.8600000143051147
        ],
        [
          0.6899999976158142,
          0.8360000252723694
        ],
        [
          0.6940000057220459,
          0.8360000252723694
        ],
        [
          0.6980000138282776,
          0.8299999833106995
        ],
        [
          0.7139999866485596,
          0.8220000267028809
        ],
        [
          0.7279999852180481,
          0.8059999942779541
        ],
        [
          0.7459999918937683,
          0.7919999957084656
        ],
        [
          0.7459999918937683,
          0.7879999876022339
        ],
        [
          0.765999972820282,
          0.7620000243186951
        ],
        [
          0.7699999809265137,
          0.7400000095367432
        ],
        [
          0.7739999890327454,
          0.7379999756813049
        ],
        [
          0.7760000228881836,
          0.6959999799728394
        ],
        [
          0.7799999713897705,
          0.6919999718666077
        ],
        [
          0.7760000228881836,
          0.6899999976158142
        ],
        [
          0.7739999890327454,
          0.671999990940094
        ],
        [
          0.7559999823570251,
          0.6539999842643738
        ],
        [
          0.7360000014305115,
          0.6499999761581421
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7319999933242798,
          0.6579999923706055
        ],
        [
          0.7300000190734863,
          0.6620000004768372
        ],
        [
          0.6980000138282776,
          0.6700000166893005
        ],
        [
          0.6959999799728394,
          0.6740000247955322
        ],
        [
          0.6759999990463257,
          0.6819999814033508
        ],
        [
          0.6499999761581421,
          0.7059999704360962
        ],
        [
          0.6460000276565552,
          0.7059999704360962
        ],
        [
          0.6380000114440918,
          0.7160000205039978
        ],
        [
          0.6299999952316284,
          0.7179999947547913
        ],
        [
          0.6179999709129333,
          0.7300000190734863
        ],
        [
          0.6140000224113464,
          0.7300000190734863
        ],
        [
          0.5740000009536743,
          0.7699999809265137
        ],
        [
          0.5680000185966492,
          0.7820000052452087
        ],
        [
          0.5600000023841858,
          0.7879999876022339
        ],
        [
          0.5600000023841858,
          0.7960000038146973
        ],
        [
          0.5479999780654907,
          0.8080000281333923
        ],
        [
          0.5479999780654907,
          0.8119999766349792
        ],
        [
          0.515999972820282,
          0.8420000076293945
        ],
        [
          0.4959999918937683,
          0.8679999709129333
        ],
        [
          0.4959999918937683,
          0.8799999952316284
        ],
        [
          0.5019999742507935,
          0.8920000195503235
        ],
        [
          0.5059999823570251,
          0.8920000195503235
        ],
        [
          0.5080000162124634,
          0.8960000276565552
        ],
        [
          0.5799999833106995,
          0.8960000276565552
        ],
        [
          0.5839999914169312,
          0.8920000195503235
        ],
        [
          0.6140000224113464,
          0.8899999856948853
        ],
        [
          0.6179999709129333,
          0.8859999775886536
        ],
        [
          0.6320000290870667,
          0.8840000033378601
        ],
        [
          0.6340000033378601,
          0.8799999952316284
        ],
        [
          0.6460000276565552,
          0.878000020980835
        ],
        [
          0.6520000100135803,
          0.871999979019165
        ],
        [
          0.656000018119812,
          0.871999979019165
        ],
        [
          0.6660000085830688,
          0.8619999885559082
        ],
        [
          0.6700000166893005,
          0.8619999885559082
        ],
        [
          0.6859999895095825,
          0.8479999899864197
        ],
        [
          0.6899999976158142,
          0.8479999899864197
        ],
        [
          0.7120000123977661,
          0.8259999752044678
        ],
        [
          0.7160000205039978,
          0.8259999752044678
        ],
        [
          0.75,
          0.7900000214576721
        ],
        [
          0.7620000243186951,
          0.7720000147819519
        ],
        [
          0.7699999809265137,
          0.7480000257492065
        ],
        [
          0.7739999890327454,
          0.7459999918937683
        ],
        [
          0.777999997138977,
          0.7279999852180481
        ],
        [
          0.7820000052452087,
          0.7239999771118164
        ],
        [
          0.7839999794960022,
          0.7059999704360962
        ],
        [
          0.7879999876022339,
          0.7039999961853027
        ],
        [
          0.7879999876022339,
          0.6859999895095825
        ],
        [
          0.7739999890327454,
          0.6639999747276306
        ],
        [
          0.7639999985694885,
          0.6620000004768372
        ],
        [
          0.7620000243186951,
          0.6579999923706055
        ],
        [
          0.7319999933242798,
          0.6579999923706055
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7379999756813049,
          0.6600000262260437
        ],
        [
          0.7319999933242798,
          0.6620000004768372
        ],
        [
          0.7300000190734863,
          0.6660000085830688
        ],
        [
          0.7179999947547913,
          0.6679999828338623
        ],
        [
          0.7160000205039978,
          0.671999990940094
        ],
        [
          0.6919999718666077,
          0.6800000071525574
        ],
        [
          0.6899999976158142,
          0.6840000152587891
        ],
        [
          0.6779999732971191,
          0.6859999895095825
        ],
        [
          0.6200000047683716,
          0.7300000190734863
        ],
        [
          0.5680000185966492,
          0.7860000133514404
        ],
        [
          0.5680000185966492,
          0.7900000214576721
        ],
        [
          0.5600000023841858,
          0.7960000038146973
        ],
        [
          0.5540000200271606,
          0.8080000281333923
        ],
        [
          0.550000011920929,
          0.8080000281333923
        ],
        [
          0.515999972820282,
          0.843999981880188
        ],
        [
          0.5080000162124634,
          0.8619999885559082
        ],
        [
          0.5019999742507935,
          0.8679999709129333
        ],
        [
          0.5040000081062317,
          0.8859999775886536
        ],
        [
          0.5120000243186951,
          0.8960000276565552
        ],
        [
          0.5759999752044678,
          0.8960000276565552
        ],
        [
          0.5799999833106995,
          0.8920000195503235
        ],
        [
          0.6140000224113464,
          0.8899999856948853
        ],
        [
          0.6179999709129333,
          0.8859999775886536
        ],
        [
          0.6320000290870667,
          0.8840000033378601
        ],
        [
          0.6340000033378601,
          0.8799999952316284
        ],
        [
          0.6460000276565552,
          0.878000020980835
        ],
        [
          0.6480000019073486,
          0.8740000128746033
        ],
        [
          0.6639999747276306,
          0.8679999709129333
        ],
        [
          0.7120000123977661,
          0.8259999752044678
        ],
        [
          0.7260000109672546,
          0.8180000185966492
        ],
        [
          0.7440000176429749,
          0.7979999780654907
        ],
        [
          0.7480000257492065,
          0.7979999780654907
        ],
        [
          0.7739999890327454,
          0.7559999823570251
        ],
        [
          0.777999997138977,
          0.7360000014305115
        ],
        [
          0.7839999794960022,
          0.7239999771118164
        ],
        [
          0.7839999794960022,
          0.7120000123977661
        ],
        [
          0.7879999876022339,
          0.7080000042915344
        ],
        [
          0.7879999876022339,
          0.6859999895095825
        ],
        [
          0.7839999794960022,
          0.6840000152587891
        ],
        [
          0.7839999794960022,
          0.6779999732971191
        ],
        [
          0.777999997138977,
          0.671999990940094
        ],
        [
          0.777999997138977,
          0.6679999828338623
        ],
        [
          0.7699999809265137,
          0.6620000004768372
        ],
        [
          0.7379999756813049,
          0.6600000262260437
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7580000162124634,
          0.6660000085830688
        ],
        [
          0.7480000257492065,
          0.6679999828338623
        ],
        [
          0.7440000176429749,
          0.671999990940094
        ],
        [
          0.7360000014305115,
          0.671999990940094
        ],
        [
          0.7179999947547913,
          0.6840000152587891
        ],
        [
          0.7059999704360962,
          0.6859999895095825
        ],
        [
          0.7039999961853027,
          0.6899999976158142
        ],
        [
          0.6859999895095825,
          0.6919999718666077
        ],
        [
          0.6840000152587891,
          0.6959999799728394
        ],
        [
          0.6600000262260437,
          0.7020000219345093
        ],
        [
          0.6579999923706055,
          0.7059999704360962
        ],
        [
          0.6480000019073486,
          0.7080000042915344
        ],
        [
          0.6439999938011169,
          0.7139999866485596
        ],
        [
          0.6399999856948853,
          0.7139999866485596
        ],
        [
          0.6320000290870667,
          0.7239999771118164
        ],
        [
          0.628000020980835,
          0.7239999771118164
        ],
        [
          0.5820000171661377,
          0.7720000147819519
        ],
        [
          0.5820000171661377,
          0.7760000228881836
        ],
        [
          0.5699999928474426,
          0.7900000214576721
        ],
        [
          0.5540000200271606,
          0.8180000185966492
        ],
        [
          0.5239999890327454,
          0.8460000157356262
        ],
        [
          0.515999972820282,
          0.8640000224113464
        ],
        [
          0.5099999904632568,
          0.8700000047683716
        ],
        [
          0.5099999904632568,
          0.8880000114440918
        ],
        [
          0.5220000147819519,
          0.8980000019073486
        ],
        [
          0.5759999752044678,
          0.8980000019073486
        ],
        [
          0.5799999833106995,
          0.8939999938011169
        ],
        [
          0.6079999804496765,
          0.8920000195503235
        ],
        [
          0.6119999885559082,
          0.8880000114440918
        ],
        [
          0.628000020980835,
          0.8859999775886536
        ],
        [
          0.6320000290870667,
          0.8820000290870667
        ],
        [
          0.6439999938011169,
          0.8799999952316284
        ],
        [
          0.6460000276565552,
          0.8759999871253967
        ],
        [
          0.6579999923706055,
          0.8740000128746033
        ],
        [
          0.6859999895095825,
          0.8519999980926514
        ],
        [
          0.6899999976158142,
          0.8519999980926514
        ],
        [
          0.699999988079071,
          0.8399999737739563
        ],
        [
          0.7039999961853027,
          0.8399999737739563
        ],
        [
          0.7179999947547913,
          0.828000009059906
        ],
        [
          0.7739999890327454,
          0.765999972820282
        ],
        [
          0.7820000052452087,
          0.75
        ],
        [
          0.7839999794960022,
          0.7319999933242798
        ],
        [
          0.7879999876022339,
          0.7300000190734863
        ],
        [
          0.7900000214576721,
          0.6840000152587891
        ],
        [
          0.7839999794960022,
          0.6779999732971191
        ],
        [
          0.7839999794960022,
          0.6740000247955322
        ],
        [
          0.7760000228881836,
          0.671999990940094
        ],
        [
          0.7739999890327454,
          0.6679999828338623
        ],
        [
          0.7580000162124634,
          0.6660000085830688
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7559999823570251,
          0.6740000247955322
        ],
        [
          0.7260000109672546,
          0.6819999814033508
        ],
        [
          0.7179999947547913,
          0.6899999976158142
        ],
        [
          0.7020000219345093,
          0.6919999718666077
        ],
        [
          0.699999988079071,
          0.6959999799728394
        ],
        [
          0.6819999814033508,
          0.6980000138282776
        ],
        [
          0.6800000071525574,
          0.7020000219345093
        ],
        [
          0.6499999761581421,
          0.7099999785423279
        ],
        [
          0.6480000019073486,
          0.7139999866485596
        ],
        [
          0.6259999871253967,
          0.7260000109672546
        ],
        [
          0.593999981880188,
          0.7599999904632568
        ],
        [
          0.5920000076293945,
          0.765999972820282
        ],
        [
          0.5879999995231628,
          0.765999972820282
        ],
        [
          0.578000009059906,
          0.7839999794960022
        ],
        [
          0.5680000185966492,
          0.7940000295639038
        ],
        [
          0.5659999847412109,
          0.8019999861717224
        ],
        [
          0.5559999942779541,
          0.8080000281333923
        ],
        [
          0.5540000200271606,
          0.8240000009536743
        ],
        [
          0.5220000147819519,
          0.8579999804496765
        ],
        [
          0.5220000147819519,
          0.8679999709129333
        ],
        [
          0.5180000066757202,
          0.8700000047683716
        ],
        [
          0.5180000066757202,
          0.8859999775886536
        ],
        [
          0.5220000147819519,
          0.8880000114440918
        ],
        [
          0.5220000147819519,
          0.8920000195503235
        ],
        [
          0.5339999794960022,
          0.8980000019073486
        ],
        [
          0.5799999833106995,
          0.8980000019073486
        ],
        [
          0.5820000171661377,
          0.8939999938011169
        ],
        [
          0.6179999709129333,
          0.8920000195503235
        ],
        [
          0.6200000047683716,
          0.8880000114440918
        ],
        [
          0.6359999775886536,
          0.8859999775886536
        ],
        [
          0.6380000114440918,
          0.8820000290870667
        ],
        [
          0.6499999761581421,
          0.8799999952316284
        ],
        [
          0.6759999990463257,
          0.8619999885559082
        ],
        [
          0.6800000071525574,
          0.8619999885559082
        ],
        [
          0.7020000219345093,
          0.8399999737739563
        ],
        [
          0.7059999704360962,
          0.8399999737739563
        ],
        [
          0.7139999866485596,
          0.8299999833106995
        ],
        [
          0.7179999947547913,
          0.8299999833106995
        ],
        [
          0.7400000095367432,
          0.8059999942779541
        ],
        [
          0.7440000176429749,
          0.8059999942779541
        ],
        [
          0.7440000176429749,
          0.8019999861717224
        ],
        [
          0.7620000243186951,
          0.7839999794960022
        ],
        [
          0.7820000052452087,
          0.7540000081062317
        ],
        [
          0.7900000214576721,
          0.7200000286102295
        ],
        [
          0.7879999876022339,
          0.6819999814033508
        ],
        [
          0.777999997138977,
          0.6759999990463257
        ],
        [
          0.7559999823570251,
          0.6740000247955322
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7559999823570251,
          0.6819999814033508
        ],
        [
          0.7519999742507935,
          0.6859999895095825
        ],
        [
          0.7379999756813049,
          0.6859999895095825
        ],
        [
          0.734000027179718,
          0.6899999976158142
        ],
        [
          0.7139999866485596,
          0.6919999718666077
        ],
        [
          0.7120000123977661,
          0.6959999799728394
        ],
        [
          0.699999988079071,
          0.6959999799728394
        ],
        [
          0.6899999976158142,
          0.7020000219345093
        ],
        [
          0.671999990940094,
          0.7039999961853027
        ],
        [
          0.6700000166893005,
          0.7080000042915344
        ],
        [
          0.6579999923706055,
          0.7099999785423279
        ],
        [
          0.6299999952316284,
          0.7260000109672546
        ],
        [
          0.6019999980926514,
          0.7480000257492065
        ],
        [
          0.5799999833106995,
          0.7699999809265137
        ],
        [
          0.5720000267028809,
          0.7860000133514404
        ],
        [
          0.5659999847412109,
          0.7879999876022339
        ],
        [
          0.5659999847412109,
          0.7919999957084656
        ],
        [
          0.5619999766349792,
          0.7940000295639038
        ],
        [
          0.5600000023841858,
          0.8100000023841858
        ],
        [
          0.550000011920929,
          0.8220000267028809
        ],
        [
          0.5419999957084656,
          0.8399999737739563
        ],
        [
          0.5260000228881836,
          0.8539999723434448
        ],
        [
          0.5260000228881836,
          0.8619999885559082
        ],
        [
          0.5199999809265137,
          0.871999979019165
        ],
        [
          0.5199999809265137,
          0.8820000290870667
        ],
        [
          0.5239999890327454,
          0.8840000033378601
        ],
        [
          0.5260000228881836,
          0.8939999938011169
        ],
        [
          0.5619999766349792,
          0.8960000276565552
        ],
        [
          0.5619999766349792,
          0.8999999761581421
        ],
        [
          0.5659999847412109,
          0.8960000276565552
        ],
        [
          0.6100000143051147,
          0.8939999938011169
        ],
        [
          0.6140000224113464,
          0.8899999856948853
        ],
        [
          0.6299999952316284,
          0.8880000114440918
        ],
        [
          0.6340000033378601,
          0.8840000033378601
        ],
        [
          0.6460000276565552,
          0.8820000290870667
        ],
        [
          0.6480000019073486,
          0.878000020980835
        ],
        [
          0.6600000262260437,
          0.8759999871253967
        ],
        [
          0.6759999990463257,
          0.8600000143051147
        ],
        [
          0.6880000233650208,
          0.8539999723434448
        ],
        [
          0.6959999799728394,
          0.843999981880188
        ],
        [
          0.699999988079071,
          0.843999981880188
        ],
        [
          0.7160000205039978,
          0.8320000171661377
        ],
        [
          0.7699999809265137,
          0.7699999809265137
        ],
        [
          0.7699999809265137,
          0.765999972820282
        ],
        [
          0.7799999713897705,
          0.7540000081062317
        ],
        [
          0.7820000052452087,
          0.7379999756813049
        ],
        [
          0.7860000133514404,
          0.7360000014305115
        ],
        [
          0.7860000133514404,
          0.6919999718666077
        ],
        [
          0.7760000228881836,
          0.6859999895095825
        ],
        [
          0.7639999985694885,
          0.6859999895095825
        ],
        [
          0.7620000243186951,
          0.6819999814033508
        ],
        [
          0.7559999823570251,
          0.6819999814033508
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7440000176429749,
          0.6859999895095825
        ],
        [
          0.7419999837875366,
          0.6899999976158142
        ],
        [
          0.7200000286102295,
          0.6919999718666077
        ],
        [
          0.7179999947547913,
          0.6959999799728394
        ],
        [
          0.6880000233650208,
          0.6980000138282776
        ],
        [
          0.6840000152587891,
          0.7020000219345093
        ],
        [
          0.6539999842643738,
          0.7020000219345093
        ],
        [
          0.6520000100135803,
          0.7059999704360962
        ],
        [
          0.6359999775886536,
          0.7080000042915344
        ],
        [
          0.628000020980835,
          0.7179999947547913
        ],
        [
          0.6179999709129333,
          0.7200000286102295
        ],
        [
          0.6039999723434448,
          0.7360000014305115
        ],
        [
          0.6000000238418579,
          0.7360000014305115
        ],
        [
          0.5759999752044678,
          0.7620000243186951
        ],
        [
          0.5740000009536743,
          0.7680000066757202
        ],
        [
          0.5640000104904175,
          0.7699999809265137
        ],
        [
          0.5559999942779541,
          0.7979999780654907
        ],
        [
          0.5519999861717224,
          0.8019999861717224
        ],
        [
          0.550000011920929,
          0.8259999752044678
        ],
        [
          0.5460000038146973,
          0.8299999833106995
        ],
        [
          0.5379999876022339,
          0.8539999723434448
        ],
        [
          0.5379999876022339,
          0.8759999871253967
        ],
        [
          0.5460000038146973,
          0.8859999775886536
        ],
        [
          0.5559999942779541,
          0.8859999775886536
        ],
        [
          0.5580000281333923,
          0.8899999856948853
        ],
        [
          0.5740000009536743,
          0.8899999856948853
        ],
        [
          0.5759999752044678,
          0.8859999775886536
        ],
        [
          0.6240000128746033,
          0.8840000033378601
        ],
        [
          0.628000020980835,
          0.8799999952316284
        ],
        [
          0.6340000033378601,
          0.8799999952316284
        ],
        [
          0.6359999775886536,
          0.8759999871253967
        ],
        [
          0.6520000100135803,
          0.8740000128746033
        ],
        [
          0.6539999842643738,
          0.8700000047683716
        ],
        [
          0.6660000085830688,
          0.8679999709129333
        ],
        [
          0.7300000190734863,
          0.8240000009536743
        ],
        [
          0.7300000190734863,
          0.8199999928474426
        ],
        [
          0.7480000257492065,
          0.8019999861717224
        ],
        [
          0.7559999823570251,
          0.7860000133514404
        ],
        [
          0.7680000066757202,
          0.7739999890327454
        ],
        [
          0.7680000066757202,
          0.7699999809265137
        ],
        [
          0.777999997138977,
          0.7580000162124634
        ],
        [
          0.7799999713897705,
          0.7419999837875366
        ],
        [
          0.7839999794960022,
          0.7400000095367432
        ],
        [
          0.7839999794960022,
          0.6980000138282776
        ],
        [
          0.777999997138977,
          0.6919999718666077
        ],
        [
          0.7680000066757202,
          0.6899999976158142
        ],
        [
          0.765999972820282,
          0.6859999895095825
        ],
        [
          0.7440000176429749,
          0.6859999895095825
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.75,
          0.6940000057220459
        ],
        [
          0.7480000257492065,
          0.6980000138282776
        ],
        [
          0.7160000205039978,
          0.699999988079071
        ],
        [
          0.7120000123977661,
          0.7039999961853027
        ],
        [
          0.6759999990463257,
          0.7039999961853027
        ],
        [
          0.6740000247955322,
          0.699999988079071
        ],
        [
          0.6679999828338623,
          0.699999988079071
        ],
        [
          0.6639999747276306,
          0.7039999961853027
        ],
        [
          0.6359999775886536,
          0.7059999704360962
        ],
        [
          0.6259999871253967,
          0.7139999866485596
        ],
        [
          0.6119999885559082,
          0.7160000205039978
        ],
        [
          0.6019999980926514,
          0.7260000109672546
        ],
        [
          0.593999981880188,
          0.7279999852180481
        ],
        [
          0.5640000104904175,
          0.7599999904632568
        ],
        [
          0.5619999766349792,
          0.7760000228881836
        ],
        [
          0.5580000281333923,
          0.777999997138977
        ],
        [
          0.5559999942779541,
          0.8059999942779541
        ],
        [
          0.5519999861717224,
          0.8100000023841858
        ],
        [
          0.550000011920929,
          0.8259999752044678
        ],
        [
          0.5460000038146973,
          0.828000009059906
        ],
        [
          0.5440000295639038,
          0.8379999995231628
        ],
        [
          0.5339999794960022,
          0.8539999723434448
        ],
        [
          0.5339999794960022,
          0.8600000143051147
        ],
        [
          0.527999997138977,
          0.8640000224113464
        ],
        [
          0.527999997138977,
          0.878000020980835
        ],
        [
          0.5400000214576721,
          0.8880000114440918
        ],
        [
          0.5740000009536743,
          0.8880000114440918
        ],
        [
          0.5899999737739563,
          0.8859999775886536
        ],
        [
          0.593999981880188,
          0.8820000290870667
        ],
        [
          0.6119999885559082,
          0.8820000290870667
        ],
        [
          0.6140000224113464,
          0.878000020980835
        ],
        [
          0.6620000004768372,
          0.8700000047683716
        ],
        [
          0.6639999747276306,
          0.8659999966621399
        ],
        [
          0.6759999990463257,
          0.8640000224113464
        ],
        [
          0.7120000123977661,
          0.8420000076293945
        ],
        [
          0.765999972820282,
          0.7820000052452087
        ],
        [
          0.7799999713897705,
          0.7540000081062317
        ],
        [
          0.7799999713897705,
          0.7419999837875366
        ],
        [
          0.7839999794960022,
          0.7379999756813049
        ],
        [
          0.7839999794960022,
          0.7099999785423279
        ],
        [
          0.7799999713897705,
          0.7059999704360962
        ],
        [
          0.7799999713897705,
          0.699999988079071
        ],
        [
          0.7680000066757202,
          0.6940000057220459
        ],
        [
          0.75,
          0.6940000057220459
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7279999852180481,
          0.7059999704360962
        ],
        [
          0.7239999771118164,
          0.7099999785423279
        ],
        [
          0.6919999718666077,
          0.7120000123977661
        ],
        [
          0.6899999976158142,
          0.7160000205039978
        ],
        [
          0.656000018119812,
          0.7179999947547913
        ],
        [
          0.6539999842643738,
          0.722000002861023
        ],
        [
          0.6480000019073486,
          0.722000002861023
        ],
        [
          0.6439999938011169,
          0.7260000109672546
        ],
        [
          0.6259999871253967,
          0.7279999852180481
        ],
        [
          0.6240000128746033,
          0.7319999933242798
        ],
        [
          0.6100000143051147,
          0.734000027179718
        ],
        [
          0.5699999928474426,
          0.7540000081062317
        ],
        [
          0.5580000281333923,
          0.7559999823570251
        ],
        [
          0.5400000214576721,
          0.7820000052452087
        ],
        [
          0.5320000052452087,
          0.8100000023841858
        ],
        [
          0.5260000228881836,
          0.8140000104904175
        ],
        [
          0.5260000228881836,
          0.8220000267028809
        ],
        [
          0.5220000147819519,
          0.8259999752044678
        ],
        [
          0.5199999809265137,
          0.843999981880188
        ],
        [
          0.5220000147819519,
          0.8799999952316284
        ],
        [
          0.5320000052452087,
          0.8859999775886536
        ],
        [
          0.5379999876022339,
          0.8859999775886536
        ],
        [
          0.5400000214576721,
          0.8899999856948853
        ],
        [
          0.5920000076293945,
          0.8899999856948853
        ],
        [
          0.593999981880188,
          0.8859999775886536
        ],
        [
          0.6140000224113464,
          0.8859999775886536
        ],
        [
          0.6179999709129333,
          0.8820000290870667
        ],
        [
          0.6380000114440918,
          0.8799999952316284
        ],
        [
          0.6420000195503235,
          0.8759999871253967
        ],
        [
          0.656000018119812,
          0.8740000128746033
        ],
        [
          0.7020000219345093,
          0.8519999980926514
        ],
        [
          0.7480000257492065,
          0.8040000200271606
        ],
        [
          0.7480000257492065,
          0.800000011920929
        ],
        [
          0.7639999985694885,
          0.7860000133514404
        ],
        [
          0.7720000147819519,
          0.765999972820282
        ],
        [
          0.7760000228881836,
          0.7639999985694885
        ],
        [
          0.777999997138977,
          0.7540000081062317
        ],
        [
          0.7760000228881836,
          0.7099999785423279
        ],
        [
          0.7720000147819519,
          0.7099999785423279
        ],
        [
          0.7699999809265137,
          0.7059999704360962
        ],
        [
          0.7279999852180481,
          0.7059999704360962
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7179999947547913,
          0.7080000042915344
        ],
        [
          0.7020000219345093,
          0.7099999785423279
        ],
        [
          0.699999988079071,
          0.7139999866485596
        ],
        [
          0.6740000247955322,
          0.7160000205039978
        ],
        [
          0.6700000166893005,
          0.7200000286102295
        ],
        [
          0.6359999775886536,
          0.722000002861023
        ],
        [
          0.6320000290870667,
          0.7260000109672546
        ],
        [
          0.6140000224113464,
          0.7279999852180481
        ],
        [
          0.6119999885559082,
          0.7319999933242798
        ],
        [
          0.5879999995231628,
          0.7379999756813049
        ],
        [
          0.5860000252723694,
          0.7419999837875366
        ],
        [
          0.5759999752044678,
          0.7440000176429749
        ],
        [
          0.5740000009536743,
          0.7480000257492065
        ],
        [
          0.5619999766349792,
          0.75
        ],
        [
          0.5260000228881836,
          0.7940000295639038
        ],
        [
          0.5239999890327454,
          0.8159999847412109
        ],
        [
          0.5199999809265137,
          0.8180000185966492
        ],
        [
          0.515999972820282,
          0.8339999914169312
        ],
        [
          0.5180000066757202,
          0.8700000047683716
        ],
        [
          0.5360000133514404,
          0.8840000033378601
        ],
        [
          0.5920000076293945,
          0.8859999775886536
        ],
        [
          0.6759999990463257,
          0.8619999885559082
        ],
        [
          0.7020000219345093,
          0.8460000157356262
        ],
        [
          0.7260000109672546,
          0.8240000009536743
        ],
        [
          0.7279999852180481,
          0.8180000185966492
        ],
        [
          0.734000027179718,
          0.8159999847412109
        ],
        [
          0.734000027179718,
          0.8119999766349792
        ],
        [
          0.7639999985694885,
          0.7820000052452087
        ],
        [
          0.7720000147819519,
          0.765999972820282
        ],
        [
          0.7699999809265137,
          0.7160000205039978
        ],
        [
          0.7620000243186951,
          0.7099999785423279
        ],
        [
          0.7519999742507935,
          0.7080000042915344
        ],
        [
          0.7179999947547913,
          0.7080000042915344
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.734000027179718,
          0.7020000219345093
        ],
        [
          0.6940000057220459,
          0.7099999785423279
        ],
        [
          0.6919999718666077,
          0.7139999866485596
        ],
        [
          0.6759999990463257,
          0.7139999866485596
        ],
        [
          0.6740000247955322,
          0.7179999947547913
        ],
        [
          0.6439999938011169,
          0.7260000109672546
        ],
        [
          0.6420000195503235,
          0.7300000190734863
        ],
        [
          0.6299999952316284,
          0.7319999933242798
        ],
        [
          0.6259999871253967,
          0.7360000014305115
        ],
        [
          0.5979999899864197,
          0.7419999837875366
        ],
        [
          0.593999981880188,
          0.7459999918937683
        ],
        [
          0.5619999766349792,
          0.7580000162124634
        ],
        [
          0.5360000133514404,
          0.7860000133514404
        ],
        [
          0.5360000133514404,
          0.7900000214576721
        ],
        [
          0.5299999713897705,
          0.7919999957084656
        ],
        [
          0.527999997138977,
          0.8080000281333923
        ],
        [
          0.5239999890327454,
          0.8100000023841858
        ],
        [
          0.5220000147819519,
          0.8240000009536743
        ],
        [
          0.5180000066757202,
          0.8259999752044678
        ],
        [
          0.5139999985694885,
          0.8479999899864197
        ],
        [
          0.5099999904632568,
          0.8519999980926514
        ],
        [
          0.5099999904632568,
          0.8740000128746033
        ],
        [
          0.527999997138977,
          0.8859999775886536
        ],
        [
          0.5479999780654907,
          0.8859999775886536
        ],
        [
          0.5519999861717224,
          0.8899999856948853
        ],
        [
          0.578000009059906,
          0.8899999856948853
        ],
        [
          0.5799999833106995,
          0.8859999775886536
        ],
        [
          0.6000000238418579,
          0.8859999775886536
        ],
        [
          0.6039999723434448,
          0.8820000290870667
        ],
        [
          0.6159999966621399,
          0.8820000290870667
        ],
        [
          0.6259999871253967,
          0.8799999952316284
        ],
        [
          0.6299999952316284,
          0.8759999871253967
        ],
        [
          0.6499999761581421,
          0.8740000128746033
        ],
        [
          0.6679999828338623,
          0.8640000224113464
        ],
        [
          0.6800000071525574,
          0.8619999885559082
        ],
        [
          0.6819999814033508,
          0.8579999804496765
        ],
        [
          0.6859999895095825,
          0.8579999804496765
        ],
        [
          0.7020000219345093,
          0.8460000157356262
        ],
        [
          0.7680000066757202,
          0.7739999890327454
        ],
        [
          0.7720000147819519,
          0.7459999918937683
        ],
        [
          0.7760000228881836,
          0.7419999837875366
        ],
        [
          0.7760000228881836,
          0.7239999771118164
        ],
        [
          0.7720000147819519,
          0.7200000286102295
        ],
        [
          0.7720000147819519,
          0.7099999785423279
        ],
        [
          0.7680000066757202,
          0.7039999961853027
        ],
        [
          0.734000027179718,
          0.7020000219345093
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7200000286102295,
          0.6980000138282776
        ],
        [
          0.7160000205039978,
          0.7020000219345093
        ],
        [
          0.6880000233650208,
          0.7080000042915344
        ],
        [
          0.6700000166893005,
          0.7179999947547913
        ],
        [
          0.6579999923706055,
          0.7200000286102295
        ],
        [
          0.656000018119812,
          0.7239999771118164
        ],
        [
          0.6299999952316284,
          0.7360000014305115
        ],
        [
          0.6140000224113464,
          0.7379999756813049
        ],
        [
          0.6100000143051147,
          0.7419999837875366
        ],
        [
          0.5979999899864197,
          0.7440000176429749
        ],
        [
          0.5960000157356262,
          0.7480000257492065
        ],
        [
          0.5820000171661377,
          0.75
        ],
        [
          0.5540000200271606,
          0.7699999809265137
        ],
        [
          0.5299999713897705,
          0.7940000295639038
        ],
        [
          0.5239999890327454,
          0.8119999766349792
        ],
        [
          0.5080000162124634,
          0.8399999737739563
        ],
        [
          0.5040000081062317,
          0.8420000076293945
        ],
        [
          0.5019999742507935,
          0.8560000061988831
        ],
        [
          0.5040000081062317,
          0.8820000290870667
        ],
        [
          0.5080000162124634,
          0.8820000290870667
        ],
        [
          0.5180000066757202,
          0.8920000195503235
        ],
        [
          0.5619999766349792,
          0.8920000195503235
        ],
        [
          0.5619999766349792,
          0.8880000114440918
        ],
        [
          0.6079999804496765,
          0.8859999775886536
        ],
        [
          0.6100000143051147,
          0.8820000290870667
        ],
        [
          0.6539999842643738,
          0.8700000047683716
        ],
        [
          0.6959999799728394,
          0.8460000157356262
        ],
        [
          0.7540000081062317,
          0.7879999876022339
        ],
        [
          0.7699999809265137,
          0.7580000162124634
        ],
        [
          0.7680000066757202,
          0.7139999866485596
        ],
        [
          0.7599999904632568,
          0.7059999704360962
        ],
        [
          0.7440000176429749,
          0.6980000138282776
        ],
        [
          0.7200000286102295,
          0.6980000138282776
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7139999866485596,
          0.7039999961853027
        ],
        [
          0.7120000123977661,
          0.7080000042915344
        ],
        [
          0.6899999976158142,
          0.7099999785423279
        ],
        [
          0.6859999895095825,
          0.7139999866485596
        ],
        [
          0.671999990940094,
          0.7160000205039978
        ],
        [
          0.6700000166893005,
          0.7200000286102295
        ],
        [
          0.6420000195503235,
          0.7279999852180481
        ],
        [
          0.6399999856948853,
          0.7319999933242798
        ],
        [
          0.6119999885559082,
          0.7400000095367432
        ],
        [
          0.6000000238418579,
          0.7459999918937683
        ],
        [
          0.5979999899864197,
          0.75
        ],
        [
          0.5799999833106995,
          0.7559999823570251
        ],
        [
          0.5699999928474426,
          0.765999972820282
        ],
        [
          0.5640000104904175,
          0.765999972820282
        ],
        [
          0.5440000295639038,
          0.7839999794960022
        ],
        [
          0.5299999713897705,
          0.7979999780654907
        ],
        [
          0.5220000147819519,
          0.8220000267028809
        ],
        [
          0.5040000081062317,
          0.8479999899864197
        ],
        [
          0.5,
          0.8600000143051147
        ],
        [
          0.5,
          0.878000020980835
        ],
        [
          0.5099999904632568,
          0.8899999856948853
        ],
        [
          0.578000009059906,
          0.8920000195503235
        ],
        [
          0.621999979019165,
          0.8840000033378601
        ],
        [
          0.6840000152587891,
          0.8539999723434448
        ],
        [
          0.7059999704360962,
          0.8320000171661377
        ],
        [
          0.7099999785423279,
          0.8320000171661377
        ],
        [
          0.734000027179718,
          0.8040000200271606
        ],
        [
          0.7379999756813049,
          0.8040000200271606
        ],
        [
          0.7620000243186951,
          0.7720000147819519
        ],
        [
          0.7620000243186951,
          0.7680000066757202
        ],
        [
          0.765999972820282,
          0.765999972820282
        ],
        [
          0.765999972820282,
          0.7260000109672546
        ],
        [
          0.7599999904632568,
          0.7200000286102295
        ],
        [
          0.7599999904632568,
          0.7160000205039978
        ],
        [
          0.7459999918937683,
          0.7080000042915344
        ],
        [
          0.734000027179718,
          0.7080000042915344
        ],
        [
          0.7319999933242798,
          0.7039999961853027
        ],
        [
          0.7139999866485596,
          0.7039999961853027
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.699999988079071,
          0.7080000042915344
        ],
        [
          0.6840000152587891,
          0.7099999785423279
        ],
        [
          0.6800000071525574,
          0.7139999866485596
        ],
        [
          0.6460000276565552,
          0.7160000205039978
        ],
        [
          0.6420000195503235,
          0.7200000286102295
        ],
        [
          0.6259999871253967,
          0.722000002861023
        ],
        [
          0.6240000128746033,
          0.7260000109672546
        ],
        [
          0.5820000171661377,
          0.7459999918937683
        ],
        [
          0.5720000267028809,
          0.7559999823570251
        ],
        [
          0.5659999847412109,
          0.7559999823570251
        ],
        [
          0.5640000104904175,
          0.7620000243186951
        ],
        [
          0.5600000023841858,
          0.7620000243186951
        ],
        [
          0.5339999794960022,
          0.7879999876022339
        ],
        [
          0.5180000066757202,
          0.828000009059906
        ],
        [
          0.5,
          0.8519999980926514
        ],
        [
          0.49799999594688416,
          0.8759999871253967
        ],
        [
          0.5120000243186951,
          0.8880000114440918
        ],
        [
          0.5220000147819519,
          0.8899999856948853
        ],
        [
          0.5879999995231628,
          0.8880000114440918
        ],
        [
          0.5899999737739563,
          0.8840000033378601
        ],
        [
          0.6100000143051147,
          0.8820000290870667
        ],
        [
          0.6119999885559082,
          0.878000020980835
        ],
        [
          0.6259999871253967,
          0.8759999871253967
        ],
        [
          0.628000020980835,
          0.871999979019165
        ],
        [
          0.6539999842643738,
          0.8640000224113464
        ],
        [
          0.656000018119812,
          0.8600000143051147
        ],
        [
          0.6620000004768372,
          0.8600000143051147
        ],
        [
          0.6779999732971191,
          0.8519999980926514
        ],
        [
          0.6959999799728394,
          0.8360000252723694
        ],
        [
          0.699999988079071,
          0.8360000252723694
        ],
        [
          0.722000002861023,
          0.8159999847412109
        ],
        [
          0.7260000109672546,
          0.8059999942779541
        ],
        [
          0.7300000190734863,
          0.8059999942779541
        ],
        [
          0.7519999742507935,
          0.7799999713897705
        ],
        [
          0.7559999823570251,
          0.7620000243186951
        ],
        [
          0.7599999904632568,
          0.7580000162124634
        ],
        [
          0.7599999904632568,
          0.734000027179718
        ],
        [
          0.7559999823570251,
          0.7319999933242798
        ],
        [
          0.7559999823570251,
          0.722000002861023
        ],
        [
          0.7519999742507935,
          0.7160000205039978
        ],
        [
          0.7379999756813049,
          0.7139999866485596
        ],
        [
          0.734000027179718,
          0.7099999785423279
        ],
        [
          0.699999988079071,
          0.7080000042915344
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6919999718666077,
          0.7059999704360962
        ],
        [
          0.6880000233650208,
          0.7099999785423279
        ],
        [
          0.6700000166893005,
          0.7120000123977661
        ],
        [
          0.6660000085830688,
          0.7160000205039978
        ],
        [
          0.6499999761581421,
          0.7179999947547913
        ],
        [
          0.6480000019073486,
          0.722000002861023
        ],
        [
          0.6259999871253967,
          0.7260000109672546
        ],
        [
          0.6240000128746033,
          0.7300000190734863
        ],
        [
          0.6119999885559082,
          0.7360000014305115
        ],
        [
          0.5979999899864197,
          0.7379999756813049
        ],
        [
          0.5960000157356262,
          0.7419999837875366
        ],
        [
          0.5820000171661377,
          0.7480000257492065
        ],
        [
          0.5580000281333923,
          0.7680000066757202
        ],
        [
          0.5580000281333923,
          0.7720000147819519
        ],
        [
          0.5339999794960022,
          0.7940000295639038
        ],
        [
          0.527999997138977,
          0.8100000023841858
        ],
        [
          0.5059999823570251,
          0.8399999737739563
        ],
        [
          0.5040000081062317,
          0.8479999899864197
        ],
        [
          0.5,
          0.8500000238418579
        ],
        [
          0.49799999594688416,
          0.8740000128746033
        ],
        [
          0.5180000066757202,
          0.8899999856948853
        ],
        [
          0.5659999847412109,
          0.8899999856948853
        ],
        [
          0.5720000267028809,
          0.8859999775886536
        ],
        [
          0.6019999980926514,
          0.8840000033378601
        ],
        [
          0.6039999723434448,
          0.8799999952316284
        ],
        [
          0.6200000047683716,
          0.878000020980835
        ],
        [
          0.6240000128746033,
          0.8740000128746033
        ],
        [
          0.6480000019073486,
          0.8659999966621399
        ],
        [
          0.6499999761581421,
          0.8619999885559082
        ],
        [
          0.6620000004768372,
          0.8600000143051147
        ],
        [
          0.6959999799728394,
          0.8339999914169312
        ],
        [
          0.699999988079071,
          0.8339999914169312
        ],
        [
          0.7099999785423279,
          0.8220000267028809
        ],
        [
          0.7139999866485596,
          0.8220000267028809
        ],
        [
          0.7400000095367432,
          0.7919999957084656
        ],
        [
          0.7400000095367432,
          0.7879999876022339
        ],
        [
          0.7519999742507935,
          0.777999997138977
        ],
        [
          0.7599999904632568,
          0.7620000243186951
        ],
        [
          0.7620000243186951,
          0.75
        ],
        [
          0.7599999904632568,
          0.7179999947547913
        ],
        [
          0.7400000095367432,
          0.7059999704360962
        ],
        [
          0.6919999718666077,
          0.7059999704360962
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7099999785423279,
          0.699999988079071
        ],
        [
          0.6880000233650208,
          0.7039999961853027
        ],
        [
          0.6840000152587891,
          0.7080000042915344
        ],
        [
          0.6740000247955322,
          0.7099999785423279
        ],
        [
          0.671999990940094,
          0.7139999866485596
        ],
        [
          0.6439999938011169,
          0.722000002861023
        ],
        [
          0.6420000195503235,
          0.7260000109672546
        ],
        [
          0.6320000290870667,
          0.7279999852180481
        ],
        [
          0.6299999952316284,
          0.7319999933242798
        ],
        [
          0.6240000128746033,
          0.7319999933242798
        ],
        [
          0.6159999966621399,
          0.7379999756813049
        ],
        [
          0.5920000076293945,
          0.7459999918937683
        ],
        [
          0.5820000171661377,
          0.7559999823570251
        ],
        [
          0.5680000185966492,
          0.7620000243186951
        ],
        [
          0.5540000200271606,
          0.7799999713897705
        ],
        [
          0.5320000052452087,
          0.800000011920929
        ],
        [
          0.5260000228881836,
          0.8140000104904175
        ],
        [
          0.5019999742507935,
          0.8479999899864197
        ],
        [
          0.4959999918937683,
          0.8600000143051147
        ],
        [
          0.4959999918937683,
          0.8740000128746033
        ],
        [
          0.5040000081062317,
          0.8840000033378601
        ],
        [
          0.515999972820282,
          0.8899999856948853
        ],
        [
          0.5400000214576721,
          0.8920000195503235
        ],
        [
          0.5680000185966492,
          0.8899999856948853
        ],
        [
          0.5720000267028809,
          0.8859999775886536
        ],
        [
          0.5899999737739563,
          0.8859999775886536
        ],
        [
          0.6000000238418579,
          0.8840000033378601
        ],
        [
          0.6019999980926514,
          0.8799999952316284
        ],
        [
          0.621999979019165,
          0.878000020980835
        ],
        [
          0.6240000128746033,
          0.8740000128746033
        ],
        [
          0.6380000114440918,
          0.871999979019165
        ],
        [
          0.6499999761581421,
          0.8659999966621399
        ],
        [
          0.6520000100135803,
          0.8619999885559082
        ],
        [
          0.6620000004768372,
          0.8600000143051147
        ],
        [
          0.6740000247955322,
          0.8539999723434448
        ],
        [
          0.6759999990463257,
          0.8500000238418579
        ],
        [
          0.6840000152587891,
          0.8479999899864197
        ],
        [
          0.7200000286102295,
          0.8180000185966492
        ],
        [
          0.7480000257492065,
          0.7879999876022339
        ],
        [
          0.7620000243186951,
          0.7680000066757202
        ],
        [
          0.765999972820282,
          0.7559999823570251
        ],
        [
          0.765999972820282,
          0.7139999866485596
        ],
        [
          0.7540000081062317,
          0.7020000219345093
        ],
        [
          0.7099999785423279,
          0.699999988079071
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7080000042915344,
          0.7039999961853027
        ],
        [
          0.7059999704360962,
          0.7080000042915344
        ],
        [
          0.6800000071525574,
          0.7099999785423279
        ],
        [
          0.6779999732971191,
          0.7139999866485596
        ],
        [
          0.6579999923706055,
          0.7160000205039978
        ],
        [
          0.656000018119812,
          0.7200000286102295
        ],
        [
          0.6420000195503235,
          0.722000002861023
        ],
        [
          0.6399999856948853,
          0.7260000109672546
        ],
        [
          0.6179999709129333,
          0.734000027179718
        ],
        [
          0.6159999966621399,
          0.7379999756813049
        ],
        [
          0.6039999723434448,
          0.7400000095367432
        ],
        [
          0.6019999980926514,
          0.7440000176429749
        ],
        [
          0.593999981880188,
          0.7459999918937683
        ],
        [
          0.5799999833106995,
          0.7559999823570251
        ],
        [
          0.5540000200271606,
          0.7820000052452087
        ],
        [
          0.5440000295639038,
          0.800000011920929
        ],
        [
          0.5139999985694885,
          0.8360000252723694
        ],
        [
          0.5120000243186951,
          0.8460000157356262
        ],
        [
          0.5019999742507935,
          0.8579999804496765
        ],
        [
          0.5019999742507935,
          0.8759999871253967
        ],
        [
          0.515999972820282,
          0.8880000114440918
        ],
        [
          0.5239999890327454,
          0.8899999856948853
        ],
        [
          0.5979999899864197,
          0.8880000114440918
        ],
        [
          0.6019999980926514,
          0.8840000033378601
        ],
        [
          0.6200000047683716,
          0.8820000290870667
        ],
        [
          0.628000020980835,
          0.8759999871253967
        ],
        [
          0.6480000019073486,
          0.8700000047683716
        ],
        [
          0.6499999761581421,
          0.8659999966621399
        ],
        [
          0.671999990940094,
          0.8579999804496765
        ],
        [
          0.6940000057220459,
          0.8420000076293945
        ],
        [
          0.7300000190734863,
          0.8100000023841858
        ],
        [
          0.7360000014305115,
          0.800000011920929
        ],
        [
          0.7419999837875366,
          0.7979999780654907
        ],
        [
          0.7419999837875366,
          0.7940000295639038
        ],
        [
          0.7639999985694885,
          0.7639999985694885
        ],
        [
          0.7680000066757202,
          0.7519999742507935
        ],
        [
          0.7680000066757202,
          0.7200000286102295
        ],
        [
          0.7599999904632568,
          0.7099999785423279
        ],
        [
          0.7519999742507935,
          0.7080000042915344
        ],
        [
          0.75,
          0.7039999961853027
        ],
        [
          0.7080000042915344,
          0.7039999961853027
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7179999947547913,
          0.7059999704360962
        ],
        [
          0.6600000262260437,
          0.7200000286102295
        ],
        [
          0.6399999856948853,
          0.7300000190734863
        ],
        [
          0.6259999871253967,
          0.7319999933242798
        ],
        [
          0.6240000128746033,
          0.7360000014305115
        ],
        [
          0.6060000061988831,
          0.7379999756813049
        ],
        [
          0.6039999723434448,
          0.7419999837875366
        ],
        [
          0.593999981880188,
          0.7440000176429749
        ],
        [
          0.5740000009536743,
          0.7599999904632568
        ],
        [
          0.5699999928474426,
          0.7599999904632568
        ],
        [
          0.5460000038146973,
          0.7919999957084656
        ],
        [
          0.5460000038146973,
          0.7960000038146973
        ],
        [
          0.5400000214576721,
          0.800000011920929
        ],
        [
          0.5400000214576721,
          0.8040000200271606
        ],
        [
          0.5320000052452087,
          0.8100000023841858
        ],
        [
          0.5299999713897705,
          0.8220000267028809
        ],
        [
          0.5260000228881836,
          0.8240000009536743
        ],
        [
          0.5180000066757202,
          0.8420000076293945
        ],
        [
          0.5059999823570251,
          0.8579999804496765
        ],
        [
          0.5040000081062317,
          0.878000020980835
        ],
        [
          0.5199999809265137,
          0.8899999856948853
        ],
        [
          0.6019999980926514,
          0.8880000114440918
        ],
        [
          0.6039999723434448,
          0.8840000033378601
        ],
        [
          0.6259999871253967,
          0.8820000290870667
        ],
        [
          0.6299999952316284,
          0.878000020980835
        ],
        [
          0.6460000276565552,
          0.8759999871253967
        ],
        [
          0.6480000019073486,
          0.871999979019165
        ],
        [
          0.6600000262260437,
          0.8700000047683716
        ],
        [
          0.6840000152587891,
          0.8519999980926514
        ],
        [
          0.7440000176429749,
          0.7960000038146973
        ],
        [
          0.7680000066757202,
          0.7540000081062317
        ],
        [
          0.7680000066757202,
          0.7139999866485596
        ],
        [
          0.7620000243186951,
          0.7080000042915344
        ],
        [
          0.7179999947547913,
          0.7059999704360962
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.75,
          0.6980000138282776
        ],
        [
          0.7480000257492065,
          0.7020000219345093
        ],
        [
          0.7300000190734863,
          0.7020000219345093
        ],
        [
          0.7279999852180481,
          0.7059999704360962
        ],
        [
          0.7059999704360962,
          0.7080000042915344
        ],
        [
          0.7020000219345093,
          0.7120000123977661
        ],
        [
          0.6800000071525574,
          0.7139999866485596
        ],
        [
          0.6779999732971191,
          0.7179999947547913
        ],
        [
          0.6620000004768372,
          0.7200000286102295
        ],
        [
          0.6579999923706055,
          0.7260000109672546
        ],
        [
          0.6399999856948853,
          0.7319999933242798
        ],
        [
          0.6380000114440918,
          0.7360000014305115
        ],
        [
          0.6179999709129333,
          0.7440000176429749
        ],
        [
          0.6159999966621399,
          0.7480000257492065
        ],
        [
          0.6060000061988831,
          0.75
        ],
        [
          0.5960000157356262,
          0.7599999904632568
        ],
        [
          0.5860000252723694,
          0.7620000243186951
        ],
        [
          0.5680000185966492,
          0.777999997138977
        ],
        [
          0.5680000185966492,
          0.7839999794960022
        ],
        [
          0.5440000295639038,
          0.8080000281333923
        ],
        [
          0.5440000295639038,
          0.8119999766349792
        ],
        [
          0.5059999823570251,
          0.8600000143051147
        ],
        [
          0.5,
          0.8740000128746033
        ],
        [
          0.5019999742507935,
          0.8799999952316284
        ],
        [
          0.5139999985694885,
          0.8859999775886536
        ],
        [
          0.515999972820282,
          0.8899999856948853
        ],
        [
          0.5239999890327454,
          0.8920000195503235
        ],
        [
          0.6000000238418579,
          0.8899999856948853
        ],
        [
          0.6039999723434448,
          0.8859999775886536
        ],
        [
          0.6259999871253967,
          0.8840000033378601
        ],
        [
          0.6299999952316284,
          0.8799999952316284
        ],
        [
          0.6439999938011169,
          0.878000020980835
        ],
        [
          0.6460000276565552,
          0.8740000128746033
        ],
        [
          0.6579999923706055,
          0.871999979019165
        ],
        [
          0.6679999828338623,
          0.8619999885559082
        ],
        [
          0.6779999732971191,
          0.8600000143051147
        ],
        [
          0.6819999814033508,
          0.8539999723434448
        ],
        [
          0.6859999895095825,
          0.8539999723434448
        ],
        [
          0.7020000219345093,
          0.8420000076293945
        ],
        [
          0.7300000190734863,
          0.8180000185966492
        ],
        [
          0.7639999985694885,
          0.7799999713897705
        ],
        [
          0.7699999809265137,
          0.7720000147819519
        ],
        [
          0.7720000147819519,
          0.7620000243186951
        ],
        [
          0.7760000228881836,
          0.7599999904632568
        ],
        [
          0.777999997138977,
          0.7480000257492065
        ],
        [
          0.7820000052452087,
          0.7440000176429749
        ],
        [
          0.7820000052452087,
          0.7139999866485596
        ],
        [
          0.7720000147819519,
          0.7059999704360962
        ],
        [
          0.7639999985694885,
          0.7020000219345093
        ],
        [
          0.7540000081062317,
          0.7020000219345093
        ],
        [
          0.75,
          0.6980000138282776
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7059999704360962,
          0.7080000042915344
        ],
        [
          0.7020000219345093,
          0.7120000123977661
        ],
        [
          0.6679999828338623,
          0.7139999866485596
        ],
        [
          0.6660000085830688,
          0.7179999947547913
        ],
        [
          0.6520000100135803,
          0.7200000286102295
        ],
        [
          0.6399999856948853,
          0.7260000109672546
        ],
        [
          0.6380000114440918,
          0.7300000190734863
        ],
        [
          0.628000020980835,
          0.7319999933242798
        ],
        [
          0.6259999871253967,
          0.7360000014305115
        ],
        [
          0.6140000224113464,
          0.7379999756813049
        ],
        [
          0.6039999723434448,
          0.7480000257492065
        ],
        [
          0.593999981880188,
          0.75
        ],
        [
          0.5839999914169312,
          0.7599999904632568
        ],
        [
          0.5799999833106995,
          0.7599999904632568
        ],
        [
          0.5540000200271606,
          0.7919999957084656
        ],
        [
          0.5519999861717224,
          0.8019999861717224
        ],
        [
          0.5400000214576721,
          0.8159999847412109
        ],
        [
          0.5400000214576721,
          0.8199999928474426
        ],
        [
          0.5299999713897705,
          0.828000009059906
        ],
        [
          0.5239999890327454,
          0.843999981880188
        ],
        [
          0.5059999823570251,
          0.8640000224113464
        ],
        [
          0.5059999823570251,
          0.8799999952316284
        ],
        [
          0.5199999809265137,
          0.8920000195503235
        ],
        [
          0.5920000076293945,
          0.8920000195503235
        ],
        [
          0.593999981880188,
          0.8880000114440918
        ],
        [
          0.6179999709129333,
          0.8859999775886536
        ],
        [
          0.6200000047683716,
          0.8820000290870667
        ],
        [
          0.6380000114440918,
          0.8799999952316284
        ],
        [
          0.6399999856948853,
          0.8759999871253967
        ],
        [
          0.6539999842643738,
          0.8740000128746033
        ],
        [
          0.6660000085830688,
          0.8640000224113464
        ],
        [
          0.6800000071525574,
          0.8579999804496765
        ],
        [
          0.6959999799728394,
          0.843999981880188
        ],
        [
          0.699999988079071,
          0.843999981880188
        ],
        [
          0.7139999866485596,
          0.828000009059906
        ],
        [
          0.7300000190734863,
          0.8140000104904175
        ],
        [
          0.734000027179718,
          0.8140000104904175
        ],
        [
          0.7599999904632568,
          0.7860000133514404
        ],
        [
          0.7760000228881836,
          0.7540000081062317
        ],
        [
          0.7739999890327454,
          0.7239999771118164
        ],
        [
          0.7559999823570251,
          0.7080000042915344
        ],
        [
          0.7059999704360962,
          0.7080000042915344
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7139999866485596,
          0.7099999785423279
        ],
        [
          0.6959999799728394,
          0.7120000123977661
        ],
        [
          0.6940000057220459,
          0.7160000205039978
        ],
        [
          0.6700000166893005,
          0.7179999947547913
        ],
        [
          0.6679999828338623,
          0.722000002861023
        ],
        [
          0.6579999923706055,
          0.722000002861023
        ],
        [
          0.6359999775886536,
          0.734000027179718
        ],
        [
          0.6340000033378601,
          0.7379999756813049
        ],
        [
          0.6240000128746033,
          0.7400000095367432
        ],
        [
          0.621999979019165,
          0.7440000176429749
        ],
        [
          0.5839999914169312,
          0.7639999985694885
        ],
        [
          0.5640000104904175,
          0.7860000133514404
        ],
        [
          0.5600000023841858,
          0.7979999780654907
        ],
        [
          0.550000011920929,
          0.8080000281333923
        ],
        [
          0.550000011920929,
          0.8119999766349792
        ],
        [
          0.5400000214576721,
          0.8199999928474426
        ],
        [
          0.5339999794960022,
          0.8360000252723694
        ],
        [
          0.5099999904632568,
          0.8740000128746033
        ],
        [
          0.5099999904632568,
          0.8859999775886536
        ],
        [
          0.5220000147819519,
          0.8939999938011169
        ],
        [
          0.5699999928474426,
          0.8939999938011169
        ],
        [
          0.621999979019165,
          0.8859999775886536
        ],
        [
          0.6240000128746033,
          0.8820000290870667
        ],
        [
          0.6340000033378601,
          0.8820000290870667
        ],
        [
          0.6420000195503235,
          0.8799999952316284
        ],
        [
          0.6439999938011169,
          0.8759999871253967
        ],
        [
          0.656000018119812,
          0.8740000128746033
        ],
        [
          0.6579999923706055,
          0.8700000047683716
        ],
        [
          0.6620000004768372,
          0.8700000047683716
        ],
        [
          0.6740000247955322,
          0.8600000143051147
        ],
        [
          0.6880000233650208,
          0.8539999723434448
        ],
        [
          0.7039999961853027,
          0.8399999737739563
        ],
        [
          0.7080000042915344,
          0.8399999737739563
        ],
        [
          0.7179999947547913,
          0.8259999752044678
        ],
        [
          0.722000002861023,
          0.8259999752044678
        ],
        [
          0.7379999756813049,
          0.8119999766349792
        ],
        [
          0.7379999756813049,
          0.8080000281333923
        ],
        [
          0.7620000243186951,
          0.7839999794960022
        ],
        [
          0.7760000228881836,
          0.7580000162124634
        ],
        [
          0.7760000228881836,
          0.7239999771118164
        ],
        [
          0.7639999985694885,
          0.7120000123977661
        ],
        [
          0.7139999866485596,
          0.7099999785423279
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7120000123977661,
          0.7120000123977661
        ],
        [
          0.699999988079071,
          0.7139999866485596
        ],
        [
          0.6880000233650208,
          0.722000002861023
        ],
        [
          0.6740000247955322,
          0.7239999771118164
        ],
        [
          0.6700000166893005,
          0.7279999852180481
        ],
        [
          0.6539999842643738,
          0.7300000190734863
        ],
        [
          0.6359999775886536,
          0.7400000095367432
        ],
        [
          0.6200000047683716,
          0.7419999837875366
        ],
        [
          0.6159999966621399,
          0.7459999918937683
        ],
        [
          0.6100000143051147,
          0.7459999918937683
        ],
        [
          0.6079999804496765,
          0.75
        ],
        [
          0.593999981880188,
          0.7519999742507935
        ],
        [
          0.578000009059906,
          0.7620000243186951
        ],
        [
          0.5720000267028809,
          0.7620000243186951
        ],
        [
          0.5680000185966492,
          0.7699999809265137
        ],
        [
          0.5640000104904175,
          0.7699999809265137
        ],
        [
          0.5519999861717224,
          0.7860000133514404
        ],
        [
          0.550000011920929,
          0.7960000038146973
        ],
        [
          0.5320000052452087,
          0.8140000104904175
        ],
        [
          0.5320000052452087,
          0.8180000185966492
        ],
        [
          0.5220000147819519,
          0.8299999833106995
        ],
        [
          0.5180000066757202,
          0.8299999833106995
        ],
        [
          0.5099999904632568,
          0.8379999995231628
        ],
        [
          0.5099999904632568,
          0.8460000157356262
        ],
        [
          0.5059999823570251,
          0.8479999899864197
        ],
        [
          0.5040000081062317,
          0.8539999723434448
        ],
        [
          0.5040000081062317,
          0.8820000290870667
        ],
        [
          0.5220000147819519,
          0.8939999938011169
        ],
        [
          0.6079999804496765,
          0.8920000195503235
        ],
        [
          0.6100000143051147,
          0.8880000114440918
        ],
        [
          0.6299999952316284,
          0.8859999775886536
        ],
        [
          0.6480000019073486,
          0.8759999871253967
        ],
        [
          0.6539999842643738,
          0.8759999871253967
        ],
        [
          0.722000002861023,
          0.8299999833106995
        ],
        [
          0.7599999904632568,
          0.7900000214576721
        ],
        [
          0.7599999904632568,
          0.7860000133514404
        ],
        [
          0.7739999890327454,
          0.7680000066757202
        ],
        [
          0.7799999713897705,
          0.75
        ],
        [
          0.7799999713897705,
          0.7360000014305115
        ],
        [
          0.7720000147819519,
          0.7179999947547913
        ],
        [
          0.7680000066757202,
          0.7179999947547913
        ],
        [
          0.765999972820282,
          0.7139999866485596
        ],
        [
          0.7120000123977661,
          0.7120000123977661
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.722000002861023,
          0.7099999785423279
        ],
        [
          0.7179999947547913,
          0.7139999866485596
        ],
        [
          0.699999988079071,
          0.7139999866485596
        ],
        [
          0.6880000233650208,
          0.7160000205039978
        ],
        [
          0.6859999895095825,
          0.7200000286102295
        ],
        [
          0.6679999828338623,
          0.722000002861023
        ],
        [
          0.6660000085830688,
          0.7260000109672546
        ],
        [
          0.6439999938011169,
          0.7319999933242798
        ],
        [
          0.6359999775886536,
          0.7379999756813049
        ],
        [
          0.6299999952316284,
          0.7379999756813049
        ],
        [
          0.628000020980835,
          0.7419999837875366
        ],
        [
          0.6159999966621399,
          0.7440000176429749
        ],
        [
          0.5979999899864197,
          0.7540000081062317
        ],
        [
          0.5799999833106995,
          0.7720000147819519
        ],
        [
          0.578000009059906,
          0.7820000052452087
        ],
        [
          0.5740000009536743,
          0.7839999794960022
        ],
        [
          0.5740000009536743,
          0.7879999876022339
        ],
        [
          0.5680000185966492,
          0.7900000214576721
        ],
        [
          0.5659999847412109,
          0.8040000200271606
        ],
        [
          0.5460000038146973,
          0.8259999752044678
        ],
        [
          0.5299999713897705,
          0.8339999914169312
        ],
        [
          0.527999997138977,
          0.8379999995231628
        ],
        [
          0.5180000066757202,
          0.8399999737739563
        ],
        [
          0.5099999904632568,
          0.8539999723434448
        ],
        [
          0.5099999904632568,
          0.8840000033378601
        ],
        [
          0.527999997138977,
          0.8899999856948853
        ],
        [
          0.5299999713897705,
          0.8939999938011169
        ],
        [
          0.6039999723434448,
          0.8939999938011169
        ],
        [
          0.6060000061988831,
          0.8899999856948853
        ],
        [
          0.6340000033378601,
          0.8880000114440918
        ],
        [
          0.6359999775886536,
          0.8840000033378601
        ],
        [
          0.6539999842643738,
          0.8820000290870667
        ],
        [
          0.6620000004768372,
          0.8740000128746033
        ],
        [
          0.7039999961853027,
          0.8500000238418579
        ],
        [
          0.7360000014305115,
          0.8180000185966492
        ],
        [
          0.7419999837875366,
          0.8159999847412109
        ],
        [
          0.7440000176429749,
          0.8100000023841858
        ],
        [
          0.7480000257492065,
          0.8100000023841858
        ],
        [
          0.75,
          0.8040000200271606
        ],
        [
          0.7739999890327454,
          0.7760000228881836
        ],
        [
          0.7820000052452087,
          0.7559999823570251
        ],
        [
          0.7820000052452087,
          0.722000002861023
        ],
        [
          0.7739999890327454,
          0.7139999866485596
        ],
        [
          0.7680000066757202,
          0.7139999866485596
        ],
        [
          0.765999972820282,
          0.7099999785423279
        ],
        [
          0.722000002861023,
          0.7099999785423279
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7419999837875366,
          0.699999988079071
        ],
        [
          0.7400000095367432,
          0.7039999961853027
        ],
        [
          0.7179999947547913,
          0.7039999961853027
        ],
        [
          0.7059999704360962,
          0.7059999704360962
        ],
        [
          0.7039999961853027,
          0.7099999785423279
        ],
        [
          0.6940000057220459,
          0.7099999785423279
        ],
        [
          0.6919999718666077,
          0.7139999866485596
        ],
        [
          0.6700000166893005,
          0.7200000286102295
        ],
        [
          0.6660000085830688,
          0.7260000109672546
        ],
        [
          0.6420000195503235,
          0.734000027179718
        ],
        [
          0.6320000290870667,
          0.7419999837875366
        ],
        [
          0.6019999980926514,
          0.7559999823570251
        ],
        [
          0.5860000252723694,
          0.777999997138977
        ],
        [
          0.5860000252723694,
          0.7820000052452087
        ],
        [
          0.5820000171661377,
          0.7839999794960022
        ],
        [
          0.5759999752044678,
          0.800000011920929
        ],
        [
          0.5440000295639038,
          0.8339999914169312
        ],
        [
          0.5320000052452087,
          0.8399999737739563
        ],
        [
          0.5320000052452087,
          0.843999981880188
        ],
        [
          0.5080000162124634,
          0.8679999709129333
        ],
        [
          0.5059999823570251,
          0.8820000290870667
        ],
        [
          0.5019999742507935,
          0.8840000033378601
        ],
        [
          0.5199999809265137,
          0.8960000276565552
        ],
        [
          0.6179999709129333,
          0.8939999938011169
        ],
        [
          0.6200000047683716,
          0.8899999856948853
        ],
        [
          0.6420000195503235,
          0.8880000114440918
        ],
        [
          0.6439999938011169,
          0.8840000033378601
        ],
        [
          0.6660000085830688,
          0.878000020980835
        ],
        [
          0.6759999990463257,
          0.8679999709129333
        ],
        [
          0.6859999895095825,
          0.8659999966621399
        ],
        [
          0.699999988079071,
          0.8539999723434448
        ],
        [
          0.7039999961853027,
          0.8539999723434448
        ],
        [
          0.7419999837875366,
          0.8180000185966492
        ],
        [
          0.7620000243186951,
          0.7940000295639038
        ],
        [
          0.7620000243186951,
          0.7900000214576721
        ],
        [
          0.7720000147819519,
          0.7820000052452087
        ],
        [
          0.7860000133514404,
          0.7480000257492065
        ],
        [
          0.7839999794960022,
          0.7139999866485596
        ],
        [
          0.7680000066757202,
          0.699999988079071
        ],
        [
          0.7419999837875366,
          0.699999988079071
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7540000081062317,
          0.6919999718666077
        ],
        [
          0.7519999742507935,
          0.6959999799728394
        ],
        [
          0.7279999852180481,
          0.6980000138282776
        ],
        [
          0.7239999771118164,
          0.7020000219345093
        ],
        [
          0.7120000123977661,
          0.7020000219345093
        ],
        [
          0.6880000233650208,
          0.7099999785423279
        ],
        [
          0.6800000071525574,
          0.7179999947547913
        ],
        [
          0.6700000166893005,
          0.7200000286102295
        ],
        [
          0.6499999761581421,
          0.7360000014305115
        ],
        [
          0.6399999856948853,
          0.7379999756813049
        ],
        [
          0.6380000114440918,
          0.7419999837875366
        ],
        [
          0.6259999871253967,
          0.7480000257492065
        ],
        [
          0.5860000252723694,
          0.7860000133514404
        ],
        [
          0.578000009059906,
          0.8019999861717224
        ],
        [
          0.5360000133514404,
          0.8479999899864197
        ],
        [
          0.5360000133514404,
          0.8519999980926514
        ],
        [
          0.5320000052452087,
          0.8539999723434448
        ],
        [
          0.5320000052452087,
          0.8679999709129333
        ],
        [
          0.5260000228881836,
          0.8700000047683716
        ],
        [
          0.5180000066757202,
          0.8799999952316284
        ],
        [
          0.5180000066757202,
          0.8859999775886536
        ],
        [
          0.5299999713897705,
          0.8920000195503235
        ],
        [
          0.5320000052452087,
          0.8960000276565552
        ],
        [
          0.6159999966621399,
          0.8960000276565552
        ],
        [
          0.6200000047683716,
          0.8920000195503235
        ],
        [
          0.6399999856948853,
          0.8899999856948853
        ],
        [
          0.6439999938011169,
          0.8859999775886536
        ],
        [
          0.6499999761581421,
          0.8859999775886536
        ],
        [
          0.6520000100135803,
          0.8820000290870667
        ],
        [
          0.6639999747276306,
          0.8799999952316284
        ],
        [
          0.699999988079071,
          0.8579999804496765
        ],
        [
          0.7300000190734863,
          0.8299999833106995
        ],
        [
          0.734000027179718,
          0.8299999833106995
        ],
        [
          0.734000027179718,
          0.8259999752044678
        ],
        [
          0.7580000162124634,
          0.8019999861717224
        ],
        [
          0.7580000162124634,
          0.7979999780654907
        ],
        [
          0.7760000228881836,
          0.7760000228881836
        ],
        [
          0.7839999794960022,
          0.7519999742507935
        ],
        [
          0.7879999876022339,
          0.7480000257492065
        ],
        [
          0.7900000214576721,
          0.7300000190734863
        ],
        [
          0.7940000295639038,
          0.7260000109672546
        ],
        [
          0.7940000295639038,
          0.7099999785423279
        ],
        [
          0.7760000228881836,
          0.6919999718666077
        ],
        [
          0.7540000081062317,
          0.6919999718666077
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7039999961853027,
          0.6759999990463257
        ],
        [
          0.6600000262260437,
          0.6899999976158142
        ],
        [
          0.6439999938011169,
          0.6980000138282776
        ],
        [
          0.6420000195503235,
          0.7020000219345093
        ],
        [
          0.6259999871253967,
          0.7099999785423279
        ],
        [
          0.6140000224113464,
          0.7120000123977661
        ],
        [
          0.6119999885559082,
          0.7160000205039978
        ],
        [
          0.6000000238418579,
          0.7179999947547913
        ],
        [
          0.5979999899864197,
          0.722000002861023
        ],
        [
          0.5860000252723694,
          0.7239999771118164
        ],
        [
          0.5759999752044678,
          0.7319999933242798
        ],
        [
          0.550000011920929,
          0.7580000162124634
        ],
        [
          0.550000011920929,
          0.7620000243186951
        ],
        [
          0.5379999876022339,
          0.777999997138977
        ],
        [
          0.5260000228881836,
          0.7860000133514404
        ],
        [
          0.5239999890327454,
          0.7979999780654907
        ],
        [
          0.515999972820282,
          0.8059999942779541
        ],
        [
          0.515999972820282,
          0.8100000023841858
        ],
        [
          0.5059999823570251,
          0.8180000185966492
        ],
        [
          0.5019999742507935,
          0.8299999833106995
        ],
        [
          0.49799999594688416,
          0.8320000171661377
        ],
        [
          0.49799999594688416,
          0.8560000061988831
        ],
        [
          0.5099999904632568,
          0.8659999966621399
        ],
        [
          0.515999972820282,
          0.8659999966621399
        ],
        [
          0.5180000066757202,
          0.8700000047683716
        ],
        [
          0.5260000228881836,
          0.871999979019165
        ],
        [
          0.527999997138977,
          0.8759999871253967
        ],
        [
          0.5920000076293945,
          0.878000020980835
        ],
        [
          0.6039999723434448,
          0.8759999871253967
        ],
        [
          0.6060000061988831,
          0.871999979019165
        ],
        [
          0.621999979019165,
          0.8700000047683716
        ],
        [
          0.6259999871253967,
          0.8659999966621399
        ],
        [
          0.6639999747276306,
          0.8579999804496765
        ],
        [
          0.6700000166893005,
          0.8519999980926514
        ],
        [
          0.6779999732971191,
          0.8500000238418579
        ],
        [
          0.7440000176429749,
          0.7820000052452087
        ],
        [
          0.7459999918937683,
          0.7720000147819519
        ],
        [
          0.7580000162124634,
          0.7559999823570251
        ],
        [
          0.7599999904632568,
          0.7459999918937683
        ],
        [
          0.7620000243186951,
          0.7260000109672546
        ],
        [
          0.7599999904632568,
          0.7039999961853027
        ],
        [
          0.7540000081062317,
          0.6919999718666077
        ],
        [
          0.7440000176429749,
          0.6819999814033508
        ],
        [
          0.7319999933242798,
          0.6759999990463257
        ],
        [
          0.7039999961853027,
          0.6759999990463257
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7120000123977661,
          0.6620000004768372
        ],
        [
          0.7059999704360962,
          0.6620000004768372
        ],
        [
          0.699999988079071,
          0.6660000085830688
        ],
        [
          0.6980000138282776,
          0.671999990940094
        ],
        [
          0.6840000152587891,
          0.6759999990463257
        ],
        [
          0.6600000262260437,
          0.6940000057220459
        ],
        [
          0.6480000019073486,
          0.6980000138282776
        ],
        [
          0.6439999938011169,
          0.7039999961853027
        ],
        [
          0.6119999885559082,
          0.7200000286102295
        ],
        [
          0.5979999899864197,
          0.7319999933242798
        ],
        [
          0.593999981880188,
          0.7319999933242798
        ],
        [
          0.5899999737739563,
          0.7379999756813049
        ],
        [
          0.5740000009536743,
          0.7419999837875366
        ],
        [
          0.5699999928474426,
          0.7459999918937683
        ],
        [
          0.5540000200271606,
          0.7480000257492065
        ],
        [
          0.5400000214576721,
          0.7559999823570251
        ],
        [
          0.5239999890327454,
          0.7820000052452087
        ],
        [
          0.5239999890327454,
          0.843999981880188
        ],
        [
          0.527999997138977,
          0.8500000238418579
        ],
        [
          0.5360000133514404,
          0.8519999980926514
        ],
        [
          0.5440000295639038,
          0.8600000143051147
        ],
        [
          0.550000011920929,
          0.8600000143051147
        ],
        [
          0.5519999861717224,
          0.8640000224113464
        ],
        [
          0.6039999723434448,
          0.8640000224113464
        ],
        [
          0.6060000061988831,
          0.8600000143051147
        ],
        [
          0.6380000114440918,
          0.8560000061988831
        ],
        [
          0.6399999856948853,
          0.8519999980926514
        ],
        [
          0.6579999923706055,
          0.8500000238418579
        ],
        [
          0.6740000247955322,
          0.8420000076293945
        ],
        [
          0.6779999732971191,
          0.8360000252723694
        ],
        [
          0.6859999895095825,
          0.8339999914169312
        ],
        [
          0.699999988079071,
          0.8220000267028809
        ],
        [
          0.722000002861023,
          0.800000011920929
        ],
        [
          0.7379999756813049,
          0.7760000228881836
        ],
        [
          0.7400000095367432,
          0.7639999985694885
        ],
        [
          0.7440000176429749,
          0.7620000243186951
        ],
        [
          0.7480000257492065,
          0.7480000257492065
        ],
        [
          0.7519999742507935,
          0.7459999918937683
        ],
        [
          0.7559999823570251,
          0.7279999852180481
        ],
        [
          0.7559999823570251,
          0.6899999976158142
        ],
        [
          0.7519999742507935,
          0.6759999990463257
        ],
        [
          0.7379999756813049,
          0.6620000004768372
        ],
        [
          0.7120000123977661,
          0.6620000004768372
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7279999852180481,
          0.6460000276565552
        ],
        [
          0.7260000109672546,
          0.6499999761581421
        ],
        [
          0.7139999866485596,
          0.6520000100135803
        ],
        [
          0.7039999961853027,
          0.6579999923706055
        ],
        [
          0.6940000057220459,
          0.6700000166893005
        ],
        [
          0.6639999747276306,
          0.6800000071525574
        ],
        [
          0.6620000004768372,
          0.6840000152587891
        ],
        [
          0.6539999842643738,
          0.6859999895095825
        ],
        [
          0.6399999856948853,
          0.6980000138282776
        ],
        [
          0.6320000290870667,
          0.699999988079071
        ],
        [
          0.6200000047683716,
          0.7120000123977661
        ],
        [
          0.6159999966621399,
          0.7120000123977661
        ],
        [
          0.6119999885559082,
          0.7179999947547913
        ],
        [
          0.6000000238418579,
          0.7239999771118164
        ],
        [
          0.5960000157356262,
          0.7300000190734863
        ],
        [
          0.5920000076293945,
          0.7300000190734863
        ],
        [
          0.5740000009536743,
          0.7480000257492065
        ],
        [
          0.5600000023841858,
          0.7540000081062317
        ],
        [
          0.5580000281333923,
          0.7599999904632568
        ],
        [
          0.5479999780654907,
          0.7620000243186951
        ],
        [
          0.5400000214576721,
          0.7720000147819519
        ],
        [
          0.527999997138977,
          0.777999997138977
        ],
        [
          0.5239999890327454,
          0.7919999957084656
        ],
        [
          0.527999997138977,
          0.8259999752044678
        ],
        [
          0.5400000214576721,
          0.8299999833106995
        ],
        [
          0.5440000295639038,
          0.8360000252723694
        ],
        [
          0.5580000281333923,
          0.8420000076293945
        ],
        [
          0.5600000023841858,
          0.8460000157356262
        ],
        [
          0.5820000171661377,
          0.8500000238418579
        ],
        [
          0.5839999914169312,
          0.8539999723434448
        ],
        [
          0.6320000290870667,
          0.8539999723434448
        ],
        [
          0.6359999775886536,
          0.8500000238418579
        ],
        [
          0.6439999938011169,
          0.8500000238418579
        ],
        [
          0.656000018119812,
          0.8460000157356262
        ],
        [
          0.6579999923706055,
          0.8420000076293945
        ],
        [
          0.6700000166893005,
          0.8399999737739563
        ],
        [
          0.671999990940094,
          0.8360000252723694
        ],
        [
          0.6819999814033508,
          0.8339999914169312
        ],
        [
          0.6980000138282776,
          0.8220000267028809
        ],
        [
          0.7200000286102295,
          0.8019999861717224
        ],
        [
          0.7360000014305115,
          0.7820000052452087
        ],
        [
          0.75,
          0.7540000081062317
        ],
        [
          0.7540000081062317,
          0.7379999756813049
        ],
        [
          0.7599999904632568,
          0.7300000190734863
        ],
        [
          0.7620000243186951,
          0.7139999866485596
        ],
        [
          0.765999972820282,
          0.7120000123977661
        ],
        [
          0.765999972820282,
          0.6700000166893005
        ],
        [
          0.7620000243186951,
          0.6660000085830688
        ],
        [
          0.7620000243186951,
          0.6579999923706055
        ],
        [
          0.7519999742507935,
          0.6499999761581421
        ],
        [
          0.7279999852180481,
          0.6460000276565552
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.734000027179718,
          0.628000020980835
        ],
        [
          0.7080000042915344,
          0.6499999761581421
        ],
        [
          0.7020000219345093,
          0.6499999761581421
        ],
        [
          0.699999988079071,
          0.6600000262260437
        ],
        [
          0.6899999976158142,
          0.6679999828338623
        ],
        [
          0.6840000152587891,
          0.6679999828338623
        ],
        [
          0.6740000247955322,
          0.6759999990463257
        ],
        [
          0.6660000085830688,
          0.6779999732971191
        ],
        [
          0.6579999923706055,
          0.6880000233650208
        ],
        [
          0.6499999761581421,
          0.6899999976158142
        ],
        [
          0.6460000276565552,
          0.6959999799728394
        ],
        [
          0.6420000195503235,
          0.6959999799728394
        ],
        [
          0.6140000224113464,
          0.7160000205039978
        ],
        [
          0.5600000023841858,
          0.7720000147819519
        ],
        [
          0.5519999861717224,
          0.7739999890327454
        ],
        [
          0.5419999957084656,
          0.7860000133514404
        ],
        [
          0.527999997138977,
          0.7940000295639038
        ],
        [
          0.5260000228881836,
          0.8240000009536743
        ],
        [
          0.5360000133514404,
          0.8360000252723694
        ],
        [
          0.5680000185966492,
          0.8500000238418579
        ],
        [
          0.593999981880188,
          0.8519999980926514
        ],
        [
          0.5960000157356262,
          0.8560000061988831
        ],
        [
          0.6140000224113464,
          0.8560000061988831
        ],
        [
          0.6159999966621399,
          0.8519999980926514
        ],
        [
          0.6399999856948853,
          0.8500000238418579
        ],
        [
          0.6420000195503235,
          0.8460000157356262
        ],
        [
          0.656000018119812,
          0.843999981880188
        ],
        [
          0.6639999747276306,
          0.8379999995231628
        ],
        [
          0.6740000247955322,
          0.8360000252723694
        ],
        [
          0.7020000219345093,
          0.8140000104904175
        ],
        [
          0.7059999704360962,
          0.8140000104904175
        ],
        [
          0.7279999852180481,
          0.7879999876022339
        ],
        [
          0.7379999756813049,
          0.7680000066757202
        ],
        [
          0.7419999837875366,
          0.765999972820282
        ],
        [
          0.7459999918937683,
          0.7480000257492065
        ],
        [
          0.75,
          0.7459999918937683
        ],
        [
          0.7540000081062317,
          0.734000027179718
        ],
        [
          0.7540000081062317,
          0.7260000109672546
        ],
        [
          0.7580000162124634,
          0.7239999771118164
        ],
        [
          0.7639999985694885,
          0.6819999814033508
        ],
        [
          0.7680000066757202,
          0.6779999732971191
        ],
        [
          0.7680000066757202,
          0.6499999761581421
        ],
        [
          0.7639999985694885,
          0.6480000019073486
        ],
        [
          0.7580000162124634,
          0.6340000033378601
        ],
        [
          0.7459999918937683,
          0.628000020980835
        ],
        [
          0.734000027179718,
          0.628000020980835
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7260000109672546,
          0.6420000195503235
        ],
        [
          0.7039999961853027,
          0.6520000100135803
        ],
        [
          0.6959999799728394,
          0.6620000004768372
        ],
        [
          0.6899999976158142,
          0.6620000004768372
        ],
        [
          0.6700000166893005,
          0.671999990940094
        ],
        [
          0.6679999828338623,
          0.6759999990463257
        ],
        [
          0.6460000276565552,
          0.6880000233650208
        ],
        [
          0.6399999856948853,
          0.6980000138282776
        ],
        [
          0.6179999709129333,
          0.7099999785423279
        ],
        [
          0.5920000076293945,
          0.7360000014305115
        ],
        [
          0.5720000267028809,
          0.7599999904632568
        ],
        [
          0.5720000267028809,
          0.7639999985694885
        ],
        [
          0.5640000104904175,
          0.7680000066757202
        ],
        [
          0.5640000104904175,
          0.7720000147819519
        ],
        [
          0.5460000038146973,
          0.7879999876022339
        ],
        [
          0.5379999876022339,
          0.7900000214576721
        ],
        [
          0.515999972820282,
          0.8140000104904175
        ],
        [
          0.515999972820282,
          0.8360000252723694
        ],
        [
          0.527999997138977,
          0.8399999737739563
        ],
        [
          0.5339999794960022,
          0.8460000157356262
        ],
        [
          0.5559999942779541,
          0.8479999899864197
        ],
        [
          0.5600000023841858,
          0.8519999980926514
        ],
        [
          0.5720000267028809,
          0.8539999723434448
        ],
        [
          0.5860000252723694,
          0.8539999723434448
        ],
        [
          0.5879999995231628,
          0.8579999804496765
        ],
        [
          0.6100000143051147,
          0.8579999804496765
        ],
        [
          0.6140000224113464,
          0.8539999723434448
        ],
        [
          0.6340000033378601,
          0.8519999980926514
        ],
        [
          0.6359999775886536,
          0.8479999899864197
        ],
        [
          0.6579999923706055,
          0.843999981880188
        ],
        [
          0.6600000262260437,
          0.8399999737739563
        ],
        [
          0.6779999732971191,
          0.8320000171661377
        ],
        [
          0.6819999814033508,
          0.8259999752044678
        ],
        [
          0.6940000057220459,
          0.8220000267028809
        ],
        [
          0.7300000190734863,
          0.7820000052452087
        ],
        [
          0.75,
          0.7419999837875366
        ],
        [
          0.75,
          0.7319999933242798
        ],
        [
          0.7599999904632568,
          0.7059999704360962
        ],
        [
          0.7620000243186951,
          0.6759999990463257
        ],
        [
          0.7580000162124634,
          0.6520000100135803
        ],
        [
          0.7440000176429749,
          0.6420000195503235
        ],
        [
          0.7260000109672546,
          0.6420000195503235
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7179999947547913,
          0.6399999856948853
        ],
        [
          0.7139999866485596,
          0.6460000276565552
        ],
        [
          0.6959999799728394,
          0.6520000100135803
        ],
        [
          0.6880000233650208,
          0.6600000262260437
        ],
        [
          0.6779999732971191,
          0.6600000262260437
        ],
        [
          0.6620000004768372,
          0.6679999828338623
        ],
        [
          0.621999979019165,
          0.7099999785423279
        ],
        [
          0.6119999885559082,
          0.7139999866485596
        ],
        [
          0.593999981880188,
          0.734000027179718
        ],
        [
          0.5839999914169312,
          0.7540000081062317
        ],
        [
          0.578000009059906,
          0.7580000162124634
        ],
        [
          0.5759999752044678,
          0.7680000066757202
        ],
        [
          0.5600000023841858,
          0.7860000133514404
        ],
        [
          0.5580000281333923,
          0.8019999861717224
        ],
        [
          0.5540000200271606,
          0.8059999942779541
        ],
        [
          0.550000011920929,
          0.8199999928474426
        ],
        [
          0.5519999861717224,
          0.828000009059906
        ],
        [
          0.5580000281333923,
          0.8339999914169312
        ],
        [
          0.578000009059906,
          0.843999981880188
        ],
        [
          0.5920000076293945,
          0.8460000157356262
        ],
        [
          0.593999981880188,
          0.8500000238418579
        ],
        [
          0.6380000114440918,
          0.8500000238418579
        ],
        [
          0.6399999856948853,
          0.8460000157356262
        ],
        [
          0.6539999842643738,
          0.843999981880188
        ],
        [
          0.6620000004768372,
          0.8379999995231628
        ],
        [
          0.6779999732971191,
          0.8339999914169312
        ],
        [
          0.722000002861023,
          0.7919999957084656
        ],
        [
          0.7360000014305115,
          0.7639999985694885
        ],
        [
          0.7400000095367432,
          0.7620000243186951
        ],
        [
          0.7519999742507935,
          0.7260000109672546
        ],
        [
          0.7559999823570251,
          0.7239999771118164
        ],
        [
          0.7599999904632568,
          0.7020000219345093
        ],
        [
          0.7599999904632568,
          0.6579999923706055
        ],
        [
          0.7580000162124634,
          0.6480000019073486
        ],
        [
          0.7480000257492065,
          0.6399999856948853
        ],
        [
          0.7179999947547913,
          0.6399999856948853
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7400000095367432,
          0.6340000033378601
        ],
        [
          0.7260000109672546,
          0.6359999775886536
        ],
        [
          0.7020000219345093,
          0.6520000100135803
        ],
        [
          0.6919999718666077,
          0.6520000100135803
        ],
        [
          0.6859999895095825,
          0.6600000262260437
        ],
        [
          0.6679999828338623,
          0.671999990940094
        ],
        [
          0.6340000033378601,
          0.7080000042915344
        ],
        [
          0.6299999952316284,
          0.7080000042915344
        ],
        [
          0.6159999966621399,
          0.722000002861023
        ],
        [
          0.6119999885559082,
          0.722000002861023
        ],
        [
          0.6019999980926514,
          0.7360000014305115
        ],
        [
          0.6000000238418579,
          0.7440000176429749
        ],
        [
          0.5920000076293945,
          0.7519999742507935
        ],
        [
          0.5920000076293945,
          0.7559999823570251
        ],
        [
          0.5600000023841858,
          0.7940000295639038
        ],
        [
          0.5139999985694885,
          0.8360000252723694
        ],
        [
          0.515999972820282,
          0.8500000238418579
        ],
        [
          0.5220000147819519,
          0.8560000061988831
        ],
        [
          0.5400000214576721,
          0.8600000143051147
        ],
        [
          0.5440000295639038,
          0.8640000224113464
        ],
        [
          0.6079999804496765,
          0.8640000224113464
        ],
        [
          0.6100000143051147,
          0.8600000143051147
        ],
        [
          0.6200000047683716,
          0.8600000143051147
        ],
        [
          0.6499999761581421,
          0.8500000238418579
        ],
        [
          0.6539999842643738,
          0.843999981880188
        ],
        [
          0.6740000247955322,
          0.8360000252723694
        ],
        [
          0.6779999732971191,
          0.8299999833106995
        ],
        [
          0.6859999895095825,
          0.828000009059906
        ],
        [
          0.7099999785423279,
          0.8080000281333923
        ],
        [
          0.7319999933242798,
          0.7860000133514404
        ],
        [
          0.734000027179718,
          0.777999997138977
        ],
        [
          0.7400000095367432,
          0.7720000147819519
        ],
        [
          0.7440000176429749,
          0.7580000162124634
        ],
        [
          0.75,
          0.75
        ],
        [
          0.7599999904632568,
          0.7059999704360962
        ],
        [
          0.7639999985694885,
          0.7020000219345093
        ],
        [
          0.765999972820282,
          0.656000018119812
        ],
        [
          0.7519999742507935,
          0.6380000114440918
        ],
        [
          0.7400000095367432,
          0.6340000033378601
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7400000095367432,
          0.6340000033378601
        ],
        [
          0.7300000190734863,
          0.6359999775886536
        ],
        [
          0.7279999852180481,
          0.6399999856948853
        ],
        [
          0.699999988079071,
          0.6520000100135803
        ],
        [
          0.6919999718666077,
          0.6620000004768372
        ],
        [
          0.671999990940094,
          0.671999990940094
        ],
        [
          0.6380000114440918,
          0.7059999704360962
        ],
        [
          0.5979999899864197,
          0.75
        ],
        [
          0.5839999914169312,
          0.7680000066757202
        ],
        [
          0.5839999914169312,
          0.7720000147819519
        ],
        [
          0.5740000009536743,
          0.7820000052452087
        ],
        [
          0.5740000009536743,
          0.7860000133514404
        ],
        [
          0.5619999766349792,
          0.7960000038146973
        ],
        [
          0.5580000281333923,
          0.8100000023841858
        ],
        [
          0.5440000295639038,
          0.8259999752044678
        ],
        [
          0.5419999957084656,
          0.8360000252723694
        ],
        [
          0.5360000133514404,
          0.8379999995231628
        ],
        [
          0.5339999794960022,
          0.8460000157356262
        ],
        [
          0.5479999780654907,
          0.8579999804496765
        ],
        [
          0.5580000281333923,
          0.8619999885559082
        ],
        [
          0.5759999752044678,
          0.8619999885559082
        ],
        [
          0.578000009059906,
          0.8659999966621399
        ],
        [
          0.6019999980926514,
          0.8659999966621399
        ],
        [
          0.6039999723434448,
          0.8619999885559082
        ],
        [
          0.6340000033378601,
          0.8579999804496765
        ],
        [
          0.6380000114440918,
          0.8539999723434448
        ],
        [
          0.6499999761581421,
          0.8519999980926514
        ],
        [
          0.6660000085830688,
          0.843999981880188
        ],
        [
          0.6679999828338623,
          0.8399999737739563
        ],
        [
          0.6759999990463257,
          0.8379999995231628
        ],
        [
          0.7039999961853027,
          0.8140000104904175
        ],
        [
          0.7080000042915344,
          0.8140000104904175
        ],
        [
          0.7379999756813049,
          0.777999997138977
        ],
        [
          0.7400000095367432,
          0.7680000066757202
        ],
        [
          0.7440000176429749,
          0.765999972820282
        ],
        [
          0.7480000257492065,
          0.75
        ],
        [
          0.7540000081062317,
          0.7419999837875366
        ],
        [
          0.7580000162124634,
          0.722000002861023
        ],
        [
          0.7620000243186951,
          0.7200000286102295
        ],
        [
          0.765999972820282,
          0.6940000057220459
        ],
        [
          0.7699999809265137,
          0.6919999718666077
        ],
        [
          0.7720000147819519,
          0.6759999990463257
        ],
        [
          0.7699999809265137,
          0.6499999761581421
        ],
        [
          0.765999972820282,
          0.6499999761581421
        ],
        [
          0.7620000243186951,
          0.6420000195503235
        ],
        [
          0.7580000162124634,
          0.6420000195503235
        ],
        [
          0.7540000081062317,
          0.6359999775886536
        ],
        [
          0.7400000095367432,
          0.6340000033378601
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.734000027179718,
          0.656000018119812
        ],
        [
          0.7319999933242798,
          0.6620000004768372
        ],
        [
          0.7099999785423279,
          0.6660000085830688
        ],
        [
          0.7080000042915344,
          0.6700000166893005
        ],
        [
          0.7020000219345093,
          0.6700000166893005
        ],
        [
          0.6819999814033508,
          0.6840000152587891
        ],
        [
          0.6740000247955322,
          0.6859999895095825
        ],
        [
          0.6460000276565552,
          0.7120000123977661
        ],
        [
          0.6420000195503235,
          0.7120000123977661
        ],
        [
          0.6380000114440918,
          0.7179999947547913
        ],
        [
          0.6240000128746033,
          0.722000002861023
        ],
        [
          0.6179999709129333,
          0.7279999852180481
        ],
        [
          0.6119999885559082,
          0.7459999918937683
        ],
        [
          0.5820000171661377,
          0.777999997138977
        ],
        [
          0.578000009059906,
          0.7900000214576721
        ],
        [
          0.5659999847412109,
          0.8019999861717224
        ],
        [
          0.5640000104904175,
          0.8119999766349792
        ],
        [
          0.5400000214576721,
          0.8479999899864197
        ],
        [
          0.5419999957084656,
          0.8600000143051147
        ],
        [
          0.5460000038146973,
          0.8600000143051147
        ],
        [
          0.550000011920929,
          0.8659999966621399
        ],
        [
          0.5640000104904175,
          0.8679999709129333
        ],
        [
          0.5659999847412109,
          0.871999979019165
        ],
        [
          0.5979999899864197,
          0.871999979019165
        ],
        [
          0.6000000238418579,
          0.8679999709129333
        ],
        [
          0.6259999871253967,
          0.8659999966621399
        ],
        [
          0.6299999952316284,
          0.8619999885559082
        ],
        [
          0.6480000019073486,
          0.8579999804496765
        ],
        [
          0.6499999761581421,
          0.8539999723434448
        ],
        [
          0.6679999828338623,
          0.8460000157356262
        ],
        [
          0.7080000042915344,
          0.8180000185966492
        ],
        [
          0.7400000095367432,
          0.7839999794960022
        ],
        [
          0.7480000257492065,
          0.7699999809265137
        ],
        [
          0.7680000066757202,
          0.7120000123977661
        ],
        [
          0.7699999809265137,
          0.6840000152587891
        ],
        [
          0.7639999985694885,
          0.6660000085830688
        ],
        [
          0.7480000257492065,
          0.6620000004768372
        ],
        [
          0.7440000176429749,
          0.656000018119812
        ],
        [
          0.734000027179718,
          0.656000018119812
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7419999837875366,
          0.6499999761581421
        ],
        [
          0.734000027179718,
          0.656000018119812
        ],
        [
          0.722000002861023,
          0.6579999923706055
        ],
        [
          0.7139999866485596,
          0.6700000166893005
        ],
        [
          0.6959999799728394,
          0.6800000071525574
        ],
        [
          0.6859999895095825,
          0.6899999976158142
        ],
        [
          0.6819999814033508,
          0.6899999976158142
        ],
        [
          0.6539999842643738,
          0.7160000205039978
        ],
        [
          0.6399999856948853,
          0.7200000286102295
        ],
        [
          0.6359999775886536,
          0.7260000109672546
        ],
        [
          0.6320000290870667,
          0.7260000109672546
        ],
        [
          0.6159999966621399,
          0.7400000095367432
        ],
        [
          0.6039999723434448,
          0.7799999713897705
        ],
        [
          0.5979999899864197,
          0.7860000133514404
        ],
        [
          0.5899999737739563,
          0.8040000200271606
        ],
        [
          0.5680000185966492,
          0.8259999752044678
        ],
        [
          0.5580000281333923,
          0.8420000076293945
        ],
        [
          0.5559999942779541,
          0.8600000143051147
        ],
        [
          0.5600000023841858,
          0.8659999966621399
        ],
        [
          0.5680000185966492,
          0.8679999709129333
        ],
        [
          0.5680000185966492,
          0.871999979019165
        ],
        [
          0.5899999737739563,
          0.8740000128746033
        ],
        [
          0.6200000047683716,
          0.871999979019165
        ],
        [
          0.621999979019165,
          0.8679999709129333
        ],
        [
          0.6359999775886536,
          0.8659999966621399
        ],
        [
          0.6380000114440918,
          0.8619999885559082
        ],
        [
          0.6600000262260437,
          0.8579999804496765
        ],
        [
          0.6620000004768372,
          0.8539999723434448
        ],
        [
          0.6940000057220459,
          0.8379999995231628
        ],
        [
          0.7139999866485596,
          0.8199999928474426
        ],
        [
          0.7179999947547913,
          0.8199999928474426
        ],
        [
          0.75,
          0.7839999794960022
        ],
        [
          0.7620000243186951,
          0.7519999742507935
        ],
        [
          0.765999972820282,
          0.75
        ],
        [
          0.7699999809265137,
          0.7319999933242798
        ],
        [
          0.7739999890327454,
          0.7300000190734863
        ],
        [
          0.7760000228881836,
          0.7239999771118164
        ],
        [
          0.777999997138977,
          0.7039999961853027
        ],
        [
          0.7820000052452087,
          0.699999988079071
        ],
        [
          0.7820000052452087,
          0.6779999732971191
        ],
        [
          0.777999997138977,
          0.6759999990463257
        ],
        [
          0.7760000228881836,
          0.6639999747276306
        ],
        [
          0.7680000066757202,
          0.656000018119812
        ],
        [
          0.7580000162124634,
          0.6499999761581421
        ],
        [
          0.7419999837875366,
          0.6499999761581421
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7319999933242798,
          0.621999979019165
        ],
        [
          0.7300000190734863,
          0.628000020980835
        ],
        [
          0.7139999866485596,
          0.6359999775886536
        ],
        [
          0.6700000166893005,
          0.6819999814033508
        ],
        [
          0.6600000262260437,
          0.6980000138282776
        ],
        [
          0.6060000061988831,
          0.7620000243186951
        ],
        [
          0.6060000061988831,
          0.765999972820282
        ],
        [
          0.5899999737739563,
          0.7839999794960022
        ],
        [
          0.5879999995231628,
          0.7940000295639038
        ],
        [
          0.5640000104904175,
          0.8240000009536743
        ],
        [
          0.550000011920929,
          0.8339999914169312
        ],
        [
          0.5460000038146973,
          0.8539999723434448
        ],
        [
          0.5479999780654907,
          0.8619999885559082
        ],
        [
          0.5559999942779541,
          0.871999979019165
        ],
        [
          0.5640000104904175,
          0.8740000128746033
        ],
        [
          0.6079999804496765,
          0.871999979019165
        ],
        [
          0.6100000143051147,
          0.8679999709129333
        ],
        [
          0.6259999871253967,
          0.8659999966621399
        ],
        [
          0.628000020980835,
          0.8619999885559082
        ],
        [
          0.6499999761581421,
          0.8579999804496765
        ],
        [
          0.6520000100135803,
          0.8539999723434448
        ],
        [
          0.6639999747276306,
          0.8519999980926514
        ],
        [
          0.6800000071525574,
          0.843999981880188
        ],
        [
          0.6899999976158142,
          0.8339999914169312
        ],
        [
          0.7020000219345093,
          0.8299999833106995
        ],
        [
          0.7400000095367432,
          0.7879999876022339
        ],
        [
          0.7480000257492065,
          0.7699999809265137
        ],
        [
          0.7519999742507935,
          0.7400000095367432
        ],
        [
          0.7580000162124634,
          0.7319999933242798
        ],
        [
          0.7599999904632568,
          0.7120000123977661
        ],
        [
          0.7639999985694885,
          0.7099999785423279
        ],
        [
          0.765999972820282,
          0.7020000219345093
        ],
        [
          0.7720000147819519,
          0.6539999842643738
        ],
        [
          0.7680000066757202,
          0.6499999761581421
        ],
        [
          0.765999972820282,
          0.6399999856948853
        ],
        [
          0.7519999742507935,
          0.621999979019165
        ],
        [
          0.7319999933242798,
          0.621999979019165
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6259999871253967,
          0.5979999899864197
        ],
        [
          0.6240000128746033,
          0.6019999980926514
        ],
        [
          0.5979999899864197,
          0.6060000061988831
        ],
        [
          0.5960000157356262,
          0.6100000143051147
        ],
        [
          0.5879999995231628,
          0.6119999885559082
        ],
        [
          0.5659999847412109,
          0.628000020980835
        ],
        [
          0.5519999861717224,
          0.6460000276565552
        ],
        [
          0.5419999957084656,
          0.6539999842643738
        ],
        [
          0.5299999713897705,
          0.6579999923706055
        ],
        [
          0.5180000066757202,
          0.671999990940094
        ],
        [
          0.5120000243186951,
          0.6859999895095825
        ],
        [
          0.5080000162124634,
          0.6880000233650208
        ],
        [
          0.49399998784065247,
          0.7239999771118164
        ],
        [
          0.49000000953674316,
          0.7260000109672546
        ],
        [
          0.48399999737739563,
          0.7599999904632568
        ],
        [
          0.49000000953674316,
          0.7979999780654907
        ],
        [
          0.5040000081062317,
          0.8119999766349792
        ],
        [
          0.5139999985694885,
          0.8140000104904175
        ],
        [
          0.5879999995231628,
          0.8119999766349792
        ],
        [
          0.5899999737739563,
          0.8080000281333923
        ],
        [
          0.6119999885559082,
          0.8040000200271606
        ],
        [
          0.6140000224113464,
          0.800000011920929
        ],
        [
          0.6240000128746033,
          0.7960000038146973
        ],
        [
          0.6420000195503235,
          0.7739999890327454
        ],
        [
          0.6420000195503235,
          0.7699999809265137
        ],
        [
          0.6480000019073486,
          0.765999972820282
        ],
        [
          0.6520000100135803,
          0.7540000081062317
        ],
        [
          0.656000018119812,
          0.7519999742507935
        ],
        [
          0.6660000085830688,
          0.7319999933242798
        ],
        [
          0.6700000166893005,
          0.7160000205039978
        ],
        [
          0.6740000247955322,
          0.7139999866485596
        ],
        [
          0.6800000071525574,
          0.6779999732971191
        ],
        [
          0.6840000152587891,
          0.6759999990463257
        ],
        [
          0.6880000233650208,
          0.656000018119812
        ],
        [
          0.6880000233650208,
          0.6119999885559082
        ],
        [
          0.6840000152587891,
          0.6060000061988831
        ],
        [
          0.6700000166893005,
          0.6019999980926514
        ],
        [
          0.6679999828338623,
          0.5979999899864197
        ],
        [
          0.6259999871253967,
          0.5979999899864197
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6420000195503235,
          0.5920000076293945
        ],
        [
          0.6399999856948853,
          0.5960000157356262
        ],
        [
          0.6240000128746033,
          0.5979999899864197
        ],
        [
          0.5979999899864197,
          0.6140000224113464
        ],
        [
          0.5860000252723694,
          0.621999979019165
        ],
        [
          0.578000009059906,
          0.6340000033378601
        ],
        [
          0.5600000023841858,
          0.6480000019073486
        ],
        [
          0.5400000214576721,
          0.656000018119812
        ],
        [
          0.527999997138977,
          0.6779999732971191
        ],
        [
          0.49799999594688416,
          0.7139999866485596
        ],
        [
          0.492000013589859,
          0.7360000014305115
        ],
        [
          0.4880000054836273,
          0.7379999756813049
        ],
        [
          0.4819999933242798,
          0.7680000066757202
        ],
        [
          0.4819999933242798,
          0.7919999957084656
        ],
        [
          0.4860000014305115,
          0.7979999780654907
        ],
        [
          0.49799999594688416,
          0.8040000200271606
        ],
        [
          0.5139999985694885,
          0.8059999942779541
        ],
        [
          0.5180000066757202,
          0.8100000023841858
        ],
        [
          0.5879999995231628,
          0.8100000023841858
        ],
        [
          0.5899999737739563,
          0.8059999942779541
        ],
        [
          0.6159999966621399,
          0.8019999861717224
        ],
        [
          0.6420000195503235,
          0.7799999713897705
        ],
        [
          0.6800000071525574,
          0.7360000014305115
        ],
        [
          0.6899999976158142,
          0.7139999866485596
        ],
        [
          0.6919999718666077,
          0.6959999799728394
        ],
        [
          0.6959999799728394,
          0.6940000057220459
        ],
        [
          0.7020000219345093,
          0.6700000166893005
        ],
        [
          0.7099999785423279,
          0.6539999842643738
        ],
        [
          0.7099999785423279,
          0.6200000047683716
        ],
        [
          0.7059999704360962,
          0.6119999885559082
        ],
        [
          0.7020000219345093,
          0.6119999885559082
        ],
        [
          0.6980000138282776,
          0.6060000061988831
        ],
        [
          0.6880000233650208,
          0.6019999980926514
        ],
        [
          0.6779999732971191,
          0.5920000076293945
        ],
        [
          0.6420000195503235,
          0.5920000076293945
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6480000019073486,
          0.5979999899864197
        ],
        [
          0.6380000114440918,
          0.6019999980926514
        ],
        [
          0.6340000033378601,
          0.6079999804496765
        ],
        [
          0.6299999952316284,
          0.6079999804496765
        ],
        [
          0.5879999995231628,
          0.6399999856948853
        ],
        [
          0.5839999914169312,
          0.6399999856948853
        ],
        [
          0.578000009059906,
          0.6480000019073486
        ],
        [
          0.5619999766349792,
          0.6539999842643738
        ],
        [
          0.527999997138977,
          0.6899999976158142
        ],
        [
          0.5239999890327454,
          0.699999988079071
        ],
        [
          0.515999972820282,
          0.7059999704360962
        ],
        [
          0.515999972820282,
          0.7139999866485596
        ],
        [
          0.5040000081062317,
          0.7379999756813049
        ],
        [
          0.5059999823570251,
          0.7860000133514404
        ],
        [
          0.5320000052452087,
          0.8059999942779541
        ],
        [
          0.5920000076293945,
          0.8080000281333923
        ],
        [
          0.6359999775886536,
          0.7919999957084656
        ],
        [
          0.6380000114440918,
          0.7879999876022339
        ],
        [
          0.656000018119812,
          0.777999997138977
        ],
        [
          0.6740000247955322,
          0.7599999904632568
        ],
        [
          0.6740000247955322,
          0.7559999823570251
        ],
        [
          0.6919999718666077,
          0.7379999756813049
        ],
        [
          0.6959999799728394,
          0.7260000109672546
        ],
        [
          0.699999988079071,
          0.7239999771118164
        ],
        [
          0.722000002861023,
          0.6700000166893005
        ],
        [
          0.7200000286102295,
          0.6179999709129333
        ],
        [
          0.7160000205039978,
          0.6179999709129333
        ],
        [
          0.7139999866485596,
          0.6100000143051147
        ],
        [
          0.7020000219345093,
          0.5979999899864197
        ],
        [
          0.6480000019073486,
          0.5979999899864197
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.6959999799728394,
          0.6039999723434448
        ],
        [
          0.6940000057220459,
          0.6079999804496765
        ],
        [
          0.6779999732971191,
          0.6079999804496765
        ],
        [
          0.6660000085830688,
          0.6119999885559082
        ],
        [
          0.656000018119812,
          0.621999979019165
        ],
        [
          0.6460000276565552,
          0.6240000128746033
        ],
        [
          0.6340000033378601,
          0.6399999856948853
        ],
        [
          0.6259999871253967,
          0.6420000195503235
        ],
        [
          0.6119999885559082,
          0.6539999842643738
        ],
        [
          0.593999981880188,
          0.6579999923706055
        ],
        [
          0.5640000104904175,
          0.6859999895095825
        ],
        [
          0.5540000200271606,
          0.6880000233650208
        ],
        [
          0.5379999876022339,
          0.7080000042915344
        ],
        [
          0.5320000052452087,
          0.7260000109672546
        ],
        [
          0.5260000228881836,
          0.7279999852180481
        ],
        [
          0.5239999890327454,
          0.7400000095367432
        ],
        [
          0.5180000066757202,
          0.7440000176429749
        ],
        [
          0.5120000243186951,
          0.7580000162124634
        ],
        [
          0.5059999823570251,
          0.7639999985694885
        ],
        [
          0.5,
          0.7820000052452087
        ],
        [
          0.49399998784065247,
          0.7900000214576721
        ],
        [
          0.49399998784065247,
          0.8059999942779541
        ],
        [
          0.5,
          0.8180000185966492
        ],
        [
          0.5120000243186951,
          0.8259999752044678
        ],
        [
          0.5220000147819519,
          0.828000009059906
        ],
        [
          0.5740000009536743,
          0.8259999752044678
        ],
        [
          0.5759999752044678,
          0.8220000267028809
        ],
        [
          0.6060000061988831,
          0.8180000185966492
        ],
        [
          0.6079999804496765,
          0.8140000104904175
        ],
        [
          0.6520000100135803,
          0.8019999861717224
        ],
        [
          0.6539999842643738,
          0.7979999780654907
        ],
        [
          0.6660000085830688,
          0.7940000295639038
        ],
        [
          0.7120000123977661,
          0.7419999837875366
        ],
        [
          0.7179999947547913,
          0.7260000109672546
        ],
        [
          0.7260000109672546,
          0.7160000205039978
        ],
        [
          0.7279999852180481,
          0.7039999961853027
        ],
        [
          0.7319999933242798,
          0.7020000219345093
        ],
        [
          0.7379999756813049,
          0.6740000247955322
        ],
        [
          0.7419999837875366,
          0.671999990940094
        ],
        [
          0.7419999837875366,
          0.6380000114440918
        ],
        [
          0.7379999756813049,
          0.6340000033378601
        ],
        [
          0.734000027179718,
          0.6179999709129333
        ],
        [
          0.7179999947547913,
          0.6039999723434448
        ],
        [
          0.6959999799728394,
          0.6039999723434448
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7139999866485596,
          0.6140000224113464
        ],
        [
          0.7020000219345093,
          0.6179999709129333
        ],
        [
          0.699999988079071,
          0.621999979019165
        ],
        [
          0.6840000152587891,
          0.6259999871253967
        ],
        [
          0.6660000085830688,
          0.6460000276565552
        ],
        [
          0.6539999842643738,
          0.656000018119812
        ],
        [
          0.6499999761581421,
          0.656000018119812
        ],
        [
          0.6439999938011169,
          0.6639999747276306
        ],
        [
          0.6200000047683716,
          0.6740000247955322
        ],
        [
          0.6179999709129333,
          0.6779999732971191
        ],
        [
          0.6039999723434448,
          0.6819999814033508
        ],
        [
          0.5740000009536743,
          0.7139999866485596
        ],
        [
          0.5619999766349792,
          0.7360000014305115
        ],
        [
          0.5540000200271606,
          0.7419999837875366
        ],
        [
          0.5519999861717224,
          0.7519999742507935
        ],
        [
          0.5479999780654907,
          0.7540000081062317
        ],
        [
          0.5360000133514404,
          0.777999997138977
        ],
        [
          0.5360000133514404,
          0.8100000023841858
        ],
        [
          0.5379999876022339,
          0.8220000267028809
        ],
        [
          0.5440000295639038,
          0.8299999833106995
        ],
        [
          0.5759999752044678,
          0.8339999914169312
        ],
        [
          0.5799999833106995,
          0.8379999995231628
        ],
        [
          0.5899999737739563,
          0.8399999737739563
        ],
        [
          0.6320000290870667,
          0.8379999995231628
        ],
        [
          0.6359999775886536,
          0.8339999914169312
        ],
        [
          0.6539999842643738,
          0.8299999833106995
        ],
        [
          0.6579999923706055,
          0.8240000009536743
        ],
        [
          0.6740000247955322,
          0.8159999847412109
        ],
        [
          0.7200000286102295,
          0.7680000066757202
        ],
        [
          0.7300000190734863,
          0.7519999742507935
        ],
        [
          0.734000027179718,
          0.7379999756813049
        ],
        [
          0.7459999918937683,
          0.722000002861023
        ],
        [
          0.7519999742507935,
          0.6880000233650208
        ],
        [
          0.7559999823570251,
          0.6859999895095825
        ],
        [
          0.7559999823570251,
          0.6539999842643738
        ],
        [
          0.7519999742507935,
          0.6499999761581421
        ],
        [
          0.7459999918937683,
          0.6240000128746033
        ],
        [
          0.7279999852180481,
          0.6140000224113464
        ],
        [
          0.7139999866485596,
          0.6140000224113464
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7160000205039978,
          0.621999979019165
        ],
        [
          0.7059999704360962,
          0.6259999871253967
        ],
        [
          0.7039999961853027,
          0.6320000290870667
        ],
        [
          0.6679999828338623,
          0.6499999761581421
        ],
        [
          0.6660000085830688,
          0.6539999842643738
        ],
        [
          0.656000018119812,
          0.656000018119812
        ],
        [
          0.6399999856948853,
          0.671999990940094
        ],
        [
          0.6159999966621399,
          0.6880000233650208
        ],
        [
          0.6100000143051147,
          0.7020000219345093
        ],
        [
          0.5860000252723694,
          0.7319999933242798
        ],
        [
          0.5860000252723694,
          0.7360000014305115
        ],
        [
          0.5680000185966492,
          0.7580000162124634
        ],
        [
          0.5640000104904175,
          0.7680000066757202
        ],
        [
          0.5580000281333923,
          0.7699999809265137
        ],
        [
          0.5559999942779541,
          0.7879999876022339
        ],
        [
          0.5460000038146973,
          0.8059999942779541
        ],
        [
          0.5440000295639038,
          0.8199999928474426
        ],
        [
          0.5400000214576721,
          0.8220000267028809
        ],
        [
          0.5400000214576721,
          0.8339999914169312
        ],
        [
          0.5440000295639038,
          0.8360000252723694
        ],
        [
          0.5460000038146973,
          0.8479999899864197
        ],
        [
          0.6140000224113464,
          0.8479999899864197
        ],
        [
          0.6159999966621399,
          0.843999981880188
        ],
        [
          0.628000020980835,
          0.843999981880188
        ],
        [
          0.6399999856948853,
          0.8399999737739563
        ],
        [
          0.6420000195503235,
          0.8360000252723694
        ],
        [
          0.6600000262260437,
          0.8320000171661377
        ],
        [
          0.6620000004768372,
          0.828000009059906
        ],
        [
          0.6740000247955322,
          0.8259999752044678
        ],
        [
          0.6759999990463257,
          0.8220000267028809
        ],
        [
          0.6840000152587891,
          0.8199999928474426
        ],
        [
          0.7260000109672546,
          0.7739999890327454
        ],
        [
          0.7519999742507935,
          0.7160000205039978
        ],
        [
          0.7540000081062317,
          0.699999988079071
        ],
        [
          0.7580000162124634,
          0.6959999799728394
        ],
        [
          0.7599999904632568,
          0.6639999747276306
        ],
        [
          0.7580000162124634,
          0.6480000019073486
        ],
        [
          0.7440000176429749,
          0.621999979019165
        ],
        [
          0.7160000205039978,
          0.621999979019165
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7300000190734863,
          0.621999979019165
        ],
        [
          0.7200000286102295,
          0.6240000128746033
        ],
        [
          0.7120000123977661,
          0.6359999775886536
        ],
        [
          0.7039999961853027,
          0.6380000114440918
        ],
        [
          0.6880000233650208,
          0.6499999761581421
        ],
        [
          0.6679999828338623,
          0.6539999842643738
        ],
        [
          0.6340000033378601,
          0.6859999895095825
        ],
        [
          0.6039999723434448,
          0.722000002861023
        ],
        [
          0.5979999899864197,
          0.734000027179718
        ],
        [
          0.5920000076293945,
          0.7379999756813049
        ],
        [
          0.5899999737739563,
          0.7480000257492065
        ],
        [
          0.5820000171661377,
          0.7559999823570251
        ],
        [
          0.5720000267028809,
          0.7760000228881836
        ],
        [
          0.5559999942779541,
          0.7919999957084656
        ],
        [
          0.5559999942779541,
          0.800000011920929
        ],
        [
          0.5400000214576721,
          0.8180000185966492
        ],
        [
          0.5360000133514404,
          0.828000009059906
        ],
        [
          0.5360000133514404,
          0.8479999899864197
        ],
        [
          0.5559999942779541,
          0.8560000061988831
        ],
        [
          0.5559999942779541,
          0.8600000143051147
        ],
        [
          0.6039999723434448,
          0.8600000143051147
        ],
        [
          0.6060000061988831,
          0.8560000061988831
        ],
        [
          0.6480000019073486,
          0.8460000157356262
        ],
        [
          0.6499999761581421,
          0.8420000076293945
        ],
        [
          0.6600000262260437,
          0.8399999737739563
        ],
        [
          0.6620000004768372,
          0.8360000252723694
        ],
        [
          0.6779999732971191,
          0.8320000171661377
        ],
        [
          0.6880000233650208,
          0.8220000267028809
        ],
        [
          0.6919999718666077,
          0.8220000267028809
        ],
        [
          0.7200000286102295,
          0.7919999957084656
        ],
        [
          0.7379999756813049,
          0.7620000243186951
        ],
        [
          0.7419999837875366,
          0.7440000176429749
        ],
        [
          0.7459999918937683,
          0.7419999837875366
        ],
        [
          0.7580000162124634,
          0.7099999785423279
        ],
        [
          0.7620000243186951,
          0.7080000042915344
        ],
        [
          0.765999972820282,
          0.6740000247955322
        ],
        [
          0.7620000243186951,
          0.6399999856948853
        ],
        [
          0.7580000162124634,
          0.6380000114440918
        ],
        [
          0.75,
          0.621999979019165
        ],
        [
          0.7300000190734863,
          0.621999979019165
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7400000095367432,
          0.6200000047683716
        ],
        [
          0.7319999933242798,
          0.6200000047683716
        ],
        [
          0.7239999771118164,
          0.6299999952316284
        ],
        [
          0.699999988079071,
          0.6480000019073486
        ],
        [
          0.6840000152587891,
          0.6520000100135803
        ],
        [
          0.6800000071525574,
          0.6620000004768372
        ],
        [
          0.6679999828338623,
          0.6660000085830688
        ],
        [
          0.6380000114440918,
          0.699999988079071
        ],
        [
          0.6340000033378601,
          0.699999988079071
        ],
        [
          0.6159999966621399,
          0.7179999947547913
        ],
        [
          0.6079999804496765,
          0.722000002861023
        ],
        [
          0.6079999804496765,
          0.7260000109672546
        ],
        [
          0.5920000076293945,
          0.7480000257492065
        ],
        [
          0.5879999995231628,
          0.7599999904632568
        ],
        [
          0.5740000009536743,
          0.7739999890327454
        ],
        [
          0.5619999766349792,
          0.7919999957084656
        ],
        [
          0.5580000281333923,
          0.7919999957084656
        ],
        [
          0.5400000214576721,
          0.8180000185966492
        ],
        [
          0.5379999876022339,
          0.8259999752044678
        ],
        [
          0.5320000052452087,
          0.8299999833106995
        ],
        [
          0.5299999713897705,
          0.8399999737739563
        ],
        [
          0.5320000052452087,
          0.8519999980926514
        ],
        [
          0.5479999780654907,
          0.8600000143051147
        ],
        [
          0.5640000104904175,
          0.8619999885559082
        ],
        [
          0.5680000185966492,
          0.8659999966621399
        ],
        [
          0.6140000224113464,
          0.8659999966621399
        ],
        [
          0.6159999966621399,
          0.8619999885559082
        ],
        [
          0.6480000019073486,
          0.8519999980926514
        ],
        [
          0.6499999761581421,
          0.8479999899864197
        ],
        [
          0.6639999747276306,
          0.843999981880188
        ],
        [
          0.6759999990463257,
          0.8339999914169312
        ],
        [
          0.6899999976158142,
          0.8299999833106995
        ],
        [
          0.6980000138282776,
          0.8240000009536743
        ],
        [
          0.734000027179718,
          0.7820000052452087
        ],
        [
          0.734000027179718,
          0.777999997138977
        ],
        [
          0.7400000095367432,
          0.7739999890327454
        ],
        [
          0.7419999837875366,
          0.7639999985694885
        ],
        [
          0.7459999918937683,
          0.7620000243186951
        ],
        [
          0.75,
          0.7480000257492065
        ],
        [
          0.7540000081062317,
          0.7459999918937683
        ],
        [
          0.7599999904632568,
          0.722000002861023
        ],
        [
          0.7639999985694885,
          0.7200000286102295
        ],
        [
          0.7680000066757202,
          0.699999988079071
        ],
        [
          0.7720000147819519,
          0.6980000138282776
        ],
        [
          0.7720000147819519,
          0.6380000114440918
        ],
        [
          0.765999972820282,
          0.6340000033378601
        ],
        [
          0.7599999904632568,
          0.621999979019165
        ],
        [
          0.7400000095367432,
          0.6200000047683716
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7440000176429749,
          0.6179999709129333
        ],
        [
          0.7179999947547913,
          0.6439999938011169
        ],
        [
          0.7099999785423279,
          0.6460000276565552
        ],
        [
          0.6959999799728394,
          0.6579999923706055
        ],
        [
          0.6859999895095825,
          0.6600000262260437
        ],
        [
          0.6439999938011169,
          0.7020000219345093
        ],
        [
          0.6340000033378601,
          0.7080000042915344
        ],
        [
          0.6100000143051147,
          0.7360000014305115
        ],
        [
          0.6000000238418579,
          0.7599999904632568
        ],
        [
          0.5339999794960022,
          0.8299999833106995
        ],
        [
          0.5299999713897705,
          0.8619999885559082
        ],
        [
          0.5419999957084656,
          0.8740000128746033
        ],
        [
          0.6000000238418579,
          0.8759999871253967
        ],
        [
          0.6100000143051147,
          0.8740000128746033
        ],
        [
          0.6119999885559082,
          0.8700000047683716
        ],
        [
          0.6259999871253967,
          0.8679999709129333
        ],
        [
          0.628000020980835,
          0.8640000224113464
        ],
        [
          0.6399999856948853,
          0.8619999885559082
        ],
        [
          0.656000018119812,
          0.8539999723434448
        ],
        [
          0.6679999828338623,
          0.843999981880188
        ],
        [
          0.6779999732971191,
          0.8420000076293945
        ],
        [
          0.6819999814033508,
          0.8360000252723694
        ],
        [
          0.7020000219345093,
          0.8259999752044678
        ],
        [
          0.7139999866485596,
          0.8100000023841858
        ],
        [
          0.7179999947547913,
          0.8100000023841858
        ],
        [
          0.7279999852180481,
          0.800000011920929
        ],
        [
          0.7279999852180481,
          0.7960000038146973
        ],
        [
          0.7419999837875366,
          0.7799999713897705
        ],
        [
          0.7519999742507935,
          0.7540000081062317
        ],
        [
          0.7559999823570251,
          0.7519999742507935
        ],
        [
          0.7580000162124634,
          0.7360000014305115
        ],
        [
          0.7639999985694885,
          0.7279999852180481
        ],
        [
          0.7680000066757202,
          0.7059999704360962
        ],
        [
          0.7739999890327454,
          0.6940000057220459
        ],
        [
          0.7760000228881836,
          0.6679999828338623
        ],
        [
          0.7799999713897705,
          0.6660000085830688
        ],
        [
          0.7820000052452087,
          0.6399999856948853
        ],
        [
          0.7760000228881836,
          0.6240000128746033
        ],
        [
          0.7639999985694885,
          0.6179999709129333
        ],
        [
          0.7440000176429749,
          0.6179999709129333
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7540000081062317,
          0.6179999709129333
        ],
        [
          0.7480000257492065,
          0.6200000047683716
        ],
        [
          0.7459999918937683,
          0.6259999871253967
        ],
        [
          0.7239999771118164,
          0.6460000276565552
        ],
        [
          0.7099999785423279,
          0.6520000100135803
        ],
        [
          0.7020000219345093,
          0.6639999747276306
        ],
        [
          0.6880000233650208,
          0.6700000166893005
        ],
        [
          0.6320000290870667,
          0.7279999852180481
        ],
        [
          0.6200000047683716,
          0.7459999918937683
        ],
        [
          0.6179999709129333,
          0.7540000081062317
        ],
        [
          0.6100000143051147,
          0.7620000243186951
        ],
        [
          0.6100000143051147,
          0.765999972820282
        ],
        [
          0.5659999847412109,
          0.8119999766349792
        ],
        [
          0.5519999861717224,
          0.8320000171661377
        ],
        [
          0.5519999861717224,
          0.8360000252723694
        ],
        [
          0.5440000295639038,
          0.843999981880188
        ],
        [
          0.5400000214576721,
          0.8640000224113464
        ],
        [
          0.550000011920929,
          0.8759999871253967
        ],
        [
          0.5659999847412109,
          0.878000020980835
        ],
        [
          0.5720000267028809,
          0.8820000290870667
        ],
        [
          0.593999981880188,
          0.8820000290870667
        ],
        [
          0.5960000157356262,
          0.878000020980835
        ],
        [
          0.6200000047683716,
          0.8759999871253967
        ],
        [
          0.628000020980835,
          0.8700000047683716
        ],
        [
          0.6399999856948853,
          0.8679999709129333
        ],
        [
          0.6420000195503235,
          0.8640000224113464
        ],
        [
          0.6759999990463257,
          0.8500000238418579
        ],
        [
          0.6880000233650208,
          0.8379999995231628
        ],
        [
          0.6959999799728394,
          0.8360000252723694
        ],
        [
          0.7400000095367432,
          0.7919999957084656
        ],
        [
          0.7400000095367432,
          0.7879999876022339
        ],
        [
          0.7540000081062317,
          0.7720000147819519
        ],
        [
          0.7559999823570251,
          0.7620000243186951
        ],
        [
          0.7599999904632568,
          0.7599999904632568
        ],
        [
          0.7720000147819519,
          0.7239999771118164
        ],
        [
          0.777999997138977,
          0.7200000286102295
        ],
        [
          0.7860000133514404,
          0.6940000057220459
        ],
        [
          0.7860000133514404,
          0.671999990940094
        ],
        [
          0.7900000214576721,
          0.6700000166893005
        ],
        [
          0.7900000214576721,
          0.6520000100135803
        ],
        [
          0.7860000133514404,
          0.6520000100135803
        ],
        [
          0.7839999794960022,
          0.6359999775886536
        ],
        [
          0.7720000147819519,
          0.6200000047683716
        ],
        [
          0.7540000081062317,
          0.6179999709129333
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7580000162124634,
          0.6240000128746033
        ],
        [
          0.7459999918937683,
          0.6299999952316284
        ],
        [
          0.7300000190734863,
          0.6460000276565552
        ],
        [
          0.7160000205039978,
          0.6520000100135803
        ],
        [
          0.7099999785423279,
          0.6620000004768372
        ],
        [
          0.6880000233650208,
          0.6759999990463257
        ],
        [
          0.6520000100135803,
          0.7139999866485596
        ],
        [
          0.6380000114440918,
          0.7200000286102295
        ],
        [
          0.6380000114440918,
          0.7239999771118164
        ],
        [
          0.6299999952316284,
          0.7279999852180481
        ],
        [
          0.628000020980835,
          0.7400000095367432
        ],
        [
          0.621999979019165,
          0.7459999918937683
        ],
        [
          0.6159999966621399,
          0.7680000066757202
        ],
        [
          0.6100000143051147,
          0.7720000147819519
        ],
        [
          0.6079999804496765,
          0.7820000052452087
        ],
        [
          0.578000009059906,
          0.8159999847412109
        ],
        [
          0.578000009059906,
          0.8199999928474426
        ],
        [
          0.5640000104904175,
          0.8339999914169312
        ],
        [
          0.5559999942779541,
          0.8500000238418579
        ],
        [
          0.5460000038146973,
          0.8600000143051147
        ],
        [
          0.5460000038146973,
          0.8700000047683716
        ],
        [
          0.5580000281333923,
          0.8820000290870667
        ],
        [
          0.6039999723434448,
          0.8840000033378601
        ],
        [
          0.6460000276565552,
          0.8700000047683716
        ],
        [
          0.6579999923706055,
          0.8640000224113464
        ],
        [
          0.6600000262260437,
          0.8600000143051147
        ],
        [
          0.6679999828338623,
          0.8579999804496765
        ],
        [
          0.6819999814033508,
          0.8460000157356262
        ],
        [
          0.6859999895095825,
          0.8460000157356262
        ],
        [
          0.7260000109672546,
          0.8119999766349792
        ],
        [
          0.7300000190734863,
          0.8119999766349792
        ],
        [
          0.7400000095367432,
          0.800000011920929
        ],
        [
          0.7400000095367432,
          0.7960000038146973
        ],
        [
          0.7580000162124634,
          0.7760000228881836
        ],
        [
          0.7680000066757202,
          0.7519999742507935
        ],
        [
          0.7720000147819519,
          0.75
        ],
        [
          0.7760000228881836,
          0.734000027179718
        ],
        [
          0.7820000052452087,
          0.7260000109672546
        ],
        [
          0.7839999794960022,
          0.7080000042915344
        ],
        [
          0.7879999876022339,
          0.7059999704360962
        ],
        [
          0.7900000214576721,
          0.6880000233650208
        ],
        [
          0.7900000214576721,
          0.6420000195503235
        ],
        [
          0.7760000228881836,
          0.6259999871253967
        ],
        [
          0.7580000162124634,
          0.6240000128746033
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7680000066757202,
          0.6320000290870667
        ],
        [
          0.7580000162124634,
          0.6340000033378601
        ],
        [
          0.7480000257492065,
          0.6439999938011169
        ],
        [
          0.734000027179718,
          0.6499999761581421
        ],
        [
          0.6779999732971191,
          0.7020000219345093
        ],
        [
          0.6740000247955322,
          0.7020000219345093
        ],
        [
          0.6740000247955322,
          0.7059999704360962
        ],
        [
          0.6620000004768372,
          0.7139999866485596
        ],
        [
          0.6620000004768372,
          0.7179999947547913
        ],
        [
          0.6520000100135803,
          0.7300000190734863
        ],
        [
          0.6460000276565552,
          0.7319999933242798
        ],
        [
          0.6439999938011169,
          0.7419999837875366
        ],
        [
          0.6340000033378601,
          0.75
        ],
        [
          0.6299999952316284,
          0.765999972820282
        ],
        [
          0.5839999914169312,
          0.8240000009536743
        ],
        [
          0.578000009059906,
          0.8360000252723694
        ],
        [
          0.5699999928474426,
          0.8420000076293945
        ],
        [
          0.5680000185966492,
          0.8539999723434448
        ],
        [
          0.5619999766349792,
          0.8600000143051147
        ],
        [
          0.5619999766349792,
          0.8759999871253967
        ],
        [
          0.5680000185966492,
          0.8840000033378601
        ],
        [
          0.5920000076293945,
          0.8880000114440918
        ],
        [
          0.5960000157356262,
          0.8840000033378601
        ],
        [
          0.6299999952316284,
          0.8820000290870667
        ],
        [
          0.6320000290870667,
          0.878000020980835
        ],
        [
          0.6480000019073486,
          0.8759999871253967
        ],
        [
          0.6600000262260437,
          0.8700000047683716
        ],
        [
          0.6620000004768372,
          0.8659999966621399
        ],
        [
          0.671999990940094,
          0.8640000224113464
        ],
        [
          0.6819999814033508,
          0.8539999723434448
        ],
        [
          0.6859999895095825,
          0.8539999723434448
        ],
        [
          0.7020000219345093,
          0.8399999737739563
        ],
        [
          0.7059999704360962,
          0.8399999737739563
        ],
        [
          0.7419999837875366,
          0.8040000200271606
        ],
        [
          0.7419999837875366,
          0.800000011920929
        ],
        [
          0.7559999823570251,
          0.7860000133514404
        ],
        [
          0.7680000066757202,
          0.7680000066757202
        ],
        [
          0.7720000147819519,
          0.7559999823570251
        ],
        [
          0.7760000228881836,
          0.7540000081062317
        ],
        [
          0.777999997138977,
          0.7440000176429749
        ],
        [
          0.7820000052452087,
          0.7419999837875366
        ],
        [
          0.7839999794960022,
          0.7260000109672546
        ],
        [
          0.7879999876022339,
          0.7239999771118164
        ],
        [
          0.7919999957084656,
          0.6880000233650208
        ],
        [
          0.7960000038146973,
          0.6859999895095825
        ],
        [
          0.7960000038146973,
          0.656000018119812
        ],
        [
          0.7919999957084656,
          0.6460000276565552
        ],
        [
          0.7820000052452087,
          0.6340000033378601
        ],
        [
          0.7680000066757202,
          0.6320000290870667
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7720000147819519,
          0.6299999952316284
        ],
        [
          0.7699999809265137,
          0.6340000033378601
        ],
        [
          0.7459999918937683,
          0.6420000195503235
        ],
        [
          0.7379999756813049,
          0.6539999842643738
        ],
        [
          0.7239999771118164,
          0.6660000085830688
        ],
        [
          0.7200000286102295,
          0.6660000085830688
        ],
        [
          0.7120000123977661,
          0.6759999990463257
        ],
        [
          0.7039999961853027,
          0.6779999732971191
        ],
        [
          0.6579999923706055,
          0.7239999771118164
        ],
        [
          0.6539999842643738,
          0.7239999771118164
        ],
        [
          0.6480000019073486,
          0.7300000190734863
        ],
        [
          0.6460000276565552,
          0.7379999756813049
        ],
        [
          0.6399999856948853,
          0.7440000176429749
        ],
        [
          0.6380000114440918,
          0.7540000081062317
        ],
        [
          0.6340000033378601,
          0.7559999823570251
        ],
        [
          0.6320000290870667,
          0.7720000147819519
        ],
        [
          0.621999979019165,
          0.7839999794960022
        ],
        [
          0.6179999709129333,
          0.7960000038146973
        ],
        [
          0.5960000157356262,
          0.8220000267028809
        ],
        [
          0.5920000076293945,
          0.8379999995231628
        ],
        [
          0.5879999995231628,
          0.8399999737739563
        ],
        [
          0.5799999833106995,
          0.8640000224113464
        ],
        [
          0.5860000252723694,
          0.8759999871253967
        ],
        [
          0.5960000157356262,
          0.8820000290870667
        ],
        [
          0.6259999871253967,
          0.8820000290870667
        ],
        [
          0.6460000276565552,
          0.8799999952316284
        ],
        [
          0.6480000019073486,
          0.8759999871253967
        ],
        [
          0.6639999747276306,
          0.8740000128746033
        ],
        [
          0.6740000247955322,
          0.8640000224113464
        ],
        [
          0.6840000152587891,
          0.8619999885559082
        ],
        [
          0.7260000109672546,
          0.8220000267028809
        ],
        [
          0.7300000190734863,
          0.8220000267028809
        ],
        [
          0.765999972820282,
          0.7799999713897705
        ],
        [
          0.7720000147819519,
          0.7680000066757202
        ],
        [
          0.7760000228881836,
          0.765999972820282
        ],
        [
          0.7860000133514404,
          0.7360000014305115
        ],
        [
          0.7900000214576721,
          0.7319999933242798
        ],
        [
          0.7919999957084656,
          0.7120000123977661
        ],
        [
          0.7960000038146973,
          0.7080000042915344
        ],
        [
          0.7979999780654907,
          0.6959999799728394
        ],
        [
          0.7979999780654907,
          0.6779999732971191
        ],
        [
          0.8019999861717224,
          0.6759999990463257
        ],
        [
          0.8019999861717224,
          0.6520000100135803
        ],
        [
          0.7979999780654907,
          0.6420000195503235
        ],
        [
          0.7839999794960022,
          0.6340000033378601
        ],
        [
          0.7820000052452087,
          0.6299999952316284
        ],
        [
          0.7720000147819519,
          0.6299999952316284
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7680000066757202,
          0.6340000033378601
        ],
        [
          0.765999972820282,
          0.6380000114440918
        ],
        [
          0.75,
          0.6399999856948853
        ],
        [
          0.734000027179718,
          0.6620000004768372
        ],
        [
          0.7300000190734863,
          0.6620000004768372
        ],
        [
          0.7039999961853027,
          0.6840000152587891
        ],
        [
          0.6959999799728394,
          0.6859999895095825
        ],
        [
          0.6420000195503235,
          0.7379999756813049
        ],
        [
          0.6420000195503235,
          0.7419999837875366
        ],
        [
          0.6359999775886536,
          0.7480000257492065
        ],
        [
          0.6259999871253967,
          0.7820000052452087
        ],
        [
          0.621999979019165,
          0.7839999794960022
        ],
        [
          0.6200000047683716,
          0.7940000295639038
        ],
        [
          0.6039999723434448,
          0.8220000267028809
        ],
        [
          0.6019999980926514,
          0.8360000252723694
        ],
        [
          0.5979999899864197,
          0.8399999737739563
        ],
        [
          0.5979999899864197,
          0.8579999804496765
        ],
        [
          0.6079999804496765,
          0.8679999709129333
        ],
        [
          0.621999979019165,
          0.8700000047683716
        ],
        [
          0.6259999871253967,
          0.8740000128746033
        ],
        [
          0.6460000276565552,
          0.8740000128746033
        ],
        [
          0.6480000019073486,
          0.8700000047683716
        ],
        [
          0.6639999747276306,
          0.8679999709129333
        ],
        [
          0.6660000085830688,
          0.8640000224113464
        ],
        [
          0.6740000247955322,
          0.8619999885559082
        ],
        [
          0.7039999961853027,
          0.8399999737739563
        ],
        [
          0.7080000042915344,
          0.8399999737739563
        ],
        [
          0.7099999785423279,
          0.8360000252723694
        ],
        [
          0.7179999947547913,
          0.8339999914169312
        ],
        [
          0.7559999823570251,
          0.7979999780654907
        ],
        [
          0.7559999823570251,
          0.7940000295639038
        ],
        [
          0.7720000147819519,
          0.777999997138977
        ],
        [
          0.7860000133514404,
          0.7480000257492065
        ],
        [
          0.7940000295639038,
          0.7200000286102295
        ],
        [
          0.7979999780654907,
          0.7179999947547913
        ],
        [
          0.800000011920929,
          0.6959999799728394
        ],
        [
          0.8040000200271606,
          0.6919999718666077
        ],
        [
          0.8040000200271606,
          0.6620000004768372
        ],
        [
          0.800000011920929,
          0.6600000262260437
        ],
        [
          0.7940000295639038,
          0.6399999856948853
        ],
        [
          0.7820000052452087,
          0.6380000114440918
        ],
        [
          0.7799999713897705,
          0.6340000033378601
        ],
        [
          0.7680000066757202,
          0.6340000033378601
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.777999997138977,
          0.6399999856948853
        ],
        [
          0.7760000228881836,
          0.6439999938011169
        ],
        [
          0.7699999809265137,
          0.6439999938011169
        ],
        [
          0.765999972820282,
          0.6499999761581421
        ],
        [
          0.7480000257492065,
          0.6579999923706055
        ],
        [
          0.7400000095367432,
          0.6679999828338623
        ],
        [
          0.7360000014305115,
          0.6679999828338623
        ],
        [
          0.7020000219345093,
          0.6899999976158142
        ],
        [
          0.6679999828338623,
          0.722000002861023
        ],
        [
          0.6420000195503235,
          0.7680000066757202
        ],
        [
          0.6320000290870667,
          0.7799999713897705
        ],
        [
          0.6320000290870667,
          0.7839999794960022
        ],
        [
          0.6039999723434448,
          0.8180000185966492
        ],
        [
          0.5979999899864197,
          0.8360000252723694
        ],
        [
          0.5879999995231628,
          0.8479999899864197
        ],
        [
          0.5860000252723694,
          0.8579999804496765
        ],
        [
          0.5799999833106995,
          0.8640000224113464
        ],
        [
          0.5799999833106995,
          0.8700000047683716
        ],
        [
          0.5879999995231628,
          0.8799999952316284
        ],
        [
          0.6000000238418579,
          0.8859999775886536
        ],
        [
          0.6359999775886536,
          0.8859999775886536
        ],
        [
          0.6539999842643738,
          0.8840000033378601
        ],
        [
          0.656000018119812,
          0.8799999952316284
        ],
        [
          0.6679999828338623,
          0.878000020980835
        ],
        [
          0.6980000138282776,
          0.8579999804496765
        ],
        [
          0.7020000219345093,
          0.8579999804496765
        ],
        [
          0.7239999771118164,
          0.8360000252723694
        ],
        [
          0.7279999852180481,
          0.8360000252723694
        ],
        [
          0.7699999809265137,
          0.7900000214576721
        ],
        [
          0.7940000295639038,
          0.7419999837875366
        ],
        [
          0.8019999861717224,
          0.7139999866485596
        ],
        [
          0.8019999861717224,
          0.699999988079071
        ],
        [
          0.8059999942779541,
          0.6959999799728394
        ],
        [
          0.8059999942779541,
          0.6639999747276306
        ],
        [
          0.8019999861717224,
          0.6620000004768372
        ],
        [
          0.800000011920929,
          0.6520000100135803
        ],
        [
          0.7940000295639038,
          0.6439999938011169
        ],
        [
          0.7900000214576721,
          0.6439999938011169
        ],
        [
          0.7879999876022339,
          0.6399999856948853
        ],
        [
          0.777999997138977,
          0.6399999856948853
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.777999997138977,
          0.6439999938011169
        ],
        [
          0.7739999890327454,
          0.6499999761581421
        ],
        [
          0.7680000066757202,
          0.6499999761581421
        ],
        [
          0.7620000243186951,
          0.6579999923706055
        ],
        [
          0.7419999837875366,
          0.671999990940094
        ],
        [
          0.7379999756813049,
          0.671999990940094
        ],
        [
          0.7360000014305115,
          0.6759999990463257
        ],
        [
          0.7319999933242798,
          0.6759999990463257
        ],
        [
          0.7300000190734863,
          0.6800000071525574
        ],
        [
          0.7200000286102295,
          0.6819999814033508
        ],
        [
          0.7120000123977661,
          0.6880000233650208
        ],
        [
          0.6740000247955322,
          0.7239999771118164
        ],
        [
          0.656000018119812,
          0.7480000257492065
        ],
        [
          0.6539999842643738,
          0.7580000162124634
        ],
        [
          0.6439999938011169,
          0.7699999809265137
        ],
        [
          0.6439999938011169,
          0.7760000228881836
        ],
        [
          0.6320000290870667,
          0.7919999957084656
        ],
        [
          0.6320000290870667,
          0.7960000038146973
        ],
        [
          0.6019999980926514,
          0.828000009059906
        ],
        [
          0.593999981880188,
          0.8460000157356262
        ],
        [
          0.5759999752044678,
          0.8619999885559082
        ],
        [
          0.5699999928474426,
          0.878000020980835
        ],
        [
          0.5759999752044678,
          0.8899999856948853
        ],
        [
          0.5820000171661377,
          0.8899999856948853
        ],
        [
          0.5899999737739563,
          0.8960000276565552
        ],
        [
          0.6200000047683716,
          0.8960000276565552
        ],
        [
          0.6420000195503235,
          0.8939999938011169
        ],
        [
          0.6439999938011169,
          0.8899999856948853
        ],
        [
          0.6539999842643738,
          0.8899999856948853
        ],
        [
          0.671999990940094,
          0.8840000033378601
        ],
        [
          0.6840000152587891,
          0.8740000128746033
        ],
        [
          0.6940000057220459,
          0.871999979019165
        ],
        [
          0.7120000123977661,
          0.8519999980926514
        ],
        [
          0.7419999837875366,
          0.828000009059906
        ],
        [
          0.7440000176429749,
          0.8199999928474426
        ],
        [
          0.7480000257492065,
          0.8199999928474426
        ],
        [
          0.7599999904632568,
          0.8080000281333923
        ],
        [
          0.777999997138977,
          0.7839999794960022
        ],
        [
          0.7799999713897705,
          0.7739999890327454
        ],
        [
          0.7900000214576721,
          0.7580000162124634
        ],
        [
          0.7919999957084656,
          0.7419999837875366
        ],
        [
          0.7960000038146973,
          0.7400000095367432
        ],
        [
          0.7979999780654907,
          0.7260000109672546
        ],
        [
          0.8019999861717224,
          0.7239999771118164
        ],
        [
          0.8040000200271606,
          0.7039999961853027
        ],
        [
          0.8080000281333923,
          0.7020000219345093
        ],
        [
          0.8080000281333923,
          0.6579999923706055
        ],
        [
          0.8019999861717224,
          0.6499999761581421
        ],
        [
          0.7979999780654907,
          0.6499999761581421
        ],
        [
          0.7960000038146973,
          0.6439999938011169
        ],
        [
          0.777999997138977,
          0.6439999938011169
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7799999713897705,
          0.6499999761581421
        ],
        [
          0.7720000147819519,
          0.6520000100135803
        ],
        [
          0.765999972820282,
          0.6600000262260437
        ],
        [
          0.75,
          0.6679999828338623
        ],
        [
          0.7440000176429749,
          0.6759999990463257
        ],
        [
          0.734000027179718,
          0.6779999732971191
        ],
        [
          0.7319999933242798,
          0.6819999814033508
        ],
        [
          0.7200000286102295,
          0.6840000152587891
        ],
        [
          0.7059999704360962,
          0.6919999718666077
        ],
        [
          0.671999990940094,
          0.7300000190734863
        ],
        [
          0.6600000262260437,
          0.7480000257492065
        ],
        [
          0.6579999923706055,
          0.7620000243186951
        ],
        [
          0.6420000195503235,
          0.7839999794960022
        ],
        [
          0.6399999856948853,
          0.7960000038146973
        ],
        [
          0.6320000290870667,
          0.8019999861717224
        ],
        [
          0.6299999952316284,
          0.8119999766349792
        ],
        [
          0.6019999980926514,
          0.843999981880188
        ],
        [
          0.6019999980926514,
          0.8479999899864197
        ],
        [
          0.5860000252723694,
          0.8700000047683716
        ],
        [
          0.5860000252723694,
          0.8799999952316284
        ],
        [
          0.5899999737739563,
          0.8820000290870667
        ],
        [
          0.5899999737739563,
          0.8859999775886536
        ],
        [
          0.6460000276565552,
          0.8880000114440918
        ],
        [
          0.6759999990463257,
          0.8799999952316284
        ],
        [
          0.7160000205039978,
          0.8539999723434448
        ],
        [
          0.7200000286102295,
          0.8539999723434448
        ],
        [
          0.7620000243186951,
          0.8100000023841858
        ],
        [
          0.7620000243186951,
          0.8059999942779541
        ],
        [
          0.777999997138977,
          0.7860000133514404
        ],
        [
          0.7860000133514404,
          0.7639999985694885
        ],
        [
          0.7900000214576721,
          0.7620000243186951
        ],
        [
          0.7900000214576721,
          0.7540000081062317
        ],
        [
          0.7940000295639038,
          0.7519999742507935
        ],
        [
          0.7960000038146973,
          0.7360000014305115
        ],
        [
          0.800000011920929,
          0.7319999933242798
        ],
        [
          0.8019999861717224,
          0.7160000205039978
        ],
        [
          0.8059999942779541,
          0.7139999866485596
        ],
        [
          0.8080000281333923,
          0.7039999961853027
        ],
        [
          0.8059999942779541,
          0.6620000004768372
        ],
        [
          0.7960000038146973,
          0.6520000100135803
        ],
        [
          0.7799999713897705,
          0.6499999761581421
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7559999823570251,
          0.6539999842643738
        ],
        [
          0.734000027179718,
          0.6639999747276306
        ],
        [
          0.7179999947547913,
          0.6800000071525574
        ],
        [
          0.7160000205039978,
          0.6899999976158142
        ],
        [
          0.7080000042915344,
          0.6919999718666077
        ],
        [
          0.6639999747276306,
          0.7400000095367432
        ],
        [
          0.6499999761581421,
          0.7760000228881836
        ],
        [
          0.6460000276565552,
          0.777999997138977
        ],
        [
          0.6439999938011169,
          0.7979999780654907
        ],
        [
          0.6399999856948853,
          0.800000011920929
        ],
        [
          0.6299999952316284,
          0.8240000009536743
        ],
        [
          0.6140000224113464,
          0.8399999737739563
        ],
        [
          0.6019999980926514,
          0.8619999885559082
        ],
        [
          0.6019999980926514,
          0.8740000128746033
        ],
        [
          0.6119999885559082,
          0.8840000033378601
        ],
        [
          0.6620000004768372,
          0.8840000033378601
        ],
        [
          0.6639999747276306,
          0.8799999952316284
        ],
        [
          0.6779999732971191,
          0.878000020980835
        ],
        [
          0.6859999895095825,
          0.8700000047683716
        ],
        [
          0.699999988079071,
          0.8679999709129333
        ],
        [
          0.7239999771118164,
          0.8479999899864197
        ],
        [
          0.7279999852180481,
          0.8479999899864197
        ],
        [
          0.7459999918937683,
          0.8299999833106995
        ],
        [
          0.7459999918937683,
          0.8259999752044678
        ],
        [
          0.765999972820282,
          0.8080000281333923
        ],
        [
          0.765999972820282,
          0.8040000200271606
        ],
        [
          0.7879999876022339,
          0.7720000147819519
        ],
        [
          0.7960000038146973,
          0.7400000095367432
        ],
        [
          0.8059999942779541,
          0.7239999771118164
        ],
        [
          0.8080000281333923,
          0.7080000042915344
        ],
        [
          0.8119999766349792,
          0.7059999704360962
        ],
        [
          0.8119999766349792,
          0.6700000166893005
        ],
        [
          0.8019999861717224,
          0.6539999842643738
        ],
        [
          0.7559999823570251,
          0.6539999842643738
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7839999794960022,
          0.628000020980835
        ],
        [
          0.777999997138977,
          0.6359999775886536
        ],
        [
          0.7620000243186951,
          0.6380000114440918
        ],
        [
          0.7599999904632568,
          0.6420000195503235
        ],
        [
          0.7540000081062317,
          0.6420000195503235
        ],
        [
          0.75,
          0.6480000019073486
        ],
        [
          0.7440000176429749,
          0.6480000019073486
        ],
        [
          0.722000002861023,
          0.6579999923706055
        ],
        [
          0.7059999704360962,
          0.6759999990463257
        ],
        [
          0.6940000057220459,
          0.699999988079071
        ],
        [
          0.671999990940094,
          0.7179999947547913
        ],
        [
          0.6660000085830688,
          0.7319999933242798
        ],
        [
          0.6620000004768372,
          0.734000027179718
        ],
        [
          0.6600000262260437,
          0.75
        ],
        [
          0.6520000100135803,
          0.7599999904632568
        ],
        [
          0.6499999761581421,
          0.8080000281333923
        ],
        [
          0.6460000276565552,
          0.8119999766349792
        ],
        [
          0.6439999938011169,
          0.8399999737739563
        ],
        [
          0.6399999856948853,
          0.843999981880188
        ],
        [
          0.6399999856948853,
          0.8539999723434448
        ],
        [
          0.6460000276565552,
          0.8600000143051147
        ],
        [
          0.6460000276565552,
          0.8640000224113464
        ],
        [
          0.699999988079071,
          0.8640000224113464
        ],
        [
          0.7020000219345093,
          0.8600000143051147
        ],
        [
          0.7319999933242798,
          0.843999981880188
        ],
        [
          0.7680000066757202,
          0.8059999942779541
        ],
        [
          0.7680000066757202,
          0.8019999861717224
        ],
        [
          0.7760000228881836,
          0.7960000038146973
        ],
        [
          0.7760000228881836,
          0.7919999957084656
        ],
        [
          0.7820000052452087,
          0.7860000133514404
        ],
        [
          0.7839999794960022,
          0.7760000228881836
        ],
        [
          0.7879999876022339,
          0.7739999890327454
        ],
        [
          0.7900000214576721,
          0.7599999904632568
        ],
        [
          0.7940000295639038,
          0.7580000162124634
        ],
        [
          0.800000011920929,
          0.7379999756813049
        ],
        [
          0.8100000023841858,
          0.722000002861023
        ],
        [
          0.8119999766349792,
          0.7059999704360962
        ],
        [
          0.8159999847412109,
          0.7020000219345093
        ],
        [
          0.8159999847412109,
          0.6759999990463257
        ],
        [
          0.8199999928474426,
          0.6740000247955322
        ],
        [
          0.8199999928474426,
          0.6639999747276306
        ],
        [
          0.8159999847412109,
          0.6600000262260437
        ],
        [
          0.8159999847412109,
          0.6480000019073486
        ],
        [
          0.8119999766349792,
          0.6380000114440918
        ],
        [
          0.8059999942779541,
          0.6359999775886536
        ],
        [
          0.8040000200271606,
          0.628000020980835
        ],
        [
          0.7839999794960022,
          0.628000020980835
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.7940000295639038,
          0.6320000290870667
        ],
        [
          0.7820000052452087,
          0.6340000033378601
        ],
        [
          0.7720000147819519,
          0.6520000100135803
        ],
        [
          0.7559999823570251,
          0.6679999828338623
        ],
        [
          0.7160000205039978,
          0.6940000057220459
        ],
        [
          0.6840000152587891,
          0.7260000109672546
        ],
        [
          0.6840000152587891,
          0.7300000190734863
        ],
        [
          0.6740000247955322,
          0.7419999837875366
        ],
        [
          0.6679999828338623,
          0.7680000066757202
        ],
        [
          0.6639999747276306,
          0.7720000147819519
        ],
        [
          0.6620000004768372,
          0.7940000295639038
        ],
        [
          0.6539999842643738,
          0.8080000281333923
        ],
        [
          0.6520000100135803,
          0.8199999928474426
        ],
        [
          0.6480000019073486,
          0.8240000009536743
        ],
        [
          0.6460000276565552,
          0.8339999914169312
        ],
        [
          0.6320000290870667,
          0.8500000238418579
        ],
        [
          0.6299999952316284,
          0.8679999709129333
        ],
        [
          0.6420000195503235,
          0.8859999775886536
        ],
        [
          0.6679999828338623,
          0.8859999775886536
        ],
        [
          0.6700000166893005,
          0.8820000290870667
        ],
        [
          0.6779999732971191,
          0.8820000290870667
        ],
        [
          0.6800000071525574,
          0.878000020980835
        ],
        [
          0.6899999976158142,
          0.8759999871253967
        ],
        [
          0.699999988079071,
          0.8679999709129333
        ],
        [
          0.722000002861023,
          0.8600000143051147
        ],
        [
          0.7720000147819519,
          0.8140000104904175
        ],
        [
          0.7720000147819519,
          0.8100000023841858
        ],
        [
          0.7820000052452087,
          0.800000011920929
        ],
        [
          0.7839999794960022,
          0.7900000214576721
        ],
        [
          0.7919999957084656,
          0.7839999794960022
        ],
        [
          0.7940000295639038,
          0.7739999890327454
        ],
        [
          0.7979999780654907,
          0.7720000147819519
        ],
        [
          0.800000011920929,
          0.7620000243186951
        ],
        [
          0.8140000104904175,
          0.7379999756813049
        ],
        [
          0.8159999847412109,
          0.7260000109672546
        ],
        [
          0.8199999928474426,
          0.722000002861023
        ],
        [
          0.8220000267028809,
          0.699999988079071
        ],
        [
          0.8259999752044678,
          0.6959999799728394
        ],
        [
          0.8259999752044678,
          0.6520000100135803
        ],
        [
          0.8220000267028809,
          0.6439999938011169
        ],
        [
          0.8140000104904175,
          0.6320000290870667
        ],
        [
          0.7940000295639038,
          0.6320000290870667
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.8019999861717224,
          0.6119999885559082
        ],
        [
          0.7919999957084656,
          0.6140000224113464
        ],
        [
          0.7860000133514404,
          0.621999979019165
        ],
        [
          0.777999997138977,
          0.6240000128746033
        ],
        [
          0.7699999809265137,
          0.6320000290870667
        ],
        [
          0.7540000081062317,
          0.6340000033378601
        ],
        [
          0.7519999742507935,
          0.6380000114440918
        ],
        [
          0.7459999918937683,
          0.6380000114440918
        ],
        [
          0.7419999837875366,
          0.6439999938011169
        ],
        [
          0.7319999933242798,
          0.6480000019073486
        ],
        [
          0.7300000190734863,
          0.6539999842643738
        ],
        [
          0.7160000205039978,
          0.6679999828338623
        ],
        [
          0.7039999961853027,
          0.6980000138282776
        ],
        [
          0.699999988079071,
          0.699999988079071
        ],
        [
          0.699999988079071,
          0.7039999961853027
        ],
        [
          0.6740000247955322,
          0.7440000176429749
        ],
        [
          0.671999990940094,
          0.765999972820282
        ],
        [
          0.6679999828338623,
          0.7699999809265137
        ],
        [
          0.6660000085830688,
          0.8119999766349792
        ],
        [
          0.6499999761581421,
          0.8460000157356262
        ],
        [
          0.6499999761581421,
          0.8619999885559082
        ],
        [
          0.6579999923706055,
          0.8759999871253967
        ],
        [
          0.6660000085830688,
          0.878000020980835
        ],
        [
          0.6840000152587891,
          0.8759999871253967
        ],
        [
          0.6880000233650208,
          0.871999979019165
        ],
        [
          0.699999988079071,
          0.8700000047683716
        ],
        [
          0.7099999785423279,
          0.8619999885559082
        ],
        [
          0.7200000286102295,
          0.8600000143051147
        ],
        [
          0.722000002861023,
          0.8560000061988831
        ],
        [
          0.7319999933242798,
          0.8519999980926514
        ],
        [
          0.7519999742507935,
          0.8320000171661377
        ],
        [
          0.7580000162124634,
          0.8299999833106995
        ],
        [
          0.7580000162124634,
          0.8259999752044678
        ],
        [
          0.7839999794960022,
          0.7960000038146973
        ],
        [
          0.7919999957084656,
          0.7739999890327454
        ],
        [
          0.800000011920929,
          0.765999972820282
        ],
        [
          0.8019999861717224,
          0.7559999823570251
        ],
        [
          0.8159999847412109,
          0.7379999756813049
        ],
        [
          0.8180000185966492,
          0.7239999771118164
        ],
        [
          0.8220000267028809,
          0.7200000286102295
        ],
        [
          0.8240000009536743,
          0.699999988079071
        ],
        [
          0.828000009059906,
          0.6980000138282776
        ],
        [
          0.828000009059906,
          0.6740000247955322
        ],
        [
          0.8320000171661377,
          0.671999990940094
        ],
        [
          0.8320000171661377,
          0.6380000114440918
        ],
        [
          0.8240000009536743,
          0.6240000128746033
        ],
        [
          0.8119999766349792,
          0.6119999885559082
        ],
        [
          0.8019999861717224,
          0.6119999885559082
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.8100000023841858,
          0.5960000157356262
        ],
        [
          0.7799999713897705,
          0.6200000047683716
        ],
        [
          0.7699999809265137,
          0.621999979019165
        ],
        [
          0.7639999985694885,
          0.6299999952316284
        ],
        [
          0.75,
          0.6320000290870667
        ],
        [
          0.7480000257492065,
          0.6359999775886536
        ],
        [
          0.7379999756813049,
          0.6359999775886536
        ],
        [
          0.7319999933242798,
          0.6399999856948853
        ],
        [
          0.722000002861023,
          0.6520000100135803
        ],
        [
          0.7160000205039978,
          0.6660000085830688
        ],
        [
          0.7080000042915344,
          0.671999990940094
        ],
        [
          0.7059999704360962,
          0.6859999895095825
        ],
        [
          0.7020000219345093,
          0.6880000233650208
        ],
        [
          0.6980000138282776,
          0.7020000219345093
        ],
        [
          0.6919999718666077,
          0.7080000042915344
        ],
        [
          0.6899999976158142,
          0.722000002861023
        ],
        [
          0.6819999814033508,
          0.7319999933242798
        ],
        [
          0.6800000071525574,
          0.7519999742507935
        ],
        [
          0.6759999990463257,
          0.7559999823570251
        ],
        [
          0.6740000247955322,
          0.8220000267028809
        ],
        [
          0.6700000166893005,
          0.8240000009536743
        ],
        [
          0.6700000166893005,
          0.8339999914169312
        ],
        [
          0.6660000085830688,
          0.8379999995231628
        ],
        [
          0.6660000085830688,
          0.8479999899864197
        ],
        [
          0.6740000247955322,
          0.8619999885559082
        ],
        [
          0.7179999947547913,
          0.8619999885559082
        ],
        [
          0.7319999933242798,
          0.8539999723434448
        ],
        [
          0.7839999794960022,
          0.8019999861717224
        ],
        [
          0.7919999957084656,
          0.7820000052452087
        ],
        [
          0.800000011920929,
          0.7739999890327454
        ],
        [
          0.8019999861717224,
          0.7620000243186951
        ],
        [
          0.8100000023841858,
          0.7559999823570251
        ],
        [
          0.8119999766349792,
          0.7459999918937683
        ],
        [
          0.8259999752044678,
          0.7279999852180481
        ],
        [
          0.828000009059906,
          0.7160000205039978
        ],
        [
          0.8360000252723694,
          0.7020000219345093
        ],
        [
          0.8379999995231628,
          0.6700000166893005
        ],
        [
          0.8420000076293945,
          0.6660000085830688
        ],
        [
          0.8420000076293945,
          0.6299999952316284
        ],
        [
          0.8379999995231628,
          0.6259999871253967
        ],
        [
          0.8360000252723694,
          0.6119999885559082
        ],
        [
          0.8220000267028809,
          0.5960000157356262
        ],
        [
          0.8100000023841858,
          0.5960000157356262
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.8159999847412109,
          0.6019999980926514
        ],
        [
          0.8059999942779541,
          0.6039999723434448
        ],
        [
          0.7900000214576721,
          0.6140000224113464
        ],
        [
          0.7799999713897705,
          0.6259999871253967
        ],
        [
          0.7639999985694885,
          0.6320000290870667
        ],
        [
          0.7540000081062317,
          0.6460000276565552
        ],
        [
          0.7480000257492065,
          0.6460000276565552
        ],
        [
          0.7279999852180481,
          0.656000018119812
        ],
        [
          0.7080000042915344,
          0.6800000071525574
        ],
        [
          0.7020000219345093,
          0.6980000138282776
        ],
        [
          0.6919999718666077,
          0.7120000123977661
        ],
        [
          0.6899999976158142,
          0.7260000109672546
        ],
        [
          0.6859999895095825,
          0.7279999852180481
        ],
        [
          0.6800000071525574,
          0.7519999742507935
        ],
        [
          0.6800000071525574,
          0.8360000252723694
        ],
        [
          0.7020000219345093,
          0.8539999723434448
        ],
        [
          0.722000002861023,
          0.8539999723434448
        ],
        [
          0.7239999771118164,
          0.8500000238418579
        ],
        [
          0.7319999933242798,
          0.8500000238418579
        ],
        [
          0.734000027179718,
          0.8460000157356262
        ],
        [
          0.7540000081062317,
          0.8360000252723694
        ],
        [
          0.7860000133514404,
          0.8019999861717224
        ],
        [
          0.7919999957084656,
          0.7879999876022339
        ],
        [
          0.800000011920929,
          0.7799999713897705
        ],
        [
          0.8259999752044678,
          0.7360000014305115
        ],
        [
          0.8320000171661377,
          0.7160000205039978
        ],
        [
          0.8360000252723694,
          0.7120000123977661
        ],
        [
          0.8379999995231628,
          0.6940000057220459
        ],
        [
          0.8420000076293945,
          0.6899999976158142
        ],
        [
          0.8420000076293945,
          0.6179999709129333
        ],
        [
          0.828000009059906,
          0.6039999723434448
        ],
        [
          0.8159999847412109,
          0.6019999980926514
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.8059999942779541,
          0.5960000157356262
        ],
        [
          0.7620000243186951,
          0.6340000033378601
        ],
        [
          0.7559999823570251,
          0.6380000114440918
        ],
        [
          0.7400000095367432,
          0.6399999856948853
        ],
        [
          0.7360000014305115,
          0.6480000019073486
        ],
        [
          0.722000002861023,
          0.6539999842643738
        ],
        [
          0.7020000219345093,
          0.6740000247955322
        ],
        [
          0.6959999799728394,
          0.6880000233650208
        ],
        [
          0.6899999976158142,
          0.6940000057220459
        ],
        [
          0.6800000071525574,
          0.7179999947547913
        ],
        [
          0.6800000071525574,
          0.7260000109672546
        ],
        [
          0.6759999990463257,
          0.7279999852180481
        ],
        [
          0.6700000166893005,
          0.765999972820282
        ],
        [
          0.6660000085830688,
          0.7699999809265137
        ],
        [
          0.671999990940094,
          0.800000011920929
        ],
        [
          0.6859999895095825,
          0.8159999847412109
        ],
        [
          0.7360000014305115,
          0.8140000104904175
        ],
        [
          0.7459999918937683,
          0.8199999928474426
        ],
        [
          0.7559999823570251,
          0.8199999928474426
        ],
        [
          0.7720000147819519,
          0.8100000023841858
        ],
        [
          0.7720000147819519,
          0.8059999942779541
        ],
        [
          0.7820000052452087,
          0.800000011920929
        ],
        [
          0.7820000052452087,
          0.7960000038146973
        ],
        [
          0.800000011920929,
          0.7760000228881836
        ],
        [
          0.8019999861717224,
          0.765999972820282
        ],
        [
          0.8100000023841858,
          0.7559999823570251
        ],
        [
          0.8119999766349792,
          0.7419999837875366
        ],
        [
          0.8259999752044678,
          0.722000002861023
        ],
        [
          0.8259999752044678,
          0.7179999947547913
        ],
        [
          0.8299999833106995,
          0.7160000205039978
        ],
        [
          0.8299999833106995,
          0.7080000042915344
        ],
        [
          0.8399999737739563,
          0.6880000233650208
        ],
        [
          0.8420000076293945,
          0.6740000247955322
        ],
        [
          0.8399999737739563,
          0.6159999966621399
        ],
        [
          0.8360000252723694,
          0.6140000224113464
        ],
        [
          0.8299999833106995,
          0.6000000238418579
        ],
        [
          0.8220000267028809,
          0.5960000157356262
        ],
        [
          0.8059999942779541,
          0.5960000157356262
        ]
      ]
    ]
  },
  {
    "icm": [
      [
        [
          0.8080000281333923,
          0.5879999995231628
        ],
        [
          0.7699999809265137,
          0.6259999871253967
        ],
        [
          0.7480000257492065,
          0.6380000114440918
        ],
        [
          0.7400000095367432,
          0.6480000019073486
        ],
        [
          0.7179999947547913,
          0.6660000085830688
        ],
        [
          0.7139999866485596,
          0.6660000085830688
        ],
        [
          0.6919999718666077,
          0.6880000233650208
        ],
        [
          0.6859999895095825,
          0.7059999704360962
        ],
        [
          0.6819999814033508,
          0.7080000042915344
        ],
        [
          0.6800000071525574,
          0.7459999918937683
        ],
        [
          0.6759999990463257,
          0.75
        ],
        [
          0.6759999990463257,
          0.7620000243186951
        ],
        [
          0.6800000071525574,
          0.765999972820282
        ],
        [
          0.6819999814033508,
          0.8019999861717224
        ],
        [
          0.6859999895095825,
          0.8059999942779541
        ],
        [
          0.6859999895095825,
          0.8119999766349792
        ],
        [
          0.6919999718666077,
          0.8159999847412109
        ],
        [
          0.7020000219345093,
          0.8159999847412109
        ],
        [
          0.7039999961853027,
          0.8119999766349792
        ],
        [
          0.7279999852180481,
          0.8119999766349792
        ],
        [
          0.7440000176429749,
          0.8259999752044678
        ],
        [
          0.7559999823570251,
          0.8220000267028809
        ],
        [
          0.765999972820282,
          0.8119999766349792
        ],
        [
          0.7699999809265137,
          0.8119999766349792
        ],
        [
          0.7760000228881836,
          0.8059999942779541
        ],
        [
          0.7760000228881836,
          0.8019999861717224
        ],
        [
          0.7900000214576721,
          0.7900000214576721
        ],
        [
          0.8059999942779541,
          0.7620000243186951
        ],
        [
          0.8080000281333923,
          0.7519999742507935
        ],
        [
          0.8119999766349792,
          0.75
        ],
        [
          0.828000009059906,
          0.7179999947547913
        ],
        [
          0.8320000171661377,
          0.7160000205039978
        ],
        [
          0.8339999914169312,
          0.7020000219345093
        ],
        [
          0.8379999995231628,
          0.6980000138282776
        ],
        [
          0.8379999995231628,
          0.6880000233650208
        ],
        [
          0.8420000076293945,
          0.6859999895095825
        ],
        [
          0.843999981880188,
          0.6660000085830688
        ],
        [
          0.8420000076293945,
          0.6060000061988831
        ],
        [
          0.8379999995231628,
          0.5960000157356262
        ],
        [
          0.828000009059906,
          0.5879999995231628
        ],
        [
          0.8080000281333923,
          0.5879999995231628
        ]
      ]
    ]
  },
  {},
  {},
  {},
  {}
]
